export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  DateTime: string
  Upload: any
}

export type AccessGroup = {
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  entityId: Scalars['ID']
  entityType: AccessGroupEntityType
  id: Scalars['ID']
  info?: Maybe<Scalars['String']>
  name: Scalars['String']
  networkId: Scalars['ID']
  type: Scalars['String']
}

export enum AccessGroupEntityType {
  network = 'network',
  post = 'post',
  space = 'space',
}

export type Action = {
  status: ActionStatus
}

export type ActionPermissions = {
  inputPermissions: Array<InputPathPermissions>
  isAuthorized: IsAuthorized
  name: Scalars['String']
  outputPermissions: Array<PathPermissions>
}

export enum ActionStatus {
  failed = 'failed',
  succeeded = 'succeeded',
}

export type ActiveSso = {
  logoutUrl?: Maybe<Scalars['String']>
  settingsUrl?: Maybe<Scalars['String']>
}

export type AddAppCollaboratorInput = {
  email: Scalars['String']
}

export type AddMediasInput = {
  contentTypes: Array<Scalars['String']>
}

export type AddNetworkInput = {
  description?: InputMaybe<Scalars['String']>
  domain?: InputMaybe<Scalars['String']>
  entrancePage?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['String']>
  industry?: InputMaybe<NetworkIndustryType>
  name: Scalars['String']
  owner: JoinNetworkInput
  primaryMembers?: InputMaybe<NetworkPrimaryMembersType>
  promoCode?: InputMaybe<Scalars['String']>
  referrer?: InputMaybe<Scalars['String']>
  timeframe?: InputMaybe<NetworkTimeframeType>
  utmCampaign?: InputMaybe<Scalars['String']>
  utmContent?: InputMaybe<Scalars['String']>
  utmMedium?: InputMaybe<Scalars['String']>
  utmSource?: InputMaybe<Scalars['String']>
  utmTerm?: InputMaybe<Scalars['String']>
  visibility?: NetworkVisibility
}

export type AddReactionInput = {
  overrideSingleChoiceReactions?: InputMaybe<Scalars['Boolean']>
  participantId?: InputMaybe<Scalars['ID']>
  reaction: Scalars['String']
}

export type AddSpaceMemberInput = {
  memberId: Scalars['ID']
  roleId?: InputMaybe<Scalars['ID']>
}

export type AddTrialInput = {
  endDate: Scalars['DateTime']
}

export type AddonInformation = {
  priceId: Scalars['String']
  productId: Scalars['String']
  quantity: Scalars['Float']
}

export type AnalyticsLimits = {
  planLimits: Array<AnalyticsPlanLimits>
}

export type AnalyticsPlanLimits = {
  daysLimitation?: Maybe<Scalars['Float']>
  plan: PlanName
}

export type AnalyticsQueryTimeframe = {
  from: Scalars['Float']
  to: Scalars['Float']
}

export type AnalyticsResponse = {
  maxCacheTime: Scalars['Float']
  query: Scalars['String']
  records: Array<ReportRecord>
  timeframe: AnalyticsQueryTimeframe
}

export type ApiRequestLimit = {
  consumableType: Scalars['String']
  duration: Scalars['Float']
  limit: Scalars['Float']
}

export enum ApiRequestLimitType {
  Complexity = 'Complexity',
  Request = 'Request',
}

export type ApiUsage = {
  consumableType: ApiRequestLimitType
  consumedPoints: Scalars['Float']
  duration: Scalars['Float']
  limit: Scalars['Float']
  remainingPoints: Scalars['Float']
  resetsAt: Scalars['DateTime']
}

export type App = {
  about?: Maybe<Scalars['String']>
  authMemberInstallation?: Maybe<AppInstallation>
  authorName?: Maybe<Scalars['String']>
  authorUrl?: Maybe<Scalars['String']>
  banner?: Maybe<Media>
  bannerId?: Maybe<Scalars['ID']>
  clientId?: Maybe<Scalars['String']>
  clientSecret?: Maybe<Scalars['String']>
  comingSoon: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<Member>
  createdById?: Maybe<Scalars['ID']>
  customCodes?: Maybe<AppCustomCodes>
  description?: Maybe<Scalars['String']>
  docsUrl?: Maybe<Scalars['String']>
  dynamicBlocks?: Maybe<Array<DynamicBlock>>
  embedIds: Array<Scalars['ID']>
  embeds?: Maybe<Array<Embed>>
  /** @deprecated Apps will be only installed on the network level */
  enabledContexts?: Maybe<Array<PermissionContext>>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  federatedSearchEnabled: Scalars['Boolean']
  globalBanner?: Maybe<Media>
  globalEmbeds?: Maybe<Array<Embed>>
  globalFavicon?: Maybe<Media>
  globalImage?: Maybe<Media>
  globalImages?: Maybe<Array<Media>>
  /** @deprecated Use the global gateway instead */
  globalNetwork?: Maybe<PluralNetwork>
  id: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  imageIds: Array<Scalars['ID']>
  images?: Maybe<Array<Media>>
  installed?: Maybe<Scalars['Boolean']>
  locked: Scalars['Boolean']
  name: Scalars['String']
  network?: Maybe<Network>
  networkId: Scalars['ID']
  privacyPolicyUrl?: Maybe<Scalars['String']>
  privatelyPublished?: Maybe<Scalars['Boolean']>
  requiredPermissions: Array<PrimaryScopes>
  requiredPlan?: Maybe<PlanName>
  secretToken?: Maybe<Scalars['String']>
  settingsBlock?: Maybe<DynamicBlock>
  slug: Scalars['String']
  standing: StoreItemStanding
  status: StoreItemStatus
  termsOfServiceUrl?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  updatedBy?: Maybe<Member>
  updatedById?: Maybe<Scalars['ID']>
  webhookSignSecret?: Maybe<Scalars['String']>
  webhookSubscriptions?: Maybe<Array<Scalars['String']>>
  webhookUrl?: Maybe<Scalars['String']>
}

export type AppAction = {
  data?: Maybe<Scalars['String']>
  status: ActionStatus
}

export type AppCollaborator = {
  addedById?: Maybe<Scalars['ID']>
  /** @deprecated Use the global gateway instead */
  app?: Maybe<App>
  appId: Scalars['ID']
  createdAt: Scalars['DateTime']
  email: Scalars['String']
  id: Scalars['ID']
  type: AppCollaboratorType
}

export enum AppCollaboratorType {
  COLLABORATOR = 'COLLABORATOR',
  OWNER = 'OWNER',
}

export type AppCustomCodes = {
  body?: Maybe<Scalars['String']>
  head?: Maybe<Scalars['String']>
}

export type AppEdge = {
  cursor: Scalars['String']
  node: App
}

export type AppInstallation = {
  app?: Maybe<App>
  appVersion?: Maybe<Scalars['String']>
  /** @deprecated Apps will be only installed on the network level */
  context?: Maybe<PermissionContext>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  installedAt: Scalars['DateTime']
  installedBy?: Maybe<Member>
  network?: Maybe<Network>
  permissions: Array<Scalars['String']>
  status: AppInstallationStatus
  templatesMappings?: Maybe<AppInstallationTemplatesMappings>
  updatedAt: Scalars['DateTime']
}

export type AppInstallationEdge = {
  cursor: Scalars['String']
  node: AppInstallation
}

export enum AppInstallationStatus {
  DELETED = 'DELETED',
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export type AppInstallationTemplatesMappings = {
  member?: Maybe<Array<TemplatesMapping>>
  postTypes?: Maybe<Array<TemplatesMapping>>
}

export type AppInstallationTemplatesMappingsInput = {
  memberTypes?: InputMaybe<Array<TemplatesMappingInput>>
  postTypes?: InputMaybe<Array<TemplatesMappingInput>>
}

export type AppInteraction = {
  appId: Scalars['String']
  interactionId: Scalars['String']
  props?: Maybe<Scalars['String']>
  slate?: Maybe<Slate>
  type: AppInteractionType
}

export enum AppInteractionType {
  Close = 'Close',
  Data = 'Data',
  OpenModal = 'OpenModal',
  OpenToast = 'OpenToast',
  Redirect = 'Redirect',
  Reload = 'Reload',
  Show = 'Show',
}

export type AppPublication = {
  addedById?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  itemId: Scalars['String']
  networkId: Scalars['String']
}

export type AppSetting = {
  appId: Scalars['String']
  context: PermissionContext
  entityId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  networkId: Scalars['String']
  settings: Scalars['String']
}

export type AppToken = {
  accessToken: Scalars['String']
  gatewayUrl?: Maybe<Scalars['String']>
}

export type AssignOrRevokeBadgeInput = {
  memberId: Scalars['String']
}

export enum AssistantLevel {
  AMATEUR = 'AMATEUR',
  EXPERT = 'EXPERT',
  PRO = 'PRO',
}

export type AuthInfoWithOtp = {
  member: Member
  network: Network
  otp: Scalars['String']
  role?: Maybe<Role>
}

export type AuthToken = {
  accessToken: Scalars['String']
  member: Member
  network?: Maybe<Network>
  networkPublicInfo: NetworkPublicInfo
  refreshToken: Scalars['String']
  role: Role
}

export type AuthTokenWithOtp = {
  accessToken: Scalars['String']
  member: Member
  network?: Maybe<Network>
  networkPublicInfo: NetworkPublicInfo
  otp: Scalars['String']
  refreshToken: Scalars['String']
  role: Role
}

export type Badge = {
  active: Scalars['Boolean']
  backgroundColor?: Maybe<Scalars['String']>
  daysUntilExpired?: Maybe<Scalars['Float']>
  id: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  longDescription?: Maybe<Scalars['String']>
  name: Scalars['String']
  networkId: Scalars['ID']
  settings?: Maybe<Array<BadgeSettings>>
  shortDescription: Scalars['String']
  text?: Maybe<Scalars['String']>
  textColor?: Maybe<Scalars['String']>
  type: BadgeType
}

export type BadgeSettings = {
  key: Scalars['String']
  value: Scalars['String']
}

export type BadgeSettingsInput = {
  key: Scalars['String']
  value: Scalars['String']
}

export enum BadgeType {
  Manual = 'Manual',
  NewMember = 'NewMember',
  Role = 'Role',
  SuspendedMember = 'SuspendedMember',
}

export type BaseCustomFieldSchema = {
  archived?: Maybe<Scalars['Boolean']>
  description?: Maybe<Scalars['String']>
  externalKeys?: Maybe<Array<Scalars['String']>>
  items?: Maybe<BaseCustomFieldSchema>
  key: Scalars['String']
  name: Scalars['String']
  properties?: Maybe<Array<BaseCustomFieldSchema>>
  required?: Maybe<Scalars['Boolean']>
  type: CustomFieldType
  typeOptions?: Maybe<CustomFieldTypeOptions>
  validators?: Maybe<Array<CustomFieldValidator>>
}

export type BaseCustomFieldSchemaInput = {
  archived?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  externalKeys?: InputMaybe<Array<Scalars['String']>>
  items?: InputMaybe<BaseCustomFieldSchemaInput>
  key: Scalars['String']
  name: Scalars['String']
  properties?: InputMaybe<Array<BaseCustomFieldSchemaInput>>
  required?: InputMaybe<Scalars['Boolean']>
  type: CustomFieldType
  typeOptions?: InputMaybe<CustomFieldTypeOptionsInput>
  validators?: InputMaybe<Array<CustomFieldValidatorInput>>
}

export type BaseFilterInput = {
  and?: InputMaybe<Array<BaseFilterInput>>
  filtername: Filtername
  key?: InputMaybe<Scalars['String']>
  negator?: InputMaybe<Scalars['String']>
  operator?: InputMaybe<Scalars['String']>
  or?: InputMaybe<Array<BaseFilterInput>>
  value?: InputMaybe<Scalars['String']>
}

export type Basket = {
  items?: Maybe<Array<BasketItem>>
  promoErrorMessage?: Maybe<Scalars['String']>
  renewalType: PlanRenewalType
  total?: Maybe<Price>
}

export type BasketItem = {
  note?: Maybe<Scalars['String']>
  promoCodeItem?: Maybe<Scalars['Boolean']>
  title: Scalars['String']
  value: Price
}

export type BasketsInput = {
  name: PlanName
  promotionCode?: InputMaybe<Scalars['String']>
  seats: Scalars['Int']
}

export type BillingAddress = {
  city?: Maybe<Scalars['String']>
  country: Scalars['String']
  postalCode?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  streetAddress?: Maybe<Scalars['String']>
}

export type BillingAddressInput = {
  city?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  postalCode?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  streetAddress?: InputMaybe<Scalars['String']>
}

export type BillingDetails = {
  address?: Maybe<BillingAddress>
  billingEmail?: Maybe<Scalars['String']>
  card?: Maybe<CardPublicInformation>
  companyName?: Maybe<Scalars['String']>
  vat?: Maybe<Vat>
}

export type BillingDetailsInput = {
  address?: InputMaybe<BillingAddressInput>
  billingEmail?: InputMaybe<Scalars['String']>
  card?: InputMaybe<CardInput>
  companyName?: InputMaybe<Scalars['String']>
  vat?: InputMaybe<VatInput>
}

export type BillingPortalSession = {
  url: Scalars['String']
}

export type BillingPrice = {
  amount: Scalars['Float']
  default: Scalars['Boolean']
  id: Scalars['String']
  interval: BillingPriceInterval
}

export enum BillingPriceInterval {
  Month = 'Month',
  Year = 'Year',
}

export type BillingProduct = {
  app?: Maybe<App>
  appId?: Maybe<Scalars['String']>
  categories: Array<Scalars['String']>
  description?: Maybe<Scalars['String']>
  downgradable: Scalars['Boolean']
  features: Array<Scalars['String']>
  hubContent?: Maybe<HubContent>
  hubContentId?: Maybe<Scalars['String']>
  id: Scalars['String']
  imageUrls: Array<Scalars['String']>
  isEnterprise: Scalars['Boolean']
  name: Scalars['String']
  order?: Maybe<Scalars['Float']>
  popular: Scalars['Boolean']
  prices: Array<BillingPrice>
  public: Scalars['Boolean']
  purchasable: Scalars['Boolean']
  purchaseLimit?: Maybe<Scalars['Float']>
  requiredPlanOrder?: Maybe<Scalars['Float']>
}

export type BillingProducts = {
  addons: Array<BillingProduct>
  plans: Array<BillingProduct>
}

export type BillingSubscription = {
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  status: SubscriptionStatus
  updatedAt: Scalars['DateTime']
}

export type Block = {
  children?: Maybe<Scalars['String']>
  extraProps?: Maybe<Scalars['String']>
  id: Scalars['String']
  name: Scalars['String']
  output?: Maybe<Scalars['String']>
  props?: Maybe<Scalars['String']>
}

export type BlockInput = {
  children?: InputMaybe<Scalars['String']>
  extraProps?: InputMaybe<Scalars['String']>
  id: Scalars['String']
  name: Scalars['String']
  output?: InputMaybe<Scalars['String']>
  props?: InputMaybe<Scalars['String']>
}

export type By = Member

export enum CallbackAction {
  Insert = 'Insert',
  Modal = 'Modal',
  None = 'None',
  Replace = 'Replace',
}

export type CallbackResponse = {
  action: CallbackAction
  slate?: Maybe<Slate>
  toast?: Maybe<Toast>
}

export type CaptchaSettings = {
  enabled: Scalars['Boolean']
  secretKey?: Maybe<Scalars['String']>
  siteKey?: Maybe<Scalars['String']>
}

export type CaptchaSettingsInput = {
  enabled: Scalars['Boolean']
  secretKey?: InputMaybe<Scalars['String']>
  siteKey?: InputMaybe<Scalars['String']>
}

export type CardInput = {
  cardNumber: Scalars['String']
  cvc: Scalars['String']
  expirationMonth: Scalars['Float']
  expirationYear: Scalars['Float']
  nameOnCard?: InputMaybe<Scalars['String']>
}

export type CardPublicInformation = {
  expirationMonth: Scalars['Float']
  expirationYear: Scalars['Float']
  lastFourDigits: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type ChartData = {
  label: Scalars['String']
  points: Scalars['String']
  value?: Maybe<Scalars['String']>
}

export type Collection = {
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<Member>
  customOrderingIndex: Scalars['Float']
  description?: Maybe<Scalars['String']>
  externalId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  name: Scalars['String']
  network?: Maybe<Network>
  relativeUrl?: Maybe<Scalars['String']>
  slug: Scalars['String']
  spaces?: Maybe<PaginatedSpace>
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
}

export type CollectionSpacesArgs = {
  exploreOnly?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
  memberId?: InputMaybe<Scalars['ID']>
}

export type CollectionEdge = {
  cursor: Scalars['String']
  node: Collection
}

export enum CollectionListOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  CUSTOM_ORDERING_INDEX = 'CUSTOM_ORDERING_INDEX',
  UPDATED_AT = 'UPDATED_AT',
}

export type ColumnSortInput = {
  key: Scalars['String']
  order?: InputMaybe<SortOrder>
}

export type ConfirmResetPasswordInput = {
  token: Scalars['String']
}

export type ContentTranslationSettings = {
  enabled: Scalars['Boolean']
}

export type ContentTranslationSettingsInput = {
  enabled: Scalars['Boolean']
}

export type ContentTypeTemplate = {
  allowedReactions?: Maybe<Array<Scalars['String']>>
  context: PostTypeContext
  forbiddenReactions?: Maybe<Array<Scalars['String']>>
  languageTemplate?: Maybe<Scalars['String']>
  name: Scalars['String']
  pluralName: Scalars['String']
  postFields?: Maybe<CustomFieldsSchema>
  /** @deprecated Use allowedReactions instead. */
  primaryReactionType?: Maybe<ReactionType>
  selfRepliable?: Maybe<Scalars['Boolean']>
  shortContentTemplate?: Maybe<Scalars['String']>
  singleChoiceReactions?: Maybe<Array<Scalars['String']>>
  slate?: Maybe<Slate>
  slug: Scalars['String']
  titleTemplate?: Maybe<Scalars['String']>
  validReplyTypesIds?: Maybe<Array<Scalars['String']>>
}

export type ContextPermissions = {
  context: PermissionContext
  entityActions: Array<EntityPermissions>
}

export type ContextScopes = {
  context: PermissionContext
  entityScopes: Array<EntityScopes>
}

export type ConvertPostInput = {
  byPassFieldPermissions?: InputMaybe<Scalars['Boolean']>
  fallbackField?: InputMaybe<Scalars['String']>
  targetPostTypeId: Scalars['ID']
}

export type CreateAccessGroupInput = {
  description?: InputMaybe<Scalars['String']>
  entityId: Scalars['ID']
  entityType: AccessGroupEntityType
  info?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  type: Scalars['String']
}

export type CreateAppInput = {
  about?: InputMaybe<Scalars['String']>
  authorName?: InputMaybe<Scalars['String']>
  authorUrl?: InputMaybe<Scalars['String']>
  bannerId?: InputMaybe<Scalars['String']>
  comingSoon?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  networkId: Scalars['String']
  privacyPolicyUrl?: InputMaybe<Scalars['String']>
  requiredPlan?: InputMaybe<PlanName>
  slug?: InputMaybe<Scalars['String']>
  termsOfServiceUrl?: InputMaybe<Scalars['String']>
}

export type CreateBadgeInput = {
  active: Scalars['Boolean']
  backgroundColor?: InputMaybe<Scalars['String']>
  daysUntilExpired?: InputMaybe<Scalars['Float']>
  imageId?: InputMaybe<Scalars['String']>
  longDescription?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  settings?: InputMaybe<Array<BadgeSettingsInput>>
  shortDescription: Scalars['String']
  text?: InputMaybe<Scalars['String']>
  textColor?: InputMaybe<Scalars['String']>
}

export type CreateCollectionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>
  description?: InputMaybe<Scalars['String']>
  externalId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  updatedAt?: InputMaybe<Scalars['DateTime']>
}

export type CreateEmojiInput = {
  text: Scalars['String']
}

export type CreateFileInput = {
  contentType: Scalars['String']
  extension: Scalars['String']
  name?: InputMaybe<Scalars['String']>
  size?: InputMaybe<Scalars['Int']>
}

export type CreateHighlightedTag = {
  /** ID of an existing tag. This field will become required in an upcoming release. */
  tagId: Scalars['String']
}

export type CreateImageInput = {
  contentType: Scalars['String']
  cropHeight?: InputMaybe<Scalars['Int']>
  cropWidth?: InputMaybe<Scalars['Int']>
  cropX?: InputMaybe<Scalars['Int']>
  cropY?: InputMaybe<Scalars['Int']>
  cropZoom?: InputMaybe<Scalars['Float']>
  height?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  width?: InputMaybe<Scalars['Int']>
}

export type CreateLimitedSupportTokenInput = {
  networkId: Scalars['String']
}

export type CreatePermissionInput = {
  description?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  scopes: Array<Scalars['String']>
}

/** Input for creating a post */
export type CreatePostInput = {
  /** The id of all the attachments to this post. */
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  createdAt?: InputMaybe<Scalars['DateTime']>
  /** The custom seo detail of this post */
  customSeoDetail?: InputMaybe<CustomSeoDetailInput>
  externalId?: InputMaybe<Scalars['String']>
  key?: InputMaybe<Scalars['String']>
  /** Whether the post is locked */
  locked?: InputMaybe<Scalars['Boolean']>
  /** The fields of the post. Depending of the post type it may include title, text, image, etc. */
  mappingFields: Array<PostMappingFieldInput>
  ownerId?: InputMaybe<Scalars['ID']>
  /** The id of this post's type */
  postTypeId: Scalars['String']
  /** Whether the post is published */
  publish?: Scalars['Boolean']
  publishedAt?: InputMaybe<Scalars['DateTime']>
  /** The slug of the post creating the human readable part of its URL */
  slug?: InputMaybe<Scalars['String']>
  /** The TagIds for this post. Can be used in conjunction with tagNames. */
  tagIds?: InputMaybe<Array<Scalars['String']>>
  /** The tags of this post. Can be used in conjunction with tagIds. */
  tagNames?: InputMaybe<Array<Scalars['String']>>
  updatedAt?: InputMaybe<Scalars['DateTime']>
}

export type CreatePostTypeInput = {
  allowedReactions?: InputMaybe<Array<Scalars['String']>>
  context: PostTypeContext
  customReactions?: InputMaybe<Array<CustomReactionInput>>
  description?: InputMaybe<Scalars['String']>
  excludedNativeShortcuts?: InputMaybe<Array<Scalars['String']>>
  forbiddenReactions?: InputMaybe<Array<Scalars['String']>>
  iconId?: InputMaybe<Scalars['ID']>
  languageTemplate?: InputMaybe<Scalars['String']>
  layout?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  nativeFieldsTemplates?: InputMaybe<NativeFieldsTemplatesInput>
  pluralName: Scalars['String']
  postFields?: InputMaybe<CustomFieldsSchemaInput>
  primaryReactionType?: InputMaybe<ReactionType>
  recommendationsSettings?: InputMaybe<PostTypeRecommendationSettingsInput>
  selfRepliable?: InputMaybe<Scalars['Boolean']>
  shortContentTemplate?: InputMaybe<Scalars['String']>
  singleChoiceReactions?: InputMaybe<Array<Scalars['String']>>
  slate?: InputMaybe<SlateInput>
  titleTemplate?: InputMaybe<Scalars['String']>
  validReplyTypesIds?: InputMaybe<Array<Scalars['String']>>
}

export type CreateReportInput = {
  description?: InputMaybe<Scalars['String']>
  entityId: Scalars['String']
  entityType: ModerationEntityType
  reportCategory: ReportCategory
  spaceId?: InputMaybe<Scalars['String']>
}

/** Input for creating a space. */
export type CreateSpaceInput = {
  address?: InputMaybe<SpaceAddressInput>
  adminIds?: InputMaybe<Array<Scalars['String']>>
  /** The id of the space banner. */
  bannerId?: InputMaybe<Scalars['String']>
  /** The id of the collection in which the space is created. */
  collectionId?: InputMaybe<Scalars['ID']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  customSeoDetail?: InputMaybe<CustomSeoDetailInput>
  /** The description of the space. */
  description?: InputMaybe<Scalars['String']>
  externalId?: InputMaybe<Scalars['String']>
  /** Is this space hidden? */
  hidden?: InputMaybe<Scalars['Boolean']>
  /** The id of the space image. */
  imageId?: InputMaybe<Scalars['String']>
  /** Is this space invite only? */
  inviteOnly?: InputMaybe<Scalars['Boolean']>
  layout?: InputMaybe<Scalars['String']>
  memberIds?: InputMaybe<Array<Scalars['String']>>
  /** The name of the space. */
  name: Scalars['String']
  nonAdminsCanInvite?: InputMaybe<Scalars['Boolean']>
  /** Is this space a private space? */
  private?: InputMaybe<Scalars['Boolean']>
  seoDetail?: InputMaybe<SpaceSeoDetailInput>
  slate?: InputMaybe<SlateInput>
  /** The slug of the space. It will be auto-generated if not provided. */
  slug?: InputMaybe<Scalars['String']>
  type?: InputMaybe<SpaceType>
  updatedAt?: InputMaybe<Scalars['DateTime']>
  whoCanPost?: InputMaybe<Array<SpaceRoleType>>
  whoCanReact?: InputMaybe<Array<SpaceRoleType>>
  whoCanReply?: InputMaybe<Array<SpaceRoleType>>
  withRoles?: InputMaybe<Scalars['Boolean']>
}

/** Input for creating a tag. */
export type CreateTagInput = {
  /** The description of the tag. */
  description?: InputMaybe<Scalars['String']>
  /** The slug of the tag. Slug is auto-generated from title if left empty. */
  slug?: InputMaybe<Scalars['String']>
  /** The name of the tag. */
  title: Scalars['String']
}

export type CreateTemplateInput = {
  about?: InputMaybe<Scalars['String']>
  appIds?: InputMaybe<Array<Scalars['String']>>
  authorName?: InputMaybe<Scalars['String']>
  authorUrl?: InputMaybe<Scalars['String']>
  bannerId?: InputMaybe<Scalars['String']>
  categories?: InputMaybe<Array<Scalars['String']>>
  comingSoon?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  entityId: Scalars['String']
  entityType: TemplateEntityType
  faviconId?: InputMaybe<Scalars['String']>
  hubContentId?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  previewHtml?: InputMaybe<Scalars['String']>
  privacyPolicyUrl?: InputMaybe<Scalars['String']>
  requiredPlan?: InputMaybe<PlanName>
  slug?: InputMaybe<Scalars['String']>
  termsOfServiceUrl?: InputMaybe<Scalars['String']>
  upsertKey?: InputMaybe<Scalars['String']>
}

export enum CreatorType {
  App = 'App',
  Member = 'Member',
  System = 'System',
}

export type CustomCode = {
  anonymize: Scalars['Boolean']
  code: Scalars['String']
  position: CustomCodePosition
}

export enum CustomCodePosition {
  BODY = 'BODY',
  HEAD = 'HEAD',
}

export type CustomField = {
  key: Scalars['String']
  relationEntities?: Maybe<CustomFieldRelation>
  value?: Maybe<Scalars['String']>
}

export type CustomFieldInput = {
  key: Scalars['String']
  value: Scalars['String']
}

export type CustomFieldPrivacy = {
  allow: Array<CustomFieldPrivacyOptions>
}

export type CustomFieldPrivacyInput = {
  allow: Array<CustomFieldPrivacyOptions>
}

export enum CustomFieldPrivacyOptions {
  ADMIN = 'ADMIN',
  OWN = 'OWN',
}

export type CustomFieldRelation = {
  medias: Array<Media>
  members: Array<Member>
  posts: Array<Post>
  spaces: Array<Space>
  tags: Array<Tag>
}

export type CustomFieldSchema = {
  archived?: Maybe<Scalars['Boolean']>
  default?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  externalKeys?: Maybe<Array<Scalars['String']>>
  items?: Maybe<BaseCustomFieldSchema>
  key: Scalars['String']
  name: Scalars['String']
  properties?: Maybe<Array<BaseCustomFieldSchema>>
  readPrivacy?: Maybe<CustomFieldPrivacy>
  required?: Maybe<Scalars['Boolean']>
  searchable?: Maybe<Scalars['Boolean']>
  settings?: Maybe<Array<CustomFieldSettings>>
  type: CustomFieldType
  typeOptions?: Maybe<CustomFieldTypeOptions>
  validators?: Maybe<Array<CustomFieldValidator>>
  writePrivacy?: Maybe<CustomFieldPrivacy>
}

export type CustomFieldSchemaInput = {
  archived?: InputMaybe<Scalars['Boolean']>
  default?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  externalKeys?: InputMaybe<Array<Scalars['String']>>
  items?: InputMaybe<BaseCustomFieldSchemaInput>
  key: Scalars['String']
  name: Scalars['String']
  properties?: InputMaybe<Array<BaseCustomFieldSchemaInput>>
  readPrivacy?: InputMaybe<CustomFieldPrivacyInput>
  required?: InputMaybe<Scalars['Boolean']>
  searchable?: InputMaybe<Scalars['Boolean']>
  settings?: InputMaybe<Array<CustomFieldSettingsInput>>
  type: CustomFieldType
  typeOptions?: InputMaybe<CustomFieldTypeOptionsInput>
  validators?: InputMaybe<Array<CustomFieldValidatorInput>>
  writePrivacy?: InputMaybe<CustomFieldPrivacyInput>
}

export type CustomFieldSettings = {
  key: Scalars['String']
  value: Scalars['String']
}

export type CustomFieldSettingsInput = {
  key: Scalars['String']
  value: Scalars['String']
}

export enum CustomFieldType {
  array = 'array',
  boolean = 'boolean',
  date = 'date',
  number = 'number',
  object = 'object',
  relation = 'relation',
  richText = 'richText',
  text = 'text',
}

export type CustomFieldTypeOptions = {
  dateType?: Maybe<DateTypeOptions>
  numberType?: Maybe<NumberTypeOptions>
  relationType?: Maybe<RelationTypeOptions>
  richTextType?: Maybe<RichTextTypeOptions>
  textType?: Maybe<TextTypeOptions>
}

export type CustomFieldTypeOptionsInput = {
  dateType?: InputMaybe<DateTypeOptions>
  numberType?: InputMaybe<NumberTypeOptions>
  relationType?: InputMaybe<RelationTypeOptions>
  richTextType?: InputMaybe<RichTextTypeOptions>
  textType?: InputMaybe<TextTypeOptions>
}

export type CustomFieldValidator = {
  customErrorMessage?: Maybe<Scalars['String']>
  validation: CustomFieldValidators
  value: Scalars['String']
}

export type CustomFieldValidatorInput = {
  customErrorMessage?: InputMaybe<Scalars['String']>
  validation: CustomFieldValidators
  value: Scalars['String']
}

export enum CustomFieldValidators {
  allOf = 'allOf',
  anyOf = 'anyOf',
  enum = 'enum',
  exclusiveMaximum = 'exclusiveMaximum',
  exclusiveMinimum = 'exclusiveMinimum',
  format = 'format',
  maxItems = 'maxItems',
  maxLength = 'maxLength',
  maxProperties = 'maxProperties',
  maximum = 'maximum',
  minItems = 'minItems',
  minLength = 'minLength',
  minProperties = 'minProperties',
  minimum = 'minimum',
  multipleOf = 'multipleOf',
  not = 'not',
  oneOf = 'oneOf',
  pattern = 'pattern',
  uniqueItems = 'uniqueItems',
}

export type CustomFieldsSchema = {
  fields: Array<CustomFieldSchema>
}

export type CustomFieldsSchemaInput = {
  fields: Array<CustomFieldSchemaInput>
}

export type CustomReaction = {
  activeColor?: Maybe<Scalars['String']>
  activeGlyphId?: Maybe<Scalars['String']>
  activeName?: Maybe<Scalars['String']>
  color?: Maybe<Scalars['String']>
  glyphId: Scalars['String']
  key: Scalars['String']
  name: Scalars['String']
}

export type CustomReactionInput = {
  activeColor?: InputMaybe<Scalars['String']>
  activeGlyphId?: InputMaybe<Scalars['String']>
  activeName?: InputMaybe<Scalars['String']>
  color?: InputMaybe<Scalars['String']>
  glyphId: Scalars['String']
  key: Scalars['String']
  name: Scalars['String']
}

export type CustomSeoDetail = {
  canonicalUrl?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  noIndex?: Maybe<Scalars['Boolean']>
  thumbnail?: Maybe<Media>
  thumbnailId?: Maybe<Scalars['ID']>
  title?: Maybe<Scalars['String']>
}

export type CustomSeoDetailInput = {
  canonicalUrl?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  noIndex?: InputMaybe<Scalars['Boolean']>
  thumbnailId?: InputMaybe<Scalars['ID']>
  title?: InputMaybe<Scalars['String']>
}

export enum CustomSsoType {
  Saml = 'Saml',
  oauth2 = 'oauth2',
}

export enum DateTypeOptions {
  date = 'date',
  datetime = 'datetime',
}

export enum DefaultSsoType {
  Apple = 'Apple',
  Discord = 'Discord',
  Slack = 'Slack',
  facebook = 'facebook',
  google = 'google',
  linkedin = 'linkedin',
}

export type DomainAvailability = {
  available: Scalars['Boolean']
}

export type DomainAvailabilityInput = {
  domain: Scalars['String']
}

export type DomainTransferStatus = {
  aaaarecordSuccess: Scalars['Boolean']
  aaaarecords: Array<Scalars['String']>
  arecordSuccess: Scalars['Boolean']
  arecords: Array<Scalars['String']>
  cnameSuccess: Scalars['Boolean']
  cnames: Array<Scalars['String']>
  domain: Scalars['String']
  ns: Array<Scalars['String']>
  root: Scalars['Boolean']
  success: Scalars['Boolean']
  tribeARecords: Array<Scalars['String']>
  tribeCname: Scalars['String']
}

export type DynamicBlock = {
  app?: Maybe<App>
  appId: Scalars['String']
  contexts?: Maybe<Array<PermissionContext>>
  description?: Maybe<Scalars['String']>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  key: Scalars['String']
  maxSize: DynamicBlockSize
  name: Scalars['String']
  slate?: Maybe<Slate>
  staffOnly: Scalars['Boolean']
}

export type DynamicBlockSlateArgs = {
  context: PermissionContext
  entityId?: InputMaybe<Scalars['ID']>
}

export type DynamicBlockEdge = {
  cursor: Scalars['String']
  node: DynamicBlock
}

export enum DynamicBlockSize {
  full = 'full',
  lg = 'lg',
  md = 'md',
  sm = 'sm',
  xl = 'xl',
}

export type EmailAvailability = {
  available: Scalars['Boolean']
}

export type EmailLog = {
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  reason?: Maybe<Scalars['String']>
  recipient: Scalars['String']
  status: EmailStatus
  type: EmailType
  updatedAt: Scalars['DateTime']
}

export type EmailLogEdge = {
  cursor: Scalars['String']
  node: EmailLog
}

export enum EmailStatus {
  BLOCKED = 'BLOCKED',
  BOUNCED = 'BOUNCED',
  CREATED = 'CREATED',
  DEFERRED = 'DEFERRED',
  DELIVERED = 'DELIVERED',
  DROPPED = 'DROPPED',
  PROCESSED = 'PROCESSED',
  SENT = 'SENT',
}

export enum EmailType {
  AppNotification = 'AppNotification',
  CollaboratorInvitation = 'CollaboratorInvitation',
  EmailVerification = 'EmailVerification',
  ExportFinished = 'ExportFinished',
  MemberConfirmation = 'MemberConfirmation',
  MemberInvitation = 'MemberInvitation',
  Notification = 'Notification',
  ResetPassword = 'ResetPassword',
  Unknown = 'Unknown',
}

export type Embed = {
  author?: Maybe<Scalars['String']>
  author_url?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  html?: Maybe<Scalars['String']>
  id: Scalars['ID']
  options?: Maybe<Scalars['String']>
  provider_name?: Maybe<Scalars['String']>
  thumbnail_height?: Maybe<Scalars['String']>
  thumbnail_url?: Maybe<Scalars['String']>
  thumbnail_width?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  url: Scalars['String']
}

export type EmbedInput = {
  options?: InputMaybe<Scalars['String']>
  url: Scalars['String']
}

export type Emoji = {
  id: Scalars['ID']
  text: Scalars['String']
}

export type EntityListFilterByInput = {
  key: Scalars['String']
  operator: EntityListFilterByOperator
  value: Scalars['String']
}

export enum EntityListFilterByOperator {
  contains = 'contains',
  endsWith = 'endsWith',
  equals = 'equals',
  gt = 'gt',
  gte = 'gte',
  hasValue = 'hasValue',
  in = 'in',
  lt = 'lt',
  lte = 'lte',
  nin = 'nin',
  not = 'not',
  startsWith = 'startsWith',
}

export type EntityPermissions = {
  actions: Array<ActionPermissions>
  id: Scalars['String']
}

export type EntityReport = {
  data?: Maybe<Array<ReportData>>
  description?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['DateTime']>
  entity?: Maybe<ReportableEntity>
  entityId: Scalars['ID']
  entityType: ReportableEntityType
  startDate?: Maybe<Scalars['DateTime']>
  tooltip?: Maybe<Scalars['String']>
}

export type EntityScopes = {
  id: Scalars['String']
  scopes: Array<Scalars['String']>
}

export type EventType = {
  description: Scalars['String']
  name: Scalars['String']
  noun: Scalars['String']
  requiredScope: Scalars['String']
  shortDescription: Scalars['String']
  verb: EventVerb
}

export enum EventVerb {
  ACCEPTED = 'ACCEPTED',
  ADDED = 'ADDED',
  BANNED = 'BANNED',
  BLOCKED = 'BLOCKED',
  CANCELED = 'CANCELED',
  CLICKED = 'CLICKED',
  CREATED = 'CREATED',
  CUSTOM = 'CUSTOM',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  FOLLOWED = 'FOLLOWED',
  HIDDEN = 'HIDDEN',
  IMPRESSION = 'IMPRESSION',
  INSTALLED = 'INSTALLED',
  LOGGED_IN = 'LOGGED_IN',
  NOT_ASSIGNED = 'NOT_ASSIGNED',
  PERMITTED = 'PERMITTED',
  PING = 'PING',
  PINGED = 'PINGED',
  PINNED = 'PINNED',
  PUBLISHED = 'PUBLISHED',
  REJECTED = 'REJECTED',
  REMOVED = 'REMOVED',
  RESENT = 'RESENT',
  REVOKED = 'REVOKED',
  SENT = 'SENT',
  SIGNED_UP = 'SIGNED_UP',
  SUCCEEDED = 'SUCCEEDED',
  SUSPENDED = 'SUSPENDED',
  UNBLOCKED = 'UNBLOCKED',
  UNFOLLOWED = 'UNFOLLOWED',
  UNHIDDEN = 'UNHIDDEN',
  UNINSTALLED = 'UNINSTALLED',
  UNPINNED = 'UNPINNED',
  UNPUBLISHED = 'UNPUBLISHED',
  UNSUSPENDED = 'UNSUSPENDED',
  UNUSED = 'UNUSED',
  UNVERIFIED = 'UNVERIFIED',
  UPDATED = 'UPDATED',
  USED = 'USED',
  VERIFIED = 'VERIFIED',
  VIEWED = 'VIEWED',
}

export type Export = {
  createdAt: Scalars['DateTime']
  endedAt?: Maybe<Scalars['DateTime']>
  fields: Array<Scalars['String']>
  file?: Maybe<File>
  fileId: Scalars['ID']
  filterBy?: Maybe<Array<MemberListFilterBy>>
  id: Scalars['ID']
  networkId: Scalars['ID']
  startedAt?: Maybe<Scalars['DateTime']>
  status: ExportStatus
  updatedAt: Scalars['DateTime']
}

export type ExportEdge = {
  cursor: Scalars['String']
  node: Export
}

export type ExportInput = {
  fields: Array<Scalars['String']>
  filterBy?: InputMaybe<Array<MemberListFilterByInput>>
  query?: InputMaybe<Scalars['String']>
}

export enum ExportListOrderByEnum {
  CreatedAt = 'CreatedAt',
  UpdatedAt = 'UpdatedAt',
}

export enum ExportStatus {
  Done = 'Done',
  Expired = 'Expired',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Initialized = 'Initialized',
}

export type ExtraProperty = {
  key: Scalars['String']
  value: Scalars['String']
}

export enum ExtraPropertyEntityType {
  Member = 'Member',
  Network = 'Network',
}

export type File = {
  downloadUrl: Scalars['String']
  extension: Scalars['String']
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  size?: Maybe<Scalars['Int']>
  url: Scalars['String']
}

export enum Filtername {
  and = 'and',
  leaf = 'leaf',
  or = 'or',
}

export type FiltersInput = {
  filter: BaseFilterInput
}

export enum FlaggedType {
  MEMBER = 'MEMBER',
  SYSTEM = 'SYSTEM',
}

export type Footer = {
  urls: Array<FooterUrl>
}

export type FooterUrl = {
  title: Scalars['String']
  url: Scalars['String']
}

export type GlobalToken = {
  accessToken: Scalars['String']
  email: Scalars['String']
}

export type GlobalTokenInput = {
  email: Scalars['String']
  verificationCode: Scalars['String']
}

export type Glyph = {
  id: Scalars['ID']
  text: Scalars['String']
  variant: GlyphMediaVariant
}

export enum GlyphMediaVariant {
  emoji = 'emoji',
  icon = 'icon',
}

export enum HomeSpaceType {
  Default = 'Default',
  NewUser = 'NewUser',
  ReturningUser = 'ReturningUser',
}

export type HubContent = {
  attachmentIds: Array<Scalars['ID']>
  attachments?: Maybe<Array<File>>
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  embedIds: Array<Scalars['ID']>
  embeds?: Maybe<Array<Embed>>
  fields?: Maybe<Array<HubContentCustomField>>
  id: Scalars['ID']
  imageIds: Array<Scalars['ID']>
  images?: Maybe<Array<Media>>
  language?: Maybe<Scalars['String']>
  /** Whether the post is locked */
  locked: Scalars['Boolean']
  postTypeId: Scalars['ID']
  publishedAt?: Maybe<Scalars['DateTime']>
  slug?: Maybe<Scalars['String']>
  tagIds?: Maybe<Array<Scalars['String']>>
  thumbnail?: Maybe<Media>
  thumbnailId?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export type HubContentCustomField = {
  key: Scalars['String']
  relationEntities?: Maybe<HubContentCustomFieldRelation>
  value?: Maybe<Scalars['String']>
}

export type HubContentCustomFieldRelation = {
  medias: Array<Media>
}

export type Image = {
  cropHeight?: Maybe<Scalars['Int']>
  cropWidth?: Maybe<Scalars['Int']>
  cropX: Scalars['Int']
  cropY: Scalars['Int']
  cropZoom: Scalars['Float']
  dominantColorHex?: Maybe<Scalars['String']>
  downloadUrl: Scalars['String']
  dpi?: Maybe<Scalars['Float']>
  height?: Maybe<Scalars['Float']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  url: Scalars['String']
  urls?: Maybe<MediaUrls>
  width?: Maybe<Scalars['Float']>
}

export type ImpersonateLoginToNetworkInput = {
  memberId: Scalars['ID']
  networkId: Scalars['ID']
}

export type In = Space

export type InputPathPermissions = {
  isAuthorized: IsAuthorized
  path: Scalars['String']
  values: Array<ValuePermissions>
}

export type InstallAppInput = {
  context?: InputMaybe<PermissionContext>
  entityId?: InputMaybe<Scalars['String']>
  permissions?: InputMaybe<Array<PrimaryScopes>>
  templatesMappings?: InputMaybe<AppInstallationTemplatesMappingsInput>
}

export type IntValue = {
  int: Scalars['Int']
}

export type InteractWithAppInput = {
  appId: Scalars['String']
  callbackId?: InputMaybe<Scalars['String']>
  dynamicBlockKey?: InputMaybe<Scalars['String']>
  inputs?: InputMaybe<Scalars['String']>
  interactionId: Scalars['String']
  preview?: InputMaybe<Scalars['Boolean']>
  props?: InputMaybe<Scalars['String']>
  shortcutKey?: InputMaybe<Scalars['String']>
}

/** Input for inviting members. */
export type InviteMembersInput = {
  /** The ids of the default spaces the invitees have. */
  defaultSpacesIds?: InputMaybe<Array<Scalars['ID']>>
  /** When does the invitations expire? Empty for no expiration. */
  expiresAt?: InputMaybe<Scalars['DateTime']>
  /** Custom message for invitation. */
  invitationMessage?: InputMaybe<Scalars['String']>
  /** The details of the invitees */
  invitees: Array<InviteeInput>
  /** The id of the role the invitees have. */
  roleId?: InputMaybe<Scalars['ID']>
}

export type InviteeInput = {
  /** The ids of the default spaces this invitee has. */
  defaultSpacesIds?: InputMaybe<Array<Scalars['ID']>>
  /** The email address of the invitee. */
  email: Scalars['String']
  /** The name of the invitee. */
  name?: InputMaybe<Scalars['String']>
  /** The role id of the invitee. */
  roleId?: InputMaybe<Scalars['ID']>
}

export type Invoice = {
  cardLastFourDigits?: Maybe<Scalars['String']>
  currency: Scalars['String']
  date: Scalars['DateTime']
  invoiceUrl?: Maybe<Scalars['String']>
  status: InvoiceStatus
  total: Scalars['Float']
}

export enum InvoiceStatus {
  cancelled = 'cancelled',
  failed = 'failed',
  paid = 'paid',
  pending = 'pending',
}

export type IsAuthorized = {
  authorized: Scalars['Boolean']
  reason?: Maybe<UnauthorizedReason>
  requiredPlan?: Maybe<PlanName>
}

export type JoinNetworkInput = {
  captchaToken?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  email: Scalars['String']
  externalId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  password: Scalars['String']
  phone?: InputMaybe<Scalars['String']>
  tagline?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['DateTime']>
  username?: InputMaybe<Scalars['String']>
  verified?: InputMaybe<Scalars['Boolean']>
}

export type JoinNetworkWithLinkInput = {
  captchaToken?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  invitationLinkId: Scalars['String']
  name: Scalars['String']
  password: Scalars['String']
  username?: InputMaybe<Scalars['String']>
}

export type JoinNetworkWithTokenInput = {
  captchaToken?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  password: Scalars['String']
  token: Scalars['String']
  username?: InputMaybe<Scalars['String']>
}

export type JwtSsoAuthUrls = {
  authorizationUrl?: Maybe<Scalars['String']>
  signUpUrl?: Maybe<Scalars['String']>
}

export type KeyValue = {
  key: Scalars['String']
  value?: Maybe<Scalars['String']>
}

export type LeaderboardItem = {
  member?: Maybe<Member>
  memberId: Scalars['String']
  score: Scalars['Float']
}

export type LoginNetworkWithPasswordInput = {
  password: Scalars['String']
  usernameOrEmail: Scalars['String']
}

export type LoginSupportWithSsoCodeInput = {
  code: Scalars['String']
  hd: Scalars['String']
  prompt: Scalars['String']
  scope: Scalars['String']
  state: Scalars['String']
}

export type LoginWithSamlResponseInput = {
  relayState: Scalars['String']
  samlResponse: Scalars['String']
}

export type LoginWithSsoCodeInput = {
  code?: InputMaybe<Scalars['String']>
  hd?: InputMaybe<Scalars['String']>
  oauth_token?: InputMaybe<Scalars['String']>
  oauth_verifier?: InputMaybe<Scalars['String']>
  prompt?: InputMaybe<Scalars['String']>
  scope?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
}

export type LogoutNetworkInput = {
  sessionId: Scalars['String']
}

export type MassActionFilters = {
  entityIds?: InputMaybe<Array<Scalars['ID']>>
  filterBy?: InputMaybe<Array<MemberListFilterByInput>>
  query?: InputMaybe<Scalars['String']>
}

export type MassActionFiltersModel = {
  entityIds?: Maybe<Array<Scalars['ID']>>
  filterBy?: Maybe<Array<MemberListFilterBy>>
  query?: Maybe<Scalars['String']>
}

export type MassActionRequest = {
  action: MassActionRequestAction
  context: MassActionRequestContext
  createdAt: Scalars['DateTime']
  createdById: Scalars['String']
  endedAt?: Maybe<Scalars['DateTime']>
  entitiesCount?: Maybe<Scalars['Int']>
  failedCount?: Maybe<Scalars['Int']>
  filters: MassActionFiltersModel
  id: Scalars['ID']
  networkId: Scalars['ID']
  processedCount?: Maybe<Scalars['Int']>
  startedAt?: Maybe<Scalars['DateTime']>
  status: MassActionRequestStatus
  updatedAt: Scalars['DateTime']
}

export enum MassActionRequestAction {
  Accept = 'Accept',
  AddTag = 'AddTag',
  AddToSpace = 'AddToSpace',
  AssignBadge = 'AssignBadge',
  Create = 'Create',
  Delete = 'Delete',
  Expire = 'Expire',
  Flag = 'Flag',
  Follow = 'Follow',
  Hide = 'Hide',
  Lock = 'Lock',
  Move = 'Move',
  Pin = 'Pin',
  Publish = 'Publish',
  Reject = 'Reject',
  RemoveTag = 'RemoveTag',
  Resend = 'Resend',
  Revoke = 'Revoke',
  RevokeBadge = 'RevokeBadge',
  Suspend = 'Suspend',
  Unflag = 'Unflag',
  Unfollow = 'Unfollow',
  Unhide = 'Unhide',
  Unpin = 'Unpin',
  Update = 'Update',
  Verify = 'Verify',
}

export enum MassActionRequestContext {
  Member = 'Member',
  MemberInvitation = 'MemberInvitation',
  ModerationItem = 'ModerationItem',
  Post = 'Post',
  Space = 'Space',
  Tag = 'Tag',
}

export type MassActionRequestExtraPropertiesInput = {
  badgeIds?: InputMaybe<Array<Scalars['ID']>>
  includeReplies?: InputMaybe<Scalars['Boolean']>
  postTypeId?: InputMaybe<Scalars['ID']>
  removeAllTags?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['ID']>
  tagIds?: InputMaybe<Array<Scalars['ID']>>
  tagNames?: InputMaybe<Array<Scalars['ID']>>
  updatePostProperties?: InputMaybe<MassActionUpdatePostPropertiesInput>
}

export type MassActionRequestInput = {
  action: MassActionRequestAction
  context: MassActionRequestContext
  extraProperties?: InputMaybe<MassActionRequestExtraPropertiesInput>
  filters: MassActionFilters
  waitForConfirmation?: InputMaybe<Scalars['Boolean']>
}

export enum MassActionRequestStatus {
  Done = 'Done',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Initialized = 'Initialized',
  WaitingForConfirmation = 'WaitingForConfirmation',
}

export type MassActionUpdatePostPropertiesInput = {
  ownerId?: InputMaybe<Scalars['String']>
  publishedAt?: InputMaybe<Scalars['DateTime']>
}

export type Media = Emoji | File | Glyph | Image

export type MediaLimits = {
  fileSizeLimit: Scalars['Float']
  fileTypesLimit: Array<Scalars['String']>
  imageSizeLimit: Scalars['Float']
  imageTypesLimit: Array<Scalars['String']>
}

export type MediaNetworkSettings = {
  fileSizeLimit: Scalars['Float']
  fileTypesLimit: Array<Scalars['String']>
  imageSizeLimit: Scalars['Float']
  imageTypesLimit: Array<Scalars['String']>
}

export type MediaUrls = {
  full: Scalars['String']
  large: Scalars['String']
  medium: Scalars['String']
  small: Scalars['String']
  thumb: Scalars['String']
}

export type Member = {
  activeSession?: Maybe<MemberSession>
  /** @deprecated Has been replaced by locale field */
  attributes: MemberAttributes
  authMemberProps?: Maybe<MemberAuthMemberProps>
  badges?: Maybe<Array<MemberBadge>>
  banner?: Maybe<Media>
  bannerId?: Maybe<Scalars['ID']>
  blockedMemberIds?: Maybe<Array<Scalars['String']>>
  blockedMembers?: Maybe<Array<Member>>
  createdAt: Scalars['DateTime']
  /** @deprecated Has been replaced with name */
  displayName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  emailStatus?: Maybe<MemberEmailStatus>
  externalId?: Maybe<Scalars['ID']>
  extraProperties?: Maybe<Array<ExtraProperty>>
  fields?: Maybe<Array<CustomField>>
  flagged: Scalars['Boolean']
  id: Scalars['ID']
  lastSeen?: Maybe<Scalars['DateTime']>
  lastSeenAt?: Maybe<Scalars['DateTime']>
  locale: Scalars['String']
  name?: Maybe<Scalars['String']>
  network?: Maybe<Network>
  networkId: Scalars['ID']
  newEmail?: Maybe<Scalars['String']>
  overrideTeammate: Scalars['Boolean']
  profilePicture?: Maybe<Media>
  profilePictureId?: Maybe<Scalars['ID']>
  relativeUrl?: Maybe<Scalars['String']>
  role?: Maybe<Role>
  roleId: Scalars['ID']
  score?: Maybe<Scalars['Int']>
  sessions?: Maybe<Array<MemberSession>>
  settings?: Maybe<MemberSettings>
  shortcuts?: Maybe<Array<Shortcut>>
  spaces?: Maybe<PaginatedSpace>
  staffReasons?: Maybe<Array<StaffReason>>
  status: MemberStatus
  tagline?: Maybe<Scalars['String']>
  teammate: Scalars['Boolean']
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
  username: Scalars['String']
  verifiedAt?: Maybe<Scalars['DateTime']>
}

export type MemberExtraPropertiesArgs = {
  keys?: InputMaybe<Array<Scalars['String']>>
}

export type MemberSpacesArgs = {
  exploreOnly?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
}

export type MemberAttributes = {
  locale: Scalars['String']
}

export type MemberAuthMemberProps = {
  canSendPrivateMessages?: Maybe<Scalars['Boolean']>
  context: PermissionContext
  permissions?: Maybe<Array<ActionPermissions>>
  scopes?: Maybe<Array<Scalars['String']>>
}

export type MemberBadge = {
  backgroundColor?: Maybe<Scalars['String']>
  badge?: Maybe<Badge>
  badgeId: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  longDescription?: Maybe<Scalars['String']>
  shortDescription: Scalars['String']
  text?: Maybe<Scalars['String']>
  textColor?: Maybe<Scalars['String']>
  type: BadgeType
}

export type MemberEdge = {
  cursor: Scalars['String']
  node: Member
}

export enum MemberEmailStatus {
  notDelivered = 'notDelivered',
  sent = 'sent',
  spammed = 'spammed',
  verified = 'verified',
}

export type MemberForSpaceInvitation = {
  member: Member
  memberId: Scalars['ID']
  spaceAffiliation: SpaceMemberAffiliation
}

export type MemberInvitation = {
  createdAt: Scalars['DateTime']
  emailLog?: Maybe<EmailLog>
  emailLogs?: Maybe<Array<EmailLog>>
  expiresAt: Scalars['DateTime']
  id: Scalars['ID']
  invitationMessage?: Maybe<Scalars['String']>
  invitee?: Maybe<Member>
  inviteeEmail: Scalars['String']
  inviteeId?: Maybe<Scalars['ID']>
  inviteeName?: Maybe<Scalars['String']>
  inviter?: Maybe<Member>
  inviterId: Scalars['ID']
  joinedAt?: Maybe<Scalars['DateTime']>
  network?: Maybe<Network>
  networkId: Scalars['ID']
  role?: Maybe<Role>
  roleId: Scalars['ID']
  status: MemberInvitationStatus
}

export type MemberInvitationEdge = {
  cursor: Scalars['String']
  node: MemberInvitation
}

export type MemberInvitationFilterByInput = {
  key: Scalars['String']
  operator: MemberInvitationFilterByOperator
  value: Scalars['String']
}

export enum MemberInvitationFilterByOperator {
  contains = 'contains',
  equals = 'equals',
  gt = 'gt',
  gte = 'gte',
  lt = 'lt',
  lte = 'lte',
  not = 'not',
}

export type MemberInvitationLink = {
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  inviter?: Maybe<Member>
  link: Scalars['String']
  network?: Maybe<Network>
}

export enum MemberInvitationStatus {
  Expired = 'Expired',
  Pending = 'Pending',
  Revoked = 'Revoked',
  accepted = 'accepted',
  delivered = 'delivered',
  notDelivered = 'notDelivered',
  notSent = 'notSent',
  rejected = 'rejected',
  sent = 'sent',
  spammed = 'spammed',
}

export type MemberListFilterBy = {
  key: Scalars['String']
  operator: MemberListFilterByOperator
  value: Scalars['String']
}

export type MemberListFilterByInput = {
  key: Scalars['String']
  operator: MemberListFilterByOperator
  value: Scalars['String']
}

export enum MemberListFilterByOperator {
  contains = 'contains',
  endsWith = 'endsWith',
  equals = 'equals',
  gt = 'gt',
  gte = 'gte',
  hasValue = 'hasValue',
  in = 'in',
  lt = 'lt',
  lte = 'lte',
  nin = 'nin',
  not = 'not',
  startsWith = 'startsWith',
}

export type MemberNetworkNotificationSettings = {
  channel: NotificationChannel
  enabled?: Maybe<Scalars['Boolean']>
  isDefault: Scalars['Boolean']
  mention?: Maybe<Scalars['Boolean']>
  message?: Maybe<Scalars['Boolean']>
  reaction?: Maybe<Scalars['Boolean']>
  sameAsDefault: Scalars['Boolean']
}

export type MemberNotificationSettings = {
  network: Array<MemberNetworkNotificationSettings>
  spaces: Array<MemberSpaceNotificationSettings>
}

export type MemberPermissionsSettingsInput = {
  canDeleteAccount: Scalars['Boolean']
}

export type MemberPostNotificationSettings = {
  enabled?: Maybe<Scalars['Boolean']>
  memberId: Scalars['String']
  postId: Scalars['String']
}

export type MemberPrivateMessagingSettings = {
  privateMessagingEnabled: Scalars['Boolean']
}

export type MemberPrivateMessagingSettingsInput = {
  privateMessagingEnabled: Scalars['Boolean']
}

export type MemberSession = {
  active: Scalars['Boolean']
  country?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  deviceBrand?: Maybe<Scalars['String']>
  id: Scalars['ID']
  ip: Scalars['String']
  lastActivityAt: Scalars['DateTime']
  os?: Maybe<Scalars['String']>
  osVersion?: Maybe<Scalars['String']>
}

export type MemberSettings = {
  privateMessaging?: Maybe<MemberPrivateMessagingSettings>
}

export type MemberSettingsInput = {
  privateMessaging?: InputMaybe<MemberPrivateMessagingSettingsInput>
}

export type MemberSpaceNotificationSettings = {
  channel: NotificationChannel
  enabled?: Maybe<Scalars['Boolean']>
  isDefault: Scalars['Boolean']
  preference?: Maybe<SpaceNotificationPreference>
  sameAsDefault: Scalars['Boolean']
  space?: Maybe<Space>
}

export enum MemberStatus {
  BLOCKED = 'BLOCKED',
  DELETED = 'DELETED',
  REMOVED = 'REMOVED',
  Suspended = 'Suspended',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED',
}

export enum MemberStatusInput {
  BLOCKED = 'BLOCKED',
  Suspended = 'Suspended',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED',
}

export type MembersPermissionSettings = {
  canDeleteAccount: Scalars['Boolean']
}

export type Migration = {
  id: Scalars['ID']
  networkId: Scalars['ID']
  requesterId: Scalars['ID']
  stage: MigrationStage
  status: MigrationStatus
}

export type MigrationFieldError = {
  field: Scalars['String']
  message: Scalars['String']
}

export type MigrationFileResult = {
  file: Scalars['String']
  insertedRows: Scalars['Int']
  rowErrors: Array<MigrationRowErrors>
  skippedRows: Scalars['Int']
}

export type MigrationRowErrors = {
  externalId?: Maybe<Scalars['String']>
  fieldErrors: Array<MigrationFieldError>
  message: Scalars['String']
  rowNumber: Scalars['Int']
}

export enum MigrationStage {
  MEDIA = 'MEDIA',
  MEMBER = 'MEMBER',
  POST = 'POST',
  SPACE = 'SPACE',
  SPACE_MEMBER = 'SPACE_MEMBER',
  TAG = 'TAG',
}

export enum MigrationStatus {
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum ModerationEntityType {
  MEMBER = 'MEMBER',
  POST = 'POST',
}

export type ModerationItem = {
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  entity?: Maybe<ModerationItemEntity>
  flaggedBy: FlaggedType
  id: Scalars['String']
  memberId?: Maybe<Scalars['String']>
  moderator?: Maybe<Member>
  reporters?: Maybe<PaginatedModerationItemReporter>
  spaceId?: Maybe<Scalars['String']>
  status: ModerationStatus
  updatedAt: Scalars['DateTime']
}

export type ModerationItemReportersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type ModerationItemEdge = {
  cursor: Scalars['String']
  node: ModerationItem
}

export type ModerationItemEntity = Member | Post

export type ModerationItemReporter = {
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  id: Scalars['String']
  reportCategory: ReportCategory
  reporter?: Maybe<Member>
  updatedAt: Scalars['DateTime']
}

export type ModerationItemReporterEdge = {
  cursor: Scalars['String']
  node: ModerationItemReporter
}

export type ModerationMemberSettings = {
  minimumHoursToPost: Scalars['Int']
  minimumHoursToReply: Scalars['Int']
}

export type ModerationMemberSettingsInput = {
  minimumHoursToPost: Scalars['Int']
  minimumHoursToReply: Scalars['Int']
}

export type ModerationSettings = {
  akismet: Scalars['Boolean']
  blackListPostTypeIds: Array<Scalars['String']>
  blackListSpaceIds: Array<Scalars['String']>
  customBlacklist?: Maybe<Array<Scalars['String']>>
  enableBlacklisting: Scalars['Boolean']
  member: ModerationMemberSettings
  oopSpam: Scalars['Boolean']
  preventPublish: Scalars['Boolean']
  useDefaultBlacklisting?: Maybe<Scalars['Boolean']>
}

export enum ModerationStatus {
  ACCEPTED = 'ACCEPTED',
  PendingConfirmation = 'PendingConfirmation',
  REJECTED = 'REJECTED',
  REVIEW = 'REVIEW',
}

export type Mutation = {
  /** @deprecated Use Glyphs instead, just update the media id with `emoji/...` */
  addEmoji: Emoji
  /** @deprecated Use Glyphs instead, just update the media id with `emoji/...` */
  addEmojis: Array<Emoji>
  /** @deprecated This mutation will be replaced by createCollection */
  addGroup: Collection
  /** @deprecated This mutation will be replaced by createImages */
  addImage: SignedUrl
  /** @deprecated This mutation will be replaced by createImages */
  addImages: Array<SignedUrl>
  /** @deprecated This mutation will be replaced by createImages or createEmojis */
  addMedias: Array<SignedUrl>
  addMemberSchemaField: Network
  /** @deprecated This mutation will be replaced by createModerationReport */
  addModerationReport: ModerationItem
  /** @deprecated This mutation will be replaced by createNetwork */
  addNetwork: AuthTokenWithOtp
  /** @deprecated This mutation will be replaced by updateNewDomain */
  addNewDomain: DomainTransferStatus
  /** @deprecated This mutation will be replaced by createPost */
  addPost: Post
  addPostTypeField: PostType
  addReaction: Action
  /** @deprecated This mutation will be replaced by createReply */
  addReply: Post
  /** @deprecated This mutation will be replaced by createSpace */
  addSpace: Space
  addSpaceMembers: Array<SpaceMember>
  addTemplateToNetwork: TemplateRequest
  /** @deprecated This mutation is for the old billing */
  addTrialPlan?: Maybe<Plan>
  /** @deprecated This mutation will be replaced by approveSpaceMembershipRequest */
  approveSpaceJoinRequest: Action
  approveSpaceMembershipRequest: Action
  archiveMemberSchemaField: Network
  archivePostType: PostType
  archivePostTypeField: PostType
  assignBadge: Action
  blockMember: Action
  callback: CallbackResponse
  cancelEmailUpdate: Action
  changeHomepage: Action
  changeNetworkSubscriptionPlan: Network
  clearNewDomain: Action
  clearNotificationsCount: Action
  closeSpace: Action
  confirmMassActionRequest: MassActionRequest
  confirmResetPassword: Action
  createAccessGroup: AccessGroup
  createBadge: Badge
  createBillingPortalSession: BillingPortalSession
  createCollection: Collection
  /** @deprecated Use Glyphs instead, just update the media id with `emoji/...` */
  createEmojis: Array<Emoji>
  createExportMemberRequest: Export
  createFiles: Array<SignedUrl>
  createImages: Array<SignedUrl>
  createMassActionRequest: MassActionRequest
  createModerationReport: ModerationItem
  createNetwork: AuthTokenWithOtp
  createPermission: Permission
  /** Create a new post in a space. */
  createPost: Post
  /** Create a new post type. */
  createPostType: PostType
  createReply: Post
  /** @deprecated This mutation will be replaced by createModerationReport */
  createReport: ModerationItem
  /** Create a space inside your community. */
  createSpace: Space
  createSpaceFromTemplate: TemplateRequest
  createSubscriptionCheckoutSession: SubscriptionCheckoutSession
  /** Create a new tag */
  createTag: Tag
  createTemplate: Template
  /** @deprecated This mutation will be replaced by declineSpaceMembershipRequest */
  declineSpaceJoinRequest: Action
  declineSpaceMembershipRequest: Action
  deleteAccessGroup: Action
  deleteBadge: Action
  deleteCollection: Action
  deleteMember: Action
  deleteMemberSchemaField: Network
  deleteNetwork: Action
  deleteNotification: Action
  deleteNotifications: Action
  deletePageCustomResponse: Action
  deletePermission: Action
  deletePost: Action
  deletePostTypeField: PostType
  deleteSpace: Action
  deleteSpacePostTypes: Action
  deleteSsoMembership: Action
  deleteTag: Action
  deleteTemplate: Action
  /** @deprecated This mutation will be replaced by updatePasswordWithToken */
  doResetPassword: Action
  /** @deprecated This mutation will be replaced by updateImage */
  editImage: Image
  /** @deprecated This mutation is for the old billing */
  extendCurrentTrial?: Maybe<Plan>
  /** @deprecated Use the global gateway instead */
  globalAddAppCollaborator: AppCollaborator
  /** @deprecated Use the global gateway instead */
  globalCreateApp: App
  /** @deprecated Use Glyphs instead, just update the media id with `emoji/...` */
  globalCreateEmojis: Array<Emoji>
  /** @deprecated Use the global gateway instead */
  globalCreateImages: Array<SignedUrl>
  /** @deprecated Use the global gateway instead */
  globalDeleteApp: Action
  /** @deprecated Use the global gateway instead */
  globalDeleteAppSetting: AppSetting
  /** @deprecated Use the global gateway instead */
  globalPublishAppPrivately: AppPublication
  /** @deprecated Use the global gateway instead */
  globalRegenerateClientSecret: App
  /** @deprecated Use the global gateway instead */
  globalRemoveAppCollaborator: Action
  /** @deprecated Use the global gateway instead */
  globalTestAppWebhook: Action
  /** @deprecated Use the global gateway instead */
  globalUnPublishAppPrivately: Action
  /** @deprecated Use the global gateway instead */
  globalUpdateApp: App
  /** @deprecated Use the global gateway instead */
  globalUpdateAppSetting: AppSetting
  hidePost: Action
  impersonateLoginToNetwork: AuthInfoWithOtp
  installApp: AppInstallation
  installAppOnAuthMember: AppInstallation
  interactWithApps: Array<AppInteraction>
  /** Invite members to join your community. */
  inviteMembers: Array<MemberInvitation>
  joinNetwork: AuthToken
  joinNetworkWithInvitationLink: AuthToken
  joinNetworkWithToken: AuthToken
  joinSpace: Action
  leaveSpace: Action
  loginNetwork: AuthToken
  loginNetworkWithPassword: AuthToken
  loginWithSamlResponse: AuthToken
  loginWithSsoCode: AuthToken
  logoutMemberSessions: Action
  logoutNetwork: Action
  modifySubscriptionAddon: Action
  movePost: Post
  movePosts: Array<Post>
  organizeCollections: Action
  /** @deprecated This mutation will be replaced by organizeSpacesInCollection */
  organizeGroupSpaces: Action
  /** @deprecated This mutation will be replaced by organizeCollections */
  organizeGroups: Action
  organizeSpacesInCollection: Action
  pinPostToSpace: Action
  pinReplyToPost: Action
  publishAppPrivately: AppPublication
  publishTemplate: Action
  /** @deprecated Use new billing APIs */
  purchase?: Maybe<BillingSubscription>
  readNotification: Action
  readNotifications: Action
  readSpace: Action
  /** @deprecated This mutation will be replaced by deleteCollection */
  removeGroup: Action
  /** @deprecated This mutation will be replaced by deleteMember */
  removeMember: Action
  /** @deprecated This mutation will be replaced by deleteNetwork */
  removeNetwork: Action
  /** @deprecated This mutation will be replaced by deletePost */
  removePost: Action
  removeReaction: Action
  removeSpaceMembers: Array<Action>
  reorderMemberSchemaFields: Network
  reorderPostTypeFields: PostType
  /** @deprecated Use the global gateway instead */
  requestGlobalTokenCode: Action
  requestSpaceMembership: SpaceJoinRequest
  /** @deprecated Use the global gateway instead */
  resendGlobalTokenCode: Action
  resendMemberInvitation: Action
  resendVerification: Action
  /** @deprecated This mutation will be replaced by sendResetPasswordEmail */
  resetPassword: Action
  revokeBadge: Action
  revokeMemberInvitation: Action
  runMigration: Migration
  sendResetPasswordEmail: Action
  setPrivatelyPublishedApps: Array<AppPublication>
  /** @deprecated This mutation will be replaced by loginWithSsoCode */
  ssoRedirect: AuthToken
  /** @deprecated This mutation will be replaced by loginSupportWithSsoCode */
  supportSsoRedirect: SupportAuthToken
  suspendMember: Action
  syncTemplate: Template
  transferToNewDomain: Action
  unArchiveMemberSchemaField: Network
  unPublishAppPrivately: ActionStatus
  unarchivePostType: PostType
  unarchivePostTypeField: PostType
  unblockMember: Action
  unhidePost: Action
  uninstallApp?: Maybe<AppInstallation>
  unpinPostFromSpace: Action
  unpinReplyFromPost: Action
  unpublishTemplate: Action
  unsetHomepage: Action
  unsubscribeFromNotification: Action
  /** @deprecated This mutation will be replaced by unsubscribeFromNotification */
  unsubscribeWithToken: Action
  unsuspendMember: Action
  updateAccessGroup: AccessGroup
  updateAppInstallation: AppInstallation
  updateAppNetworkSettings: AppAction
  updateAppSpaceSetting: AppAction
  updateAppStanding: ActionStatus
  updateAppStatus: ActionStatus
  updateAuthMember: Member
  updateBadge: Badge
  /** @deprecated Use new billing APIs */
  updateBillingDetails?: Maybe<BillingDetails>
  updateCollection: Action
  updateCustomSso: Sso
  updateDefaultSsoStatus: Action
  updateFile: File
  /** @deprecated This mutation will be replaced by updateCollection */
  updateGroup: Action
  updateImage: Image
  updateJwtSso: Sso
  updateMember: Member
  updateMemberInvitation: MemberInvitation
  updateMemberNetworkNotificationSettings: MemberNetworkNotificationSettings
  updateMemberPostNotificationSettings: MemberPostNotificationSettings
  /** @deprecated This mutation will be replaced by updateMember */
  updateMemberPrivateMessagingSettings: MemberPrivateMessagingSettings
  updateMemberSchemaField: Network
  updateMemberSpaceNotificationSettings: MemberSpaceNotificationSettings
  updateMemberSpaceRole: Action
  /** @deprecated This mutation will be replaced by updateModerationItem */
  updateModeration: Action
  updateModerationItem: Action
  updateModerationSettings: ModerationSettings
  updateNetwork: Network
  updateNetworkAvailableLocales: Network
  updateNetworkCustomCapacities: Network
  updateNetworkDomainSubfolder: Network
  updateNetworkMediaSettings: MediaNetworkSettings
  updateNetworkNotificationSettings: NotificationNetworkSettings
  updateNetworkStatus: Action
  updateNewDomain: DomainTransferStatus
  updatePasswordWithToken: Action
  updatePermission: Permission
  updatePost: Post
  updatePostType: PostType
  updatePostTypeField: PostType
  /** @deprecated This mutation will be replaced by updateNetwork */
  updatePrivateMessagingSettings: PrivateMessagingSettings
  updateSpace: Space
  updateSpaceDefaultNotificationSettings: SpaceDefaultNotificationSettings
  updateSpaceHighlightedTags: Action
  /** @deprecated This mutation will be replaced by updateMemberSpaceRole */
  updateSpaceMemberRole: Action
  updateSpacePostTypes: Array<SpacePostType>
  updateSubscriptionInterval: Action
  updateSubscriptionPlan: Action
  updateTag: Tag
  updateTemplate: Template
  uploadMigrationFiles: UploadedMigrations
  upsertExtraProperty: Action
  upsertPageCustomResponse: PageDetailedCustomResponse
  upsertTheme: NewTheme
  verifyMember: AuthToken
}

export type MutationAddEmojiArgs = {
  input: CreateEmojiInput
}

export type MutationAddEmojisArgs = {
  input: Array<CreateEmojiInput>
}

export type MutationAddGroupArgs = {
  input: CreateCollectionInput
}

export type MutationAddImageArgs = {
  input: CreateImageInput
}

export type MutationAddImagesArgs = {
  input: Array<CreateImageInput>
}

export type MutationAddMediasArgs = {
  input: AddMediasInput
}

export type MutationAddMemberSchemaFieldArgs = {
  input: CustomFieldSchemaInput
}

export type MutationAddModerationReportArgs = {
  input: CreateReportInput
}

export type MutationAddNetworkArgs = {
  input: AddNetworkInput
}

export type MutationAddNewDomainArgs = {
  input: DomainAvailabilityInput
}

export type MutationAddPostArgs = {
  input: CreatePostInput
  spaceId: Scalars['ID']
}

export type MutationAddPostTypeFieldArgs = {
  id: Scalars['ID']
  input: CustomFieldSchemaInput
}

export type MutationAddReactionArgs = {
  input: AddReactionInput
  postId: Scalars['ID']
}

export type MutationAddReplyArgs = {
  input: CreatePostInput
  postId: Scalars['ID']
}

export type MutationAddSpaceArgs = {
  input: CreateSpaceInput
}

export type MutationAddSpaceMembersArgs = {
  input: Array<AddSpaceMemberInput>
  spaceId: Scalars['ID']
}

export type MutationAddTemplateToNetworkArgs = {
  excludeEntityTypes?: InputMaybe<Array<TemplateEntityType>>
  templateId: Scalars['String']
}

export type MutationAddTrialPlanArgs = {
  trial: AddTrialInput
}

export type MutationApproveSpaceJoinRequestArgs = {
  spaceId: Scalars['ID']
  spaceJoinRequestId: Scalars['ID']
}

export type MutationApproveSpaceMembershipRequestArgs = {
  spaceId: Scalars['ID']
  spaceMembershipRequestId: Scalars['ID']
}

export type MutationArchiveMemberSchemaFieldArgs = {
  key: Scalars['String']
}

export type MutationArchivePostTypeArgs = {
  id: Scalars['ID']
}

export type MutationArchivePostTypeFieldArgs = {
  id: Scalars['ID']
  key: Scalars['String']
}

export type MutationAssignBadgeArgs = {
  id: Scalars['String']
  input: AssignOrRevokeBadgeInput
}

export type MutationBlockMemberArgs = {
  memberId: Scalars['String']
}

export type MutationCallbackArgs = {
  appId: Scalars['ID']
  callbackId: Scalars['ID']
  context: PermissionContext
  dynamicBlockId?: InputMaybe<Scalars['ID']>
  entityId?: InputMaybe<Scalars['ID']>
  inputs?: InputMaybe<Scalars['String']>
}

export type MutationCancelEmailUpdateArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type MutationChangeHomepageArgs = {
  spaceId: Scalars['String']
  type?: InputMaybe<HomeSpaceType>
}

export type MutationChangeNetworkSubscriptionPlanArgs = {
  name: PlanName
}

export type MutationCloseSpaceArgs = {
  spaceId: Scalars['ID']
}

export type MutationConfirmMassActionRequestArgs = {
  massActionRequestId: Scalars['String']
}

export type MutationConfirmResetPasswordArgs = {
  input: ConfirmResetPasswordInput
}

export type MutationCreateAccessGroupArgs = {
  input: CreateAccessGroupInput
}

export type MutationCreateBadgeArgs = {
  input: CreateBadgeInput
}

export type MutationCreateBillingPortalSessionArgs = {
  returnUrl: Scalars['String']
}

export type MutationCreateCollectionArgs = {
  input: CreateCollectionInput
}

export type MutationCreateEmojisArgs = {
  input: Array<CreateEmojiInput>
}

export type MutationCreateExportMemberRequestArgs = {
  input: ExportInput
}

export type MutationCreateFilesArgs = {
  input: Array<CreateFileInput>
}

export type MutationCreateImagesArgs = {
  input: Array<CreateImageInput>
}

export type MutationCreateMassActionRequestArgs = {
  input: MassActionRequestInput
}

export type MutationCreateModerationReportArgs = {
  input: CreateReportInput
}

export type MutationCreateNetworkArgs = {
  input: AddNetworkInput
}

export type MutationCreatePermissionArgs = {
  input: CreatePermissionInput
}

export type MutationCreatePostArgs = {
  input: CreatePostInput
  spaceId: Scalars['ID']
}

export type MutationCreatePostTypeArgs = {
  input: CreatePostTypeInput
}

export type MutationCreateReplyArgs = {
  input: CreatePostInput
  postId: Scalars['ID']
}

export type MutationCreateReportArgs = {
  input: CreateReportInput
}

export type MutationCreateSpaceArgs = {
  input: CreateSpaceInput
}

export type MutationCreateSpaceFromTemplateArgs = {
  excludeEntityTypes?: InputMaybe<Array<TemplateEntityType>>
  input: CreateSpaceInput
  style?: InputMaybe<Scalars['String']>
  templateId: Scalars['String']
}

export type MutationCreateSubscriptionCheckoutSessionArgs = {
  cancelUrl: Scalars['String']
  priceId: Scalars['String']
  successUrl: Scalars['String']
}

export type MutationCreateTagArgs = {
  input: CreateTagInput
}

export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput
}

export type MutationDeclineSpaceJoinRequestArgs = {
  spaceId: Scalars['ID']
  spaceJoinRequestId: Scalars['ID']
}

export type MutationDeclineSpaceMembershipRequestArgs = {
  spaceId: Scalars['ID']
  spaceMembershipRequestId: Scalars['ID']
}

export type MutationDeleteAccessGroupArgs = {
  id: Scalars['ID']
}

export type MutationDeleteBadgeArgs = {
  id: Scalars['String']
}

export type MutationDeleteCollectionArgs = {
  id: Scalars['ID']
}

export type MutationDeleteMemberArgs = {
  id: Scalars['ID']
}

export type MutationDeleteMemberSchemaFieldArgs = {
  key: Scalars['String']
}

export type MutationDeleteNotificationArgs = {
  notificationId: Scalars['ID']
}

export type MutationDeleteNotificationsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>
}

export type MutationDeletePageCustomResponseArgs = {
  path: Scalars['String']
}

export type MutationDeletePermissionArgs = {
  id: Scalars['ID']
}

export type MutationDeletePostArgs = {
  id: Scalars['ID']
}

export type MutationDeletePostTypeFieldArgs = {
  id: Scalars['ID']
  key: Scalars['String']
}

export type MutationDeleteSpaceArgs = {
  id: Scalars['ID']
}

export type MutationDeleteSpacePostTypesArgs = {
  postTypeIds: Array<Scalars['ID']>
  spaceId: Scalars['ID']
}

export type MutationDeleteSsoMembershipArgs = {
  memberId: Scalars['String']
  type: SsoType
}

export type MutationDeleteTagArgs = {
  id: Scalars['ID']
}

export type MutationDeleteTemplateArgs = {
  id: Scalars['String']
}

export type MutationDoResetPasswordArgs = {
  input: UpdatePasswordWithTokenInput
}

export type MutationEditImageArgs = {
  imageId: Scalars['String']
  input: UpdateImageInput
}

export type MutationExtendCurrentTrialArgs = {
  newEndDate: Scalars['DateTime']
}

export type MutationGlobalAddAppCollaboratorArgs = {
  appId: Scalars['String']
  input: AddAppCollaboratorInput
}

export type MutationGlobalCreateAppArgs = {
  input: CreateAppInput
}

export type MutationGlobalCreateEmojisArgs = {
  input: Array<CreateEmojiInput>
}

export type MutationGlobalCreateImagesArgs = {
  input: Array<CreateImageInput>
}

export type MutationGlobalDeleteAppArgs = {
  id: Scalars['ID']
}

export type MutationGlobalDeleteAppSettingArgs = {
  context: PermissionContext
  entityId?: InputMaybe<Scalars['ID']>
  networkId: Scalars['ID']
}

export type MutationGlobalPublishAppPrivatelyArgs = {
  appId: Scalars['ID']
  networkId: Scalars['ID']
}

export type MutationGlobalRegenerateClientSecretArgs = {
  appId: Scalars['ID']
}

export type MutationGlobalRemoveAppCollaboratorArgs = {
  appId: Scalars['String']
  collaboratorId: Scalars['String']
}

export type MutationGlobalTestAppWebhookArgs = {
  appId: Scalars['ID']
  input: TestAppWebhookInput
}

export type MutationGlobalUnPublishAppPrivatelyArgs = {
  appId: Scalars['ID']
  networkId: Scalars['ID']
}

export type MutationGlobalUpdateAppArgs = {
  id: Scalars['ID']
  input: UpdateAppInput
}

export type MutationGlobalUpdateAppSettingArgs = {
  context: PermissionContext
  entityId?: InputMaybe<Scalars['ID']>
  networkId: Scalars['ID']
  settings: Scalars['String']
}

export type MutationHidePostArgs = {
  id: Scalars['ID']
}

export type MutationImpersonateLoginToNetworkArgs = {
  input: ImpersonateLoginToNetworkInput
}

export type MutationInstallAppArgs = {
  appId: Scalars['ID']
  input?: InputMaybe<InstallAppInput>
}

export type MutationInstallAppOnAuthMemberArgs = {
  appId: Scalars['ID']
  input?: InputMaybe<InstallAppInput>
}

export type MutationInteractWithAppsArgs = {
  context: PermissionContext
  entityId?: InputMaybe<Scalars['ID']>
  input: Array<InteractWithAppInput>
}

export type MutationInviteMembersArgs = {
  input: InviteMembersInput
}

export type MutationJoinNetworkArgs = {
  input: JoinNetworkInput
}

export type MutationJoinNetworkWithInvitationLinkArgs = {
  input: JoinNetworkWithLinkInput
}

export type MutationJoinNetworkWithTokenArgs = {
  input: JoinNetworkWithTokenInput
}

export type MutationJoinSpaceArgs = {
  spaceId: Scalars['ID']
}

export type MutationLeaveSpaceArgs = {
  spaceId: Scalars['ID']
}

export type MutationLoginNetworkArgs = {
  input: LoginNetworkWithPasswordInput
}

export type MutationLoginNetworkWithPasswordArgs = {
  input: LoginNetworkWithPasswordInput
}

export type MutationLoginWithSamlResponseArgs = {
  input: LoginWithSamlResponseInput
}

export type MutationLoginWithSsoCodeArgs = {
  input: LoginWithSsoCodeInput
}

export type MutationLogoutMemberSessionsArgs = {
  memberId: Scalars['String']
}

export type MutationLogoutNetworkArgs = {
  input?: InputMaybe<LogoutNetworkInput>
}

export type MutationModifySubscriptionAddonArgs = {
  priceId: Scalars['String']
  quantity: Scalars['Float']
}

export type MutationMovePostArgs = {
  convertPost?: InputMaybe<ConvertPostInput>
  id: Scalars['ID']
  sendNotification?: InputMaybe<Scalars['Boolean']>
  spaceId: Scalars['ID']
}

export type MutationMovePostsArgs = {
  convertPost?: InputMaybe<ConvertPostInput>
  ids: Array<Scalars['ID']>
  sendNotification?: InputMaybe<Scalars['Boolean']>
  spaceId: Scalars['ID']
}

export type MutationOrganizeCollectionsArgs = {
  ids: Array<Scalars['String']>
}

export type MutationOrganizeGroupSpacesArgs = {
  groupId: Scalars['String']
  spaceIds: Array<Scalars['String']>
}

export type MutationOrganizeGroupsArgs = {
  groupIds: Array<Scalars['String']>
}

export type MutationOrganizeSpacesInCollectionArgs = {
  collectionId: Scalars['String']
  spaceIds: Array<Scalars['String']>
}

export type MutationPinPostToSpaceArgs = {
  postId: Scalars['ID']
}

export type MutationPinReplyToPostArgs = {
  postId: Scalars['ID']
  replyId: Scalars['ID']
}

export type MutationPublishAppPrivatelyArgs = {
  appId: Scalars['ID']
}

export type MutationPublishTemplateArgs = {
  id: Scalars['String']
}

export type MutationPurchaseArgs = {
  input: PurchaseInput
}

export type MutationReadNotificationArgs = {
  notificationId: Scalars['ID']
}

export type MutationReadNotificationsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>
}

export type MutationReadSpaceArgs = {
  date: Scalars['DateTime']
  spaceId: Scalars['String']
}

export type MutationRemoveGroupArgs = {
  groupId?: InputMaybe<Scalars['ID']>
}

export type MutationRemoveMemberArgs = {
  memberId: Scalars['ID']
}

export type MutationRemovePostArgs = {
  postId: Scalars['ID']
}

export type MutationRemoveReactionArgs = {
  participantId?: InputMaybe<Scalars['String']>
  postId: Scalars['ID']
  reaction: Scalars['String']
}

export type MutationRemoveSpaceMembersArgs = {
  memberIds: Array<Scalars['ID']>
  spaceId: Scalars['ID']
}

export type MutationReorderMemberSchemaFieldsArgs = {
  input: Array<ReOrderSchemaFieldInput>
}

export type MutationReorderPostTypeFieldsArgs = {
  id: Scalars['ID']
  input: Array<ReOrderSchemaFieldInput>
}

export type MutationRequestGlobalTokenCodeArgs = {
  input: RequestGlobalTokenInput
}

export type MutationRequestSpaceMembershipArgs = {
  spaceId: Scalars['ID']
}

export type MutationResendGlobalTokenCodeArgs = {
  input: RequestGlobalTokenInput
}

export type MutationResendMemberInvitationArgs = {
  id: Scalars['ID']
}

export type MutationResetPasswordArgs = {
  input: ResetPasswordInput
}

export type MutationRevokeBadgeArgs = {
  id: Scalars['String']
  input: AssignOrRevokeBadgeInput
}

export type MutationRevokeMemberInvitationArgs = {
  id: Scalars['ID']
}

export type MutationRunMigrationArgs = {
  id: Scalars['String']
}

export type MutationSendResetPasswordEmailArgs = {
  email: Scalars['String']
}

export type MutationSetPrivatelyPublishedAppsArgs = {
  ids: Array<Scalars['ID']>
}

export type MutationSsoRedirectArgs = {
  input: LoginWithSsoCodeInput
}

export type MutationSupportSsoRedirectArgs = {
  input: LoginSupportWithSsoCodeInput
}

export type MutationSuspendMemberArgs = {
  memberId: Scalars['String']
}

export type MutationSyncTemplateArgs = {
  id: Scalars['String']
  upsertKey?: InputMaybe<Scalars['String']>
}

export type MutationUnArchiveMemberSchemaFieldArgs = {
  key: Scalars['String']
}

export type MutationUnPublishAppPrivatelyArgs = {
  appId: Scalars['ID']
  networkId: Scalars['ID']
}

export type MutationUnarchivePostTypeArgs = {
  id: Scalars['ID']
}

export type MutationUnarchivePostTypeFieldArgs = {
  id: Scalars['ID']
  key: Scalars['String']
}

export type MutationUnblockMemberArgs = {
  memberId: Scalars['String']
}

export type MutationUnhidePostArgs = {
  id: Scalars['ID']
}

export type MutationUninstallAppArgs = {
  appInstallationId: Scalars['ID']
  reason?: InputMaybe<Scalars['String']>
}

export type MutationUnpinPostFromSpaceArgs = {
  postId: Scalars['ID']
}

export type MutationUnpinReplyFromPostArgs = {
  postId: Scalars['ID']
  replyId: Scalars['ID']
}

export type MutationUnpublishTemplateArgs = {
  id: Scalars['String']
}

export type MutationUnsetHomepageArgs = {
  type: HomeSpaceType
}

export type MutationUnsubscribeFromNotificationArgs = {
  input: UnsubscribeWithTokenInput
}

export type MutationUnsubscribeWithTokenArgs = {
  input: UnsubscribeWithTokenInput
}

export type MutationUnsuspendMemberArgs = {
  memberId: Scalars['String']
}

export type MutationUpdateAccessGroupArgs = {
  id: Scalars['ID']
  input: UpdateAccessGroupInput
}

export type MutationUpdateAppInstallationArgs = {
  appInstallationId: Scalars['ID']
  input: UpdateAppInstallationInput
}

export type MutationUpdateAppNetworkSettingsArgs = {
  appId: Scalars['ID']
  settings: Scalars['String']
}

export type MutationUpdateAppSpaceSettingArgs = {
  appId: Scalars['ID']
  settings: Scalars['String']
  spaceId: Scalars['ID']
}

export type MutationUpdateAppStandingArgs = {
  appId: Scalars['ID']
  standing: StoreItemStanding
}

export type MutationUpdateAppStatusArgs = {
  appId: Scalars['ID']
  status: StoreItemStatus
}

export type MutationUpdateAuthMemberArgs = {
  input: UpdateMemberInput
}

export type MutationUpdateBadgeArgs = {
  id: Scalars['String']
  input: UpdateBadgeInput
}

export type MutationUpdateBillingDetailsArgs = {
  input: BillingDetailsInput
}

export type MutationUpdateCollectionArgs = {
  id: Scalars['ID']
  input: UpdateCollectionInput
}

export type MutationUpdateCustomSsoArgs = {
  input: UpdateCustomSsoInput
}

export type MutationUpdateDefaultSsoStatusArgs = {
  sso: DefaultSsoType
  status: SsoStatus
}

export type MutationUpdateFileArgs = {
  id: Scalars['String']
  input: UpdateFileInput
}

export type MutationUpdateGroupArgs = {
  groupId?: InputMaybe<Scalars['ID']>
  input: UpdateCollectionInput
}

export type MutationUpdateImageArgs = {
  id: Scalars['String']
  input: UpdateImageInput
}

export type MutationUpdateJwtSsoArgs = {
  input: UpdateJwtSsoInput
}

export type MutationUpdateMemberArgs = {
  id?: InputMaybe<Scalars['ID']>
  input: UpdateMemberInput
}

export type MutationUpdateMemberInvitationArgs = {
  id: Scalars['ID']
  input: UpdateMemberInvitationInput
}

export type MutationUpdateMemberNetworkNotificationSettingsArgs = {
  channel: NotificationChannel
  input: UpdateMemberNetworkNotificationSettingsInput
  memberId?: InputMaybe<Scalars['ID']>
}

export type MutationUpdateMemberPostNotificationSettingsArgs = {
  input: UpdateMemberPostNotificationSettingsInput
  memberId?: InputMaybe<Scalars['ID']>
  postId: Scalars['ID']
}

export type MutationUpdateMemberPrivateMessagingSettingsArgs = {
  input: UpdateMemberPrivateMessagingSettingsInput
}

export type MutationUpdateMemberSchemaFieldArgs = {
  input: UpdateCustomFieldSchemaInput
}

export type MutationUpdateMemberSpaceNotificationSettingsArgs = {
  channel: NotificationChannel
  input: UpdateMemberSpaceNotificationSettingsInput
  memberId?: InputMaybe<Scalars['ID']>
  spaceId: Scalars['ID']
}

export type MutationUpdateMemberSpaceRoleArgs = {
  input: UpdateSpaceMemberRoleInput
  memberId: Scalars['ID']
  spaceId: Scalars['ID']
}

export type MutationUpdateModerationArgs = {
  id: Scalars['ID']
  input: UpdateModerationItemInput
}

export type MutationUpdateModerationItemArgs = {
  id: Scalars['ID']
  input: UpdateModerationItemInput
}

export type MutationUpdateModerationSettingsArgs = {
  input: UpdateModerationSettingsInput
}

export type MutationUpdateNetworkArgs = {
  input: UpdateNetworkInput
}

export type MutationUpdateNetworkAvailableLocalesArgs = {
  availableLocales: Array<Scalars['String']>
}

export type MutationUpdateNetworkCustomCapacitiesArgs = {
  additionalSeats?: InputMaybe<Scalars['Int']>
  customMemberCapacity?: InputMaybe<Scalars['Int']>
}

export type MutationUpdateNetworkDomainSubfolderArgs = {
  domainSubfolder?: InputMaybe<Scalars['String']>
}

export type MutationUpdateNetworkMediaSettingsArgs = {
  input: UpdateMediaNetworkSettingsInput
}

export type MutationUpdateNetworkNotificationSettingsArgs = {
  input: UpdateNotificationNetworkSettingsInput
}

export type MutationUpdateNetworkStatusArgs = {
  input: UpdateNetworkStatusInput
}

export type MutationUpdateNewDomainArgs = {
  input: UpdateNewDomainInput
}

export type MutationUpdatePasswordWithTokenArgs = {
  input: UpdatePasswordWithTokenInput
}

export type MutationUpdatePermissionArgs = {
  id: Scalars['ID']
  input: UpdatePermissionInput
}

export type MutationUpdatePostArgs = {
  id: Scalars['ID']
  input: UpdatePostInput
}

export type MutationUpdatePostTypeArgs = {
  id: Scalars['ID']
  input: UpdatePostTypeInput
}

export type MutationUpdatePostTypeFieldArgs = {
  id: Scalars['ID']
  input: UpdateCustomFieldSchemaInput
}

export type MutationUpdatePrivateMessagingSettingsArgs = {
  input: UpdatePrivateMessagingSettingsInput
}

export type MutationUpdateSpaceArgs = {
  id: Scalars['ID']
  input: UpdateSpaceInput
}

export type MutationUpdateSpaceDefaultNotificationSettingsArgs = {
  channel: NotificationChannel
  input: UpdateSpaceDefaultNotificationSettingsInput
  spaceId: Scalars['ID']
}

export type MutationUpdateSpaceHighlightedTagsArgs = {
  input: UpdateHighlightedTags
  spaceId: Scalars['ID']
}

export type MutationUpdateSpaceMemberRoleArgs = {
  input: UpdateSpaceMemberRoleInput
  memberId: Scalars['ID']
  spaceId: Scalars['ID']
}

export type MutationUpdateSpacePostTypesArgs = {
  input: Array<UpdateSpacePostTypeInput>
  spaceId: Scalars['ID']
}

export type MutationUpdateSubscriptionIntervalArgs = {
  interval: BillingPriceInterval
}

export type MutationUpdateSubscriptionPlanArgs = {
  priceId: Scalars['String']
}

export type MutationUpdateTagArgs = {
  id: Scalars['ID']
  input: UpdateTagInput
}

export type MutationUpdateTemplateArgs = {
  id: Scalars['String']
  input: UpdateTemplateInput
}

export type MutationUploadMigrationFilesArgs = {
  baseUrl?: InputMaybe<Scalars['String']>
  changeMemberEmails?: InputMaybe<Scalars['Boolean']>
  dryRun?: InputMaybe<Scalars['Boolean']>
  members?: InputMaybe<Scalars['Upload']>
  migrationId?: InputMaybe<Scalars['String']>
  posts?: InputMaybe<Scalars['Upload']>
  spaces?: InputMaybe<Scalars['Upload']>
}

export type MutationUpsertExtraPropertyArgs = {
  input: UpsertExtraPropertyInput
}

export type MutationUpsertPageCustomResponseArgs = {
  input: UpsertPageCustomResponse
  path: Scalars['String']
}

export type MutationUpsertThemeArgs = {
  input: UpsertTheme
}

export type MutationVerifyMemberArgs = {
  input: VerifyMemberInput
}

export type NativeFieldsTemplates = {
  description?: Maybe<Scalars['String']>
  thumbnailId?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export type NativeFieldsTemplatesInput = {
  description?: InputMaybe<Scalars['String']>
  thumbnailId?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type NavigationItem = {
  link?: Maybe<Scalars['String']>
  openInNewWindow?: Maybe<Scalars['Boolean']>
  text: Scalars['String']
  type: NavigationItemType
}

export enum NavigationItemType {
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  PRIMARY_LINK = 'PRIMARY_LINK',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TEXT_LINK = 'TEXT_LINK',
}

export type NavigationSlateUpdatesInput = {
  footer?: InputMaybe<SlateUpdatesInput>
  footerDisabled?: InputMaybe<Scalars['Boolean']>
  footerFixed?: InputMaybe<Scalars['Boolean']>
  header?: InputMaybe<SlateUpdatesInput>
  headerDisabled?: InputMaybe<Scalars['Boolean']>
  headerFixed?: InputMaybe<Scalars['Boolean']>
  sidebar1?: InputMaybe<SlateUpdatesInput>
  sidebar1Disabled?: InputMaybe<Scalars['Boolean']>
  sidebar1Fixed?: InputMaybe<Scalars['Boolean']>
  sidebar2?: InputMaybe<SlateUpdatesInput>
  sidebar2Disabled?: InputMaybe<Scalars['Boolean']>
  sidebar2Fixed?: InputMaybe<Scalars['Boolean']>
}

export type NavigationSlates = {
  footer?: Maybe<Slate>
  footerDisabled?: Maybe<Scalars['Boolean']>
  footerFixed?: Maybe<Scalars['Boolean']>
  header: Slate
  headerDisabled?: Maybe<Scalars['Boolean']>
  headerFixed?: Maybe<Scalars['Boolean']>
  sidebar1: Slate
  sidebar1Disabled?: Maybe<Scalars['Boolean']>
  sidebar1Fixed?: Maybe<Scalars['Boolean']>
  sidebar2?: Maybe<Slate>
  sidebar2Disabled?: Maybe<Scalars['Boolean']>
  sidebar2Fixed?: Maybe<Scalars['Boolean']>
}

export type Network = {
  activeSso?: Maybe<ActiveSso>
  activeTheme?: Maybe<NewTheme>
  /** @deprecated Has been moved to usageLimits */
  additionalSeatsCapacity?: Maybe<Scalars['Int']>
  aliases: Array<Scalars['String']>
  authMemberProps?: Maybe<NetworkAuthMemberProps>
  availableLocales: Array<Scalars['String']>
  badges?: Maybe<Array<Badge>>
  /** @deprecated It will be stored on Stripe. */
  billingEmail?: Maybe<Scalars['String']>
  /** @deprecated Has been replaced by activeTheme */
  brandColor?: Maybe<Scalars['String']>
  /** @deprecated Has been moved to extraProperties */
  companyName?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<Member>
  createdById: Scalars['ID']
  customCodes?: Maybe<Array<CustomCode>>
  /** @deprecated Has been moved to usageLimits */
  customMemberCapacity?: Maybe<Scalars['Int']>
  customSeoDetail?: Maybe<CustomSeoDetail>
  defaultSpaces?: Maybe<Array<Space>>
  description?: Maybe<Scalars['String']>
  domain: Scalars['String']
  domainSubfolder?: Maybe<Scalars['String']>
  extraProperties?: Maybe<Array<ExtraProperty>>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  /** @deprecated Has been replaced by navigation slates */
  footer?: Maybe<Footer>
  /** @deprecated Has been moved to extraProperties */
  hideDefaultAuthenticationForm: Scalars['Boolean']
  id: Scalars['ID']
  images?: Maybe<NetworkImages>
  incidentEmails?: Maybe<Array<Scalars['String']>>
  /** @deprecated Has been moved to extraProperties */
  industry?: Maybe<NetworkIndustryType>
  /** @deprecated This field is deprecated. */
  landingPages?: Maybe<NetworkSettings>
  limits?: Maybe<NetworkLimits>
  limitsUpdatedAt?: Maybe<Scalars['DateTime']>
  locale: Scalars['String']
  logo?: Maybe<Media>
  logoId?: Maybe<Scalars['ID']>
  /** @deprecated This resolver will be replaced by limits */
  mediaLimits?: Maybe<MediaLimits>
  /** @deprecated This resolver will be replaced by settings */
  mediaSettings?: Maybe<MediaNetworkSettings>
  /**
   * Calculated member capacity
   * @deprecated Has been moved to usageLimits
   */
  memberCapacity?: Maybe<Scalars['Int']>
  /** @deprecated Has been moved to usageLimits */
  memberCapacityDeclared?: Maybe<Scalars['Int']>
  memberFields?: Maybe<CustomFieldsSchema>
  members?: Maybe<PaginatedMember>
  membersCount?: Maybe<Scalars['Int']>
  membership: NetworkMembership
  name: Scalars['String']
  navigationSlates: NavigationSlates
  newDomain?: Maybe<Scalars['String']>
  /** @deprecated This resolver will be replaced by settings */
  notificationSettings?: Maybe<NotificationNetworkSettings>
  organizationId?: Maybe<Scalars['String']>
  overUsedAt?: Maybe<Scalars['DateTime']>
  owner?: Maybe<Member>
  ownerId: Scalars['ID']
  passwordComplexity: NetworkPasswordComplexity
  planName: Scalars['String']
  postTypes?: Maybe<Array<PostType>>
  /** @deprecated Has been moved to extraProperties */
  privacyPolicyUrl?: Maybe<Scalars['String']>
  /** @deprecated Has been moved to extraProperties */
  releaseChannel?: Maybe<NetworkReleaseChannelType>
  roles?: Maybe<Array<Role>>
  /** @deprecated Has been moved to usageLimits */
  seatCapacityDeclared?: Maybe<Scalars['Int']>
  /**
   * Calculated seats capacity
   * @deprecated Has been moved to usageLimits
   */
  seatsCapacity?: Maybe<Scalars['Int']>
  settings?: Maybe<Settings>
  shortcuts?: Maybe<Array<Shortcut>>
  spaces?: Maybe<PaginatedSpace>
  status: NetworkStatus
  statusLocked: Scalars['Boolean']
  statusReason?: Maybe<StatusReason>
  /** @deprecated Use planName instead. */
  subscriptionPlan?: Maybe<Plan>
  systemSpaces?: Maybe<Array<Space>>
  /** @deprecated Has been moved to extraProperties */
  termsOfServiceUrl?: Maybe<Scalars['String']>
  /** @deprecated Has been replaced by activeTheme */
  themes?: Maybe<Themes>
  /** @deprecated Has been replaced by navigation slates */
  topNavigation?: Maybe<TopNavigation>
  tribeBranding: Scalars['Boolean']
  usages?: Maybe<NetworkUsages>
  visibility: NetworkVisibility
  whoCanInvite?: Maybe<Array<Role>>
  whoCanInviteIds: Array<Scalars['ID']>
  willUnpublishAt?: Maybe<Scalars['DateTime']>
}

export type NetworkCustomCodesArgs = {
  anonymize: Scalars['Boolean']
}

export type NetworkExtraPropertiesArgs = {
  keys?: InputMaybe<Array<Scalars['String']>>
}

export type NetworkMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<Array<MemberStatusInput>>
}

export type NetworkPostTypesArgs = {
  context?: InputMaybe<PostTypeContext>
}

export type NetworkSpacesArgs = {
  limit: Scalars['Int']
}

export type NetworkAuthMemberProps = {
  context: PermissionContext
  permissions?: Maybe<Array<ActionPermissions>>
  /** @deprecated This field will be replaced by Member.settings */
  privateMessagingEnabled?: Maybe<Scalars['Boolean']>
  scopes?: Maybe<Array<Scalars['String']>>
  totalUnreadPostsCount?: Maybe<Scalars['Int']>
}

export type NetworkAuthMemberPropsTotalUnreadPostsCountArgs = {
  type?: InputMaybe<Array<SpaceType>>
}

export type NetworkImages = {
  darkFavicon?: Maybe<Media>
  darkLogo?: Maybe<Media>
  darkMobileLogo?: Maybe<Media>
  lightFavicon?: Maybe<Media>
  lightLogo?: Maybe<Media>
  lightMobileLogo?: Maybe<Media>
}

export type NetworkImagesInput = {
  darkFaviconId?: InputMaybe<Scalars['String']>
  darkLogoId?: InputMaybe<Scalars['String']>
  darkMobileLogoId?: InputMaybe<Scalars['String']>
  lightFaviconId?: InputMaybe<Scalars['String']>
  lightLogoId?: InputMaybe<Scalars['String']>
  lightMobileLogoId?: InputMaybe<Scalars['String']>
}

export enum NetworkIndustryType {
  BloggerCoachCreator = 'BloggerCoachCreator',
  ConsultingAndAgency = 'ConsultingAndAgency',
  EcomerceAndRetail = 'EcomerceAndRetail',
  EntertainmentAndEvents = 'EntertainmentAndEvents',
  FinancianServices = 'FinancianServices',
  Healthcare = 'Healthcare',
  InternetAndOnlineService = 'InternetAndOnlineService',
  MediaAndPublishing = 'MediaAndPublishing',
  NonProfitAndAssociation = 'NonProfitAndAssociation',
  OnlineTrainingAndEducation = 'OnlineTrainingAndEducation',
  Other = 'Other',
  SoftwareAndSaas = 'SoftwareAndSaas',
}

export enum NetworkLandingPage {
  EXPLORE = 'EXPLORE',
  FEED = 'FEED',
  SPACES = 'SPACES',
}

export type NetworkLimits = {
  analyticsLimits: AnalyticsLimits
  fileSizeLimit: Scalars['Float']
  fileTypesLimit: Array<Scalars['String']>
  imageSizeLimit: Scalars['Float']
  imageTypesLimit: Array<Scalars['String']>
  usageLimits: NetworkUsageLimits
}

export enum NetworkMembership {
  inviteOnly = 'inviteOnly',
  open = 'open',
}

export enum NetworkPasswordComplexity {
  Complex = 'Complex',
  Simple = 'Simple',
  Standard = 'Standard',
}

export enum NetworkPrimaryMembersType {
  Customers = 'Customers',
  Employees = 'Employees',
  Members = 'Members',
  Other = 'Other',
  Students = 'Students',
}

export type NetworkPublicInfo = {
  domain: Scalars['String']
  domainSubfolder?: Maybe<Scalars['String']>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  images?: Maybe<NetworkImages>
  jwtSsoAuthUrls?: Maybe<JwtSsoAuthUrls>
  logo?: Maybe<Media>
  logoId?: Maybe<Scalars['ID']>
  membership: NetworkMembership
  name: Scalars['String']
  status: NetworkStatus
  systemSpaces?: Maybe<Array<Space>>
  visibility: NetworkVisibility
}

export enum NetworkReleaseChannelType {
  edge = 'edge',
  stable = 'stable',
}

export type NetworkSettings = {
  landingPageForGuest: NetworkLandingPage
  landingPageForMember: NetworkLandingPage
  landingPageForNewMember: NetworkLandingPage
}

export type NetworkSettingsInput = {
  captcha?: InputMaybe<CaptchaSettingsInput>
  contentTranslation?: InputMaybe<ContentTranslationSettingsInput>
  memberPermissions?: InputMaybe<MemberPermissionsSettingsInput>
  privateMessaging?: InputMaybe<PrivateMessagingSettingsInput>
}

export enum NetworkStatus {
  archived = 'archived',
  published = 'published',
  unpublished = 'unpublished',
}

export enum NetworkStatusChangedBy {
  admin = 'admin',
  support = 'support',
  system = 'system',
}

export enum NetworkStatusReason {
  memberCapacityExceeded = 'memberCapacityExceeded',
  networkCreated = 'networkCreated',
  networkLockLifted = 'networkLockLifted',
  seatsCapacityExceeded = 'seatsCapacityExceeded',
  trialEnded = 'trialEnded',
}

export enum NetworkTimeframeType {
  FewMonths = 'FewMonths',
  FewWeeks = 'FewWeeks',
  NotSure = 'NotSure',
  VerySoon = 'VerySoon',
}

export type NetworkUsageLimits = {
  aiSearchAccess?: Maybe<Scalars['Boolean']>
  analyticsAccess?: Maybe<Scalars['Boolean']>
  analyticsDaysLimit?: Maybe<Scalars['Float']>
  apiAccess?: Maybe<Scalars['Boolean']>
  apiRequestCapacity?: Maybe<Array<ApiRequestLimit>>
  appIds?: Maybe<Array<Scalars['String']>>
  auditLogAccess?: Maybe<Scalars['Boolean']>
  customDomain?: Maybe<Scalars['Boolean']>
  emailCustomization?: Maybe<Scalars['Boolean']>
  jwtSSOAccess?: Maybe<Scalars['Boolean']>
  membersCapacity?: Maybe<Scalars['Float']>
  monthlyEmailCapacity?: Maybe<Scalars['Float']>
  monthlyVisitorCapacity?: Maybe<Scalars['Float']>
  oauth2SSOAccess?: Maybe<Scalars['Boolean']>
  postTypesCapacity?: Maybe<Scalars['Float']>
  samlSSOAccess?: Maybe<Scalars['Boolean']>
  seatsCapacity?: Maybe<Scalars['Float']>
  spacesCapacity?: Maybe<Scalars['Float']>
  storageCapacity?: Maybe<Scalars['Float']>
  translationLocaleCapacity?: Maybe<Scalars['Float']>
}

export type NetworkUsages = {
  fileStorageUsage: Scalars['Float']
  imageStorageUsage: Scalars['Float']
  usages: NetworkUsageLimits
}

export enum NetworkVisibility {
  private = 'private',
  public = 'public',
}

export type NewTheme = {
  colorTokens?: Maybe<ThemeColorTokens>
  colors?: Maybe<ThemeColors>
  id: Scalars['String']
  name?: Maybe<Scalars['String']>
  typography?: Maybe<Array<ThemeToken>>
}

export type Notification = {
  actor?: Maybe<Payload>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  meta?: Maybe<NotificationMeta>
  object?: Maybe<Payload>
  read: Scalars['Boolean']
  space?: Maybe<Space>
  target?: Maybe<Payload>
  verb: NotificationVerb
}

export enum NotificationChannel {
  DESKTOP = 'DESKTOP',
  EMAIL = 'EMAIL',
  IN_APP = 'IN_APP',
}

export type NotificationEdge = {
  cursor: Scalars['String']
  node: Notification
}

export type NotificationMeta = {
  body?: Maybe<Scalars['String']>
  fullTitle: Scalars['String']
  reason: NotificationReason
  relativeUrl: Scalars['String']
  textBody?: Maybe<Scalars['String']>
  textFullTitle: Scalars['String']
  textTitle: Scalars['String']
  title: Scalars['String']
  url: Scalars['String']
}

export type NotificationNetworkSettings = {
  emailEnabled: Scalars['Boolean']
  emailFrom?: Maybe<Scalars['String']>
  emailNotificationEnabled: Scalars['Boolean']
}

export enum NotificationReason {
  NETWORK_ADMIN = 'NETWORK_ADMIN',
  NETWORK_SUBSCRIPTION = 'NETWORK_SUBSCRIPTION',
  POST_AUTHOR = 'POST_AUTHOR',
  POST_SUBSCRIPTION = 'POST_SUBSCRIPTION',
  SPACE_ADMIN = 'SPACE_ADMIN',
  SPACE_SUBSCRIPTION = 'SPACE_SUBSCRIPTION',
}

export enum NotificationVerb {
  COMMENT_CREATED = 'COMMENT_CREATED',
  COMMENT_DELETED = 'COMMENT_DELETED',
  COMMENT_UPDATED = 'COMMENT_UPDATED',
  JOIN_REQUEST_STATUS_UPDATED = 'JOIN_REQUEST_STATUS_UPDATED',
  MEMBER_MENTIONED = 'MEMBER_MENTIONED',
  MESSAGE_CREATED = 'MESSAGE_CREATED',
  POST_CREATED = 'POST_CREATED',
  POST_DELETED = 'POST_DELETED',
  POST_FOLLOWED = 'POST_FOLLOWED',
  POST_UPDATED = 'POST_UPDATED',
  REACTION_CREATED = 'REACTION_CREATED',
  REPLY_CREATED = 'REPLY_CREATED',
  SPACE_MEMBER_ADDED = 'SPACE_MEMBER_ADDED',
}

export type NotificationsCount = {
  new: Scalars['Float']
}

export enum NumberTypeOptions {
  integer = 'integer',
  number = 'number',
}

export type OAuthCode = {
  code: Scalars['String']
}

export type OAuthCodeInput = {
  clientId: Scalars['String']
  redirectUri: Scalars['String']
  scopes: Array<PrimaryScopes>
}

export type OAuthTokenInput = {
  code?: InputMaybe<Scalars['String']>
  refreshToken?: InputMaybe<Scalars['String']>
}

export type OAuthTokens = {
  accessToken: Scalars['String']
  expiresIn: Scalars['Float']
  memberId: Scalars['String']
  refreshToken: Scalars['String']
}

export type Page = {
  customResponse?: Maybe<PageCustomResponse>
  entity?: Maybe<PageEntity>
  seoDetail: PageSeo
  space: Space
}

export type PageCustomResponse = {
  body: Scalars['String']
  headers: Array<PageCustomResponseHeader>
  httpCode: Scalars['Int']
}

export type PageCustomResponseHeader = {
  key: Scalars['String']
  value: Scalars['String']
}

export type PageCustomResponseHeaderInput = {
  key: Scalars['String']
  value: Scalars['String']
}

export type PageDetailedCustomResponse = {
  body: Scalars['String']
  createdAt: Scalars['DateTime']
  createdById?: Maybe<Scalars['String']>
  creatorType: CreatorType
  headers: Array<PageCustomResponseHeader>
  httpCode: Scalars['Int']
  updatedAt?: Maybe<Scalars['DateTime']>
  updatedById?: Maybe<Scalars['String']>
}

export type PageDetailedCustomResponseEdge = {
  cursor: Scalars['String']
  node: PageDetailedCustomResponse
}

export type PageEntity = Collection | Member | Post

export type PageInfo = {
  endCursor?: Maybe<Scalars['String']>
  hasNextPage: Scalars['Boolean']
}

export type PageSeo = {
  additionalMeta?: Maybe<Array<PageTag>>
  description?: Maybe<Scalars['String']>
  jsonld?: Maybe<Scalars['String']>
  thumbnail?: Maybe<Media>
  title: Scalars['String']
}

export enum PageSeoTagType {
  LINK = 'LINK',
  META = 'META',
  TITLE = 'TITLE',
}

export type PageTag = {
  properties: Array<KeyValue>
  type: PageSeoTagType
}

export type PaginatedApp = {
  edges?: Maybe<Array<AppEdge>>
  nodes?: Maybe<Array<App>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedAppInstallation = {
  edges?: Maybe<Array<AppInstallationEdge>>
  nodes?: Maybe<Array<AppInstallation>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedDynamicBlock = {
  edges?: Maybe<Array<DynamicBlockEdge>>
  nodes?: Maybe<Array<DynamicBlock>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedEmailLog = {
  edges?: Maybe<Array<EmailLogEdge>>
  nodes?: Maybe<Array<EmailLog>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedExport = {
  edges?: Maybe<Array<ExportEdge>>
  nodes?: Maybe<Array<Export>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedMember = {
  edges?: Maybe<Array<MemberEdge>>
  nodes?: Maybe<Array<Member>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedMemberInvitation = {
  edges?: Maybe<Array<MemberInvitationEdge>>
  nodes?: Maybe<Array<MemberInvitation>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedModeration = {
  edges?: Maybe<Array<ModerationItemEdge>>
  nodes?: Maybe<Array<ModerationItem>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedModerationItemReporter = {
  edges?: Maybe<Array<ModerationItemReporterEdge>>
  nodes?: Maybe<Array<ModerationItemReporter>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedNetwork = {
  edges?: Maybe<Array<PluralNetworkEdge>>
  nodes?: Maybe<Array<PluralNetwork>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedNotification = {
  edges?: Maybe<Array<NotificationEdge>>
  nodes?: Maybe<Array<Notification>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedPageCustomResponse = {
  edges?: Maybe<Array<PageDetailedCustomResponseEdge>>
  nodes?: Maybe<Array<PageDetailedCustomResponse>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedPluralMember = {
  edges?: Maybe<Array<PluralMemberEdge>>
  nodes?: Maybe<Array<PluralMember>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedPost = {
  edges?: Maybe<Array<PostEdge>>
  nodes?: Maybe<Array<Post>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedPostReactionParticipant = {
  edges?: Maybe<Array<PostReactionParticipantEdge>>
  nodes?: Maybe<Array<PostReactionParticipant>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedPostType = {
  edges?: Maybe<Array<PostTypeEdge>>
  nodes?: Maybe<Array<PostType>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedSpace = {
  edges?: Maybe<Array<SpaceEdge>>
  nodes?: Maybe<Array<Space>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedSpaceJoinRequest = {
  edges?: Maybe<Array<SpaceJoinRequestEdge>>
  nodes?: Maybe<Array<SpaceJoinRequest>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedSpaceMember = {
  edges?: Maybe<Array<SpaceMemberEdge>>
  nodes?: Maybe<Array<SpaceMember>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedSpacePostType = {
  edges?: Maybe<Array<SpacePostTypeEdge>>
  nodes?: Maybe<Array<SpacePostType>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedTag = {
  edges?: Maybe<Array<TagEdge>>
  nodes?: Maybe<Array<Tag>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PaginatedTemplate = {
  edges?: Maybe<Array<TemplateEdge>>
  nodes?: Maybe<Array<Template>>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type PasswordComplexity = {
  complex: Scalars['Boolean']
}

export type PathPermissions = {
  isAuthorized: IsAuthorized
  path: Scalars['String']
}

export type Payload = {
  id: Scalars['ID']
  media?: Maybe<Media>
  member?: Maybe<Member>
  name?: Maybe<Scalars['String']>
  post?: Maybe<Post>
  space?: Maybe<Space>
  summary?: Maybe<Scalars['String']>
  type: PayloadType
}

export enum PayloadType {
  JOIN_REQUEST_STATUS = 'JOIN_REQUEST_STATUS',
  MEMBER = 'MEMBER',
  NETWORK = 'NETWORK',
  POST = 'POST',
  REACTION = 'REACTION',
  SPACE = 'SPACE',
}

export type Permission = {
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  scopes: Array<Scalars['String']>
}

export enum PermissionContext {
  MEMBER = 'MEMBER',
  NETWORK = 'NETWORK',
  POST = 'POST',
  SPACE = 'SPACE',
}

export type Permissions = {
  actions: Array<ActionPermissions>
  contextAwareActions: Array<ContextPermissions>
}

export type PermissionsContextInput = {
  context: PermissionContext
  ids: Array<Scalars['String']>
}

export enum PinnedInto {
  member = 'member',
  network = 'network',
  post = 'post',
  space = 'space',
}

export type Plan = {
  createdAt: Scalars['DateTime']
  endDate?: Maybe<Scalars['DateTime']>
  extendable: Scalars['Boolean']
  memberCapacity: Scalars['Int']
  name: PlanName
  renewDate?: Maybe<Scalars['DateTime']>
  renewalType: PlanRenewalType
  seatCapacity: Scalars['Int']
  startDate: Scalars['DateTime']
  trial: Scalars['Boolean']
}

export enum PlanName {
  Advanced = 'Advanced',
  Basic = 'Basic',
  Enterprise = 'Enterprise',
  Plus = 'Plus',
  PlusLegacy = 'PlusLegacy',
  Premium = 'Premium',
  PremiumLegacy = 'PremiumLegacy',
  basic = 'basic',
  enterprise = 'enterprise',
  plus = 'plus',
  premium = 'premium',
}

export enum PlanRenewalType {
  month = 'month',
  year = 'year',
}

export type PluralMember = {
  activeSession?: Maybe<MemberSession>
  /** @deprecated Has been replaced by locale field */
  attributes: MemberAttributes
  authMemberProps?: Maybe<MemberAuthMemberProps>
  badges?: Maybe<Array<MemberBadge>>
  banner?: Maybe<Media>
  bannerId?: Maybe<Scalars['ID']>
  blockedMemberIds?: Maybe<Array<Scalars['String']>>
  blockedMembers?: Maybe<Array<Member>>
  createdAt: Scalars['DateTime']
  /** @deprecated Has been replaced with name */
  displayName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  emailStatus?: Maybe<MemberEmailStatus>
  externalId?: Maybe<Scalars['ID']>
  extraProperties?: Maybe<Array<ExtraProperty>>
  fields?: Maybe<Array<CustomField>>
  flagged: Scalars['Boolean']
  id: Scalars['ID']
  lastSeen?: Maybe<Scalars['DateTime']>
  lastSeenAt?: Maybe<Scalars['DateTime']>
  locale: Scalars['String']
  name?: Maybe<Scalars['String']>
  network?: Maybe<Network>
  networkId: Scalars['ID']
  newEmail?: Maybe<Scalars['String']>
  overrideTeammate: Scalars['Boolean']
  profilePicture?: Maybe<Media>
  profilePictureId?: Maybe<Scalars['ID']>
  relativeUrl?: Maybe<Scalars['String']>
  role?: Maybe<Role>
  roleId: Scalars['ID']
  score?: Maybe<Scalars['Int']>
  sessions?: Maybe<Array<MemberSession>>
  settings?: Maybe<MemberSettings>
  shortcuts?: Maybe<Array<Shortcut>>
  spaces?: Maybe<PaginatedSpace>
  staffReasons?: Maybe<Array<StaffReason>>
  status: MemberStatus
  tagline?: Maybe<Scalars['String']>
  teammate: Scalars['Boolean']
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
  username: Scalars['String']
  verifiedAt?: Maybe<Scalars['DateTime']>
}

export type PluralMemberExtraPropertiesArgs = {
  keys?: InputMaybe<Array<Scalars['String']>>
}

export type PluralMemberSpacesArgs = {
  exploreOnly?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
}

export type PluralMemberEdge = {
  cursor: Scalars['String']
  node: PluralMember
}

export type PluralNetwork = {
  activeSso?: Maybe<ActiveSso>
  activeTheme?: Maybe<NewTheme>
  /** @deprecated Has been moved to usageLimits */
  additionalSeatsCapacity?: Maybe<Scalars['Int']>
  aliases: Array<Scalars['String']>
  authMemberProps?: Maybe<NetworkAuthMemberProps>
  availableLocales: Array<Scalars['String']>
  badges?: Maybe<Array<Badge>>
  /** @deprecated It will be stored on Stripe. */
  billingEmail?: Maybe<Scalars['String']>
  /** @deprecated Has been replaced by activeTheme */
  brandColor?: Maybe<Scalars['String']>
  /** @deprecated Has been moved to extraProperties */
  companyName?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<Member>
  createdById: Scalars['ID']
  customCodes?: Maybe<Array<CustomCode>>
  /** @deprecated Has been moved to usageLimits */
  customMemberCapacity?: Maybe<Scalars['Int']>
  customSeoDetail?: Maybe<CustomSeoDetail>
  defaultSpaces?: Maybe<Array<Space>>
  description?: Maybe<Scalars['String']>
  domain: Scalars['String']
  domainSubfolder?: Maybe<Scalars['String']>
  extraProperties?: Maybe<Array<ExtraProperty>>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  /** @deprecated Has been replaced by navigation slates */
  footer?: Maybe<Footer>
  globalFavicon?: Maybe<Media>
  globalLogo?: Maybe<Media>
  /** @deprecated Has been moved to extraProperties */
  hideDefaultAuthenticationForm: Scalars['Boolean']
  id: Scalars['ID']
  images?: Maybe<NetworkImages>
  incidentEmails?: Maybe<Array<Scalars['String']>>
  /** @deprecated Has been moved to extraProperties */
  industry?: Maybe<NetworkIndustryType>
  /** @deprecated This field is deprecated. */
  landingPages?: Maybe<NetworkSettings>
  limits?: Maybe<NetworkLimits>
  limitsUpdatedAt?: Maybe<Scalars['DateTime']>
  locale: Scalars['String']
  logo?: Maybe<Media>
  logoId?: Maybe<Scalars['ID']>
  /** @deprecated This resolver will be replaced by limits */
  mediaLimits?: Maybe<MediaLimits>
  /** @deprecated This resolver will be replaced by settings */
  mediaSettings?: Maybe<MediaNetworkSettings>
  /**
   * Calculated member capacity
   * @deprecated Has been moved to usageLimits
   */
  memberCapacity?: Maybe<Scalars['Int']>
  /** @deprecated Has been moved to usageLimits */
  memberCapacityDeclared?: Maybe<Scalars['Int']>
  memberFields?: Maybe<CustomFieldsSchema>
  members?: Maybe<PaginatedMember>
  membersCount?: Maybe<Scalars['Int']>
  membership: NetworkMembership
  name: Scalars['String']
  navigationSlates: NavigationSlates
  newDomain?: Maybe<Scalars['String']>
  /** @deprecated This resolver will be replaced by settings */
  notificationSettings?: Maybe<NotificationNetworkSettings>
  organizationId?: Maybe<Scalars['String']>
  overUsedAt?: Maybe<Scalars['DateTime']>
  owner?: Maybe<Member>
  ownerId: Scalars['ID']
  passwordComplexity: NetworkPasswordComplexity
  planName: Scalars['String']
  postTypes?: Maybe<Array<PostType>>
  /** @deprecated Has been moved to extraProperties */
  privacyPolicyUrl?: Maybe<Scalars['String']>
  /** @deprecated Has been moved to extraProperties */
  releaseChannel?: Maybe<NetworkReleaseChannelType>
  roles?: Maybe<Array<Role>>
  /** @deprecated Has been moved to usageLimits */
  seatCapacityDeclared?: Maybe<Scalars['Int']>
  /**
   * Calculated seats capacity
   * @deprecated Has been moved to usageLimits
   */
  seatsCapacity?: Maybe<Scalars['Int']>
  settings?: Maybe<Settings>
  shortcuts?: Maybe<Array<Shortcut>>
  spaces?: Maybe<PaginatedSpace>
  status: NetworkStatus
  statusLocked: Scalars['Boolean']
  statusReason?: Maybe<StatusReason>
  /** @deprecated Use planName instead. */
  subscriptionPlan?: Maybe<Plan>
  systemSpaces?: Maybe<Array<Space>>
  /** @deprecated Has been moved to extraProperties */
  termsOfServiceUrl?: Maybe<Scalars['String']>
  /** @deprecated Has been replaced by activeTheme */
  themes?: Maybe<Themes>
  /** @deprecated Has been replaced by navigation slates */
  topNavigation?: Maybe<TopNavigation>
  tribeBranding: Scalars['Boolean']
  usages?: Maybe<NetworkUsages>
  visibility: NetworkVisibility
  whoCanInvite?: Maybe<Array<Role>>
  whoCanInviteIds: Array<Scalars['ID']>
  willUnpublishAt?: Maybe<Scalars['DateTime']>
}

export type PluralNetworkCustomCodesArgs = {
  anonymize: Scalars['Boolean']
}

export type PluralNetworkExtraPropertiesArgs = {
  keys?: InputMaybe<Array<Scalars['String']>>
}

export type PluralNetworkMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<Array<MemberStatusInput>>
}

export type PluralNetworkPostTypesArgs = {
  context?: InputMaybe<PostTypeContext>
}

export type PluralNetworkSpacesArgs = {
  limit: Scalars['Int']
}

export type PluralNetworkEdge = {
  cursor: Scalars['String']
  node: PluralNetwork
}

export type Post = {
  /** @deprecated Use allowedReactions instead. */
  allowedEmojis?: Maybe<Array<Scalars['String']>>
  allowedReactions?: Maybe<Array<Scalars['String']>>
  attachmentIds: Array<Scalars['ID']>
  attachments?: Maybe<Array<File>>
  authMemberProps?: Maybe<PostAuthMemberProps>
  contentSummary?: Maybe<PostContentSummary>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<SpaceMember>
  createdById: Scalars['ID']
  customSeoDetail?: Maybe<CustomSeoDetail>
  description?: Maybe<Scalars['String']>
  embedIds: Array<Scalars['String']>
  embeds?: Maybe<Array<Embed>>
  externalId?: Maybe<Scalars['ID']>
  fields?: Maybe<Array<CustomField>>
  followersCount?: Maybe<Scalars['Int']>
  /** @deprecated Use forbiddenReactions instead. */
  forbiddenEmojis?: Maybe<Array<Scalars['String']>>
  forbiddenReactions?: Maybe<Array<Scalars['String']>>
  hasMoreContent: Scalars['Boolean']
  id: Scalars['ID']
  imageIds: Array<Scalars['ID']>
  images?: Maybe<Array<Media>>
  isAnonymous: Scalars['Boolean']
  isHidden?: Maybe<Scalars['Boolean']>
  language?: Maybe<Scalars['String']>
  lastActivityAt?: Maybe<Scalars['DateTime']>
  lastActivityDetail?: Maybe<PostLastActivityDetail>
  /** Whether the post is locked */
  locked: Scalars['Boolean']
  /** @deprecated This field is going to be deprecated in favor of "fields" */
  mappingFields?: Maybe<Array<PostMappingField>>
  mentionedMembers: Array<Scalars['String']>
  mentions?: Maybe<Array<Member>>
  /** @deprecated There are no negative reactions anymore. */
  negativeReactions?: Maybe<Array<Scalars['String']>>
  /** @deprecated There are no positive reactions anymore. */
  negativeReactionsCount?: Maybe<Scalars['Int']>
  networkId: Scalars['ID']
  owner?: Maybe<SpaceMember>
  ownerId: Scalars['ID']
  pinnedInto: Array<PinnedInto>
  pinnedReplies?: Maybe<Array<Post>>
  /** @deprecated There are no positive reactions anymore. */
  positiveReactions?: Maybe<Array<Scalars['String']>>
  /** @deprecated There are no positive reactions anymore. */
  positiveReactionsCount?: Maybe<Scalars['Int']>
  postType?: Maybe<PostType>
  postTypeId: Scalars['ID']
  /** @deprecated Use allowedReactions instead. */
  primaryReactionType?: Maybe<ReactionType>
  publishedAt?: Maybe<Scalars['DateTime']>
  reactions?: Maybe<Array<PostReactionDetail>>
  reactionsCount: Scalars['Int']
  relativeUrl?: Maybe<Scalars['String']>
  repliedTo?: Maybe<Post>
  repliedToId?: Maybe<Scalars['ID']>
  repliedToIds?: Maybe<Array<Scalars['String']>>
  repliedTos?: Maybe<Array<Post>>
  replies?: Maybe<PaginatedPost>
  repliesCount: Scalars['Int']
  seoDetail: PostSeoDetail
  shortContent?: Maybe<Scalars['String']>
  shortcuts?: Maybe<Array<Shortcut>>
  singleChoiceReactions?: Maybe<Array<Scalars['String']>>
  slug?: Maybe<Scalars['String']>
  space?: Maybe<Space>
  spaceId: Scalars['ID']
  status: PostStatus
  tagIds?: Maybe<Array<Scalars['String']>>
  tags?: Maybe<Array<Tag>>
  textContent?: Maybe<Scalars['String']>
  thumbnail?: Maybe<Media>
  thumbnailId?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  topRepliers: Array<PostTopReplier>
  /** @deprecated This is replaced by tagIds. */
  topicIds?: Maybe<Array<Scalars['String']>>
  totalRepliesCount: Scalars['Int']
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
}

export type PostContentSummaryArgs = {
  format?: ShortContentFormat
  length?: Scalars['Int']
}

export type PostRepliesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  excludePins?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  orderByString?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type PostShortContentArgs = {
  format?: ShortContentFormat
  length?: InputMaybe<Scalars['Int']>
}

export type PostAuthMemberProps = {
  availableReplyTypes?: Maybe<Array<PostType>>
  canReact?: Maybe<Scalars['Boolean']>
  context: PermissionContext
  memberPostNotificationSettingsEnabled?: Maybe<Scalars['Boolean']>
  permissions?: Maybe<Array<ActionPermissions>>
  scopes?: Maybe<Array<Scalars['String']>>
}

export type PostContentSummary = {
  hasMoreContent: Scalars['Boolean']
  summary: Scalars['String']
}

export type PostEdge = {
  cursor: Scalars['String']
  node: Post
}

export enum PostFieldsEnum {
  boolean1 = 'boolean1',
  boolean2 = 'boolean2',
  boolean3 = 'boolean3',
  boolean4 = 'boolean4',
  boolean5 = 'boolean5',
  date1 = 'date1',
  date2 = 'date2',
  date3 = 'date3',
  date4 = 'date4',
  date5 = 'date5',
  html1 = 'html1',
  html2 = 'html2',
  html3 = 'html3',
  html4 = 'html4',
  html5 = 'html5',
  html6 = 'html6',
  html7 = 'html7',
  html8 = 'html8',
  html9 = 'html9',
  html10 = 'html10',
  image1 = 'image1',
  image2 = 'image2',
  image3 = 'image3',
  image4 = 'image4',
  image5 = 'image5',
  number1 = 'number1',
  number2 = 'number2',
  number3 = 'number3',
  number4 = 'number4',
  number5 = 'number5',
  numberArray1 = 'numberArray1',
  numberArray2 = 'numberArray2',
  numberArray3 = 'numberArray3',
  numberArray4 = 'numberArray4',
  numberArray5 = 'numberArray5',
  text1 = 'text1',
  text2 = 'text2',
  text3 = 'text3',
  text4 = 'text4',
  text5 = 'text5',
  text6 = 'text6',
  text7 = 'text7',
  text8 = 'text8',
  text9 = 'text9',
  text10 = 'text10',
  textArray1 = 'textArray1',
  textArray2 = 'textArray2',
  textArray3 = 'textArray3',
  textArray4 = 'textArray4',
  textArray5 = 'textArray5',
}

export type PostLastActivityDetail = {
  entity?: Maybe<PostLastActivityEntity>
  entityId: Scalars['ID']
  entityType: PostLastActivityEntityType
}

export type PostLastActivityEntity = Post | PostReactionParticipant

export enum PostLastActivityEntityType {
  Reaction = 'Reaction',
  Reply = 'Reply',
}

export enum PostListFilterByEnum {
  boolean1 = 'boolean1',
  boolean2 = 'boolean2',
  boolean3 = 'boolean3',
  boolean4 = 'boolean4',
  boolean5 = 'boolean5',
  createdAt = 'createdAt',
  date1 = 'date1',
  date2 = 'date2',
  date3 = 'date3',
  date4 = 'date4',
  date5 = 'date5',
  number1 = 'number1',
  number2 = 'number2',
  number3 = 'number3',
  number4 = 'number4',
  number5 = 'number5',
  publishedAt = 'publishedAt',
  updatedAt = 'updatedAt',
}

export type PostListFilterByInput = {
  key?: InputMaybe<PostListFilterByEnum>
  keyString?: InputMaybe<Scalars['String']>
  operator?: InputMaybe<PostListFilterByOperator>
  value: Scalars['String']
}

export enum PostListFilterByOperator {
  contains = 'contains',
  endsWith = 'endsWith',
  equals = 'equals',
  gt = 'gt',
  gte = 'gte',
  hasValue = 'hasValue',
  in = 'in',
  lt = 'lt',
  lte = 'lte',
  nin = 'nin',
  not = 'not',
  startsWith = 'startsWith',
}

export enum PostListOrderByEnum {
  boolean1 = 'boolean1',
  boolean2 = 'boolean2',
  boolean3 = 'boolean3',
  boolean4 = 'boolean4',
  boolean5 = 'boolean5',
  createdAt = 'createdAt',
  date1 = 'date1',
  date2 = 'date2',
  date3 = 'date3',
  date4 = 'date4',
  date5 = 'date5',
  lastActivityAt = 'lastActivityAt',
  number1 = 'number1',
  number2 = 'number2',
  number3 = 'number3',
  number4 = 'number4',
  number5 = 'number5',
  publishedAt = 'publishedAt',
  reactionsCount = 'reactionsCount',
  repliesCount = 'repliesCount',
  text1 = 'text1',
  text2 = 'text2',
  text3 = 'text3',
  text4 = 'text4',
  text5 = 'text5',
  totalRepliesCount = 'totalRepliesCount',
  updatedAt = 'updatedAt',
}

export type PostMappingField = {
  key: Scalars['String']
  type: PostMappingTypeEnum
  value: Scalars['String']
}

export type PostMappingFieldInput = {
  key: Scalars['String']
  type: PostMappingTypeEnum
  value: Scalars['String']
}

export enum PostMappingTypeEnum {
  boolean = 'boolean',
  date = 'date',
  html = 'html',
  image = 'image',
  number = 'number',
  numberArray = 'numberArray',
  text = 'text',
  textArray = 'textArray',
}

export type PostReactionDetail = {
  count: Scalars['Int']
  participants?: Maybe<PaginatedPostReactionParticipant>
  reacted: Scalars['Boolean']
  reaction: Scalars['String']
}

export type PostReactionDetailParticipantsArgs = {
  limit: Scalars['Int']
}

export type PostReactionParticipant = {
  participant?: Maybe<Member>
  reaction?: Maybe<PostReactionDetail>
}

export type PostReactionParticipantEdge = {
  cursor: Scalars['String']
  node: PostReactionParticipant
}

export type PostSeoDetail = {
  description?: Maybe<Scalars['String']>
  image?: Maybe<Scalars['String']>
  title: Scalars['String']
}

export enum PostStatus {
  ARCHIVED = 'ARCHIVED',
  BLOCKED = 'BLOCKED',
  DELETED = 'DELETED',
  DRAFTED = 'DRAFTED',
  PUBLISHED = 'PUBLISHED',
}

export type PostTopReplier = {
  member?: Maybe<Member>
  repliesCount: Scalars['Int']
}

export type PostType = {
  actions?: Maybe<Array<PostTypeAction>>
  /** @deprecated Use allowedReactions instead. */
  allowedEmojis?: Maybe<Array<Scalars['String']>>
  allowedReactions?: Maybe<Array<Scalars['String']>>
  archived: Scalars['Boolean']
  authMemberProps?: Maybe<PostTypeAuthMemberProps>
  context: PostTypeContext
  createdAt: Scalars['DateTime']
  customReactions?: Maybe<Array<CustomReaction>>
  description?: Maybe<Scalars['String']>
  excludedNativeShortcuts?: Maybe<Array<Scalars['String']>>
  /** @deprecated Use forbiddenReactions instead. */
  forbiddenEmojis?: Maybe<Array<Scalars['String']>>
  forbiddenReactions?: Maybe<Array<Scalars['String']>>
  icon?: Maybe<Media>
  iconId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  languageTemplate?: Maybe<Scalars['String']>
  layout: Scalars['String']
  /** @deprecated This field is going to be deprecated in favor of "postFields" */
  mappings?: Maybe<Array<PostTypeMapping>>
  name: Scalars['String']
  nativeFieldsTemplates?: Maybe<NativeFieldsTemplates>
  /** @deprecated There are no negative reactions anymore. */
  negativeReactions?: Maybe<Array<Scalars['String']>>
  pluralName: Scalars['String']
  /** @deprecated There are no positive reactions anymore. */
  positiveReactions?: Maybe<Array<Scalars['String']>>
  postFields?: Maybe<CustomFieldsSchema>
  /** @deprecated Use allowedReactions instead. */
  primaryReactionType?: Maybe<ReactionType>
  recommendationsSettings?: Maybe<PostTypeRecommendationSettings>
  shortContentTemplate?: Maybe<Scalars['String']>
  singleChoiceReactions?: Maybe<Array<Scalars['String']>>
  slate: Slate
  slug: Scalars['String']
  titleTemplate?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  validReplyTypes?: Maybe<Array<PostType>>
}

export type PostTypeAction = {
  props?: Maybe<Scalars['String']>
  shortcutKey: Scalars['String']
}

export type PostTypeAuthMemberProps = {
  availableSpaces?: Maybe<Array<Space>>
  context: PermissionContext
  permissions?: Maybe<Array<ActionPermissions>>
  scopes?: Maybe<Array<Scalars['String']>>
}

export enum PostTypeContext {
  post = 'post',
  reply = 'reply',
}

export type PostTypeEdge = {
  cursor: Scalars['String']
  node: PostType
}

export type PostTypeMapping = {
  default?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  field: PostFieldsEnum
  isMainContent?: Maybe<Scalars['Boolean']>
  isSearchable?: Maybe<Scalars['Boolean']>
  key: Scalars['String']
  required?: Maybe<Scalars['Boolean']>
  title?: Maybe<Scalars['String']>
  type: PostMappingTypeEnum
}

export type PostTypeRecommendationSettings = {
  fields: Array<Scalars['String']>
  sourceSelf?: Maybe<Scalars['Boolean']>
  sourceSpaces?: Maybe<Array<Scalars['String']>>
}

export type PostTypeRecommendationSettingsInput = {
  fields: Array<Scalars['String']>
  sourceSelf?: InputMaybe<Scalars['Boolean']>
  sourceSpaces?: InputMaybe<Array<Scalars['String']>>
}

export type Price = {
  currency: Scalars['String']
  formattedValue: Scalars['String']
  value: Scalars['Float']
}

export enum PrimaryScopes {
  CreateContent = 'CreateContent',
  DeleteAuthMember = 'DeleteAuthMember',
  DeleteContent = 'DeleteContent',
  DeleteMember = 'DeleteMember',
  DeleteNetwork = 'DeleteNetwork',
  FindAuthMember = 'FindAuthMember',
  FindContent = 'FindContent',
  FindNetwork = 'FindNetwork',
  FullAccess = 'FullAccess',
  InviteMember = 'InviteMember',
  JoinNetwork = 'JoinNetwork',
  UpdateAuthMember = 'UpdateAuthMember',
  UpdateBilling = 'UpdateBilling',
  UpdateContent = 'UpdateContent',
  UpdateMember = 'UpdateMember',
  UpdateModeration = 'UpdateModeration',
  UpdateNetwork = 'UpdateNetwork',
  UpdateNetworkTemplate = 'UpdateNetworkTemplate',
  UpdateReport = 'UpdateReport',
  ViewAuthMember = 'ViewAuthMember',
  ViewContent = 'ViewContent',
  ViewMember = 'ViewMember',
  ViewNetwork = 'ViewNetwork',
  ViewReport = 'ViewReport',
}

/** Input for creating a private message. */
export type PrivateMessageInput = {
  memberIds?: InputMaybe<Array<Scalars['String']>>
}

export type PrivateMessagingSettings = {
  membersCanTurnOffPrivateMessaging: Scalars['Boolean']
  membersCanUsePrivateMessaging: Scalars['Boolean']
  privateMessagingEnabled: Scalars['Boolean']
}

export type PrivateMessagingSettingsInput = {
  membersCanTurnOffPrivateMessaging: Scalars['Boolean']
  membersCanUsePrivateMessaging: Scalars['Boolean']
  privateMessagingEnabled: Scalars['Boolean']
}

export type Product = {
  description: Scalars['String']
  features: Array<Scalars['String']>
  name: Scalars['String']
  prices?: Maybe<Array<ProductPrice>>
  seatCapacity: Scalars['Int']
}

export type ProductPrice = {
  additionalSeatPrice: Price
  planPrice: Price
  renewalType: PlanRenewalType
}

export type PurchaseInput = {
  billingDetails?: InputMaybe<BillingDetailsInput>
  planName: PlanName
  promotionCode?: InputMaybe<Scalars['String']>
  renewalType: PlanRenewalType
  seats: Scalars['Int']
}

export type Query = {
  accessGroup: AccessGroup
  accessGroups: Array<AccessGroup>
  activityLogs: Array<ReportRecord>
  analytics: Array<AnalyticsResponse>
  apiUsage: Array<ApiUsage>
  app: App
  apps: PaginatedApp
  authMember: Member
  authMemberAppInstallation: AppInstallation
  authMemberAppInstallations: PaginatedAppInstallation
  availableDynamicBlocks: Array<DynamicBlock>
  /** @deprecated Use new billing APIs */
  baskets: Array<Basket>
  /** @deprecated Use new billing APIs */
  billingDetails?: Maybe<BillingDetails>
  billingProducts: BillingProducts
  /** @deprecated Use new billing APIs */
  cancelSubscription?: Maybe<Action>
  /** @deprecated This query will be replaced by domainAvailability */
  checkDomainAvailability: DomainAvailability
  /** @deprecated This query will be replaced by emailAvailability */
  checkEmailAvailability: EmailAvailability
  /** @deprecated This query will be replaced by invitationLinkValidity */
  checkInvitationLinkValidity: MemberInvitationLink
  /** @deprecated This query will be replaced by memberInvitationValidity */
  checkMemberInvitationValidity: MemberInvitation
  /** @deprecated This query will be replaced by newDomainStatus */
  checkNewDomainStatus: DomainTransferStatus
  /** @deprecated This query will be replaced by passwordComplexity */
  checkPasswordComplexity: PasswordComplexity
  /** @deprecated This query will be replaced by usernameAvailability */
  checkUsernameAvailability: UsernameAvailability
  collection: Collection
  collections: Array<Collection>
  domainAvailability: DomainAvailability
  dynamicBlock: DynamicBlock
  dynamicBlockByKey: DynamicBlock
  dynamicBlocks: PaginatedDynamicBlock
  emailAvailability: EmailAvailability
  emailLogs: PaginatedEmailLog
  embed: Embed
  exploreSpaces: PaginatedSpace
  exportMemberRequest: Export
  exportMemberRequests: PaginatedExport
  extraProperties: Array<ExtraProperty>
  feed: PaginatedPost
  /** @deprecated This query will be replaced by app */
  getAppById: App
  /** @deprecated This query will be replaced by app */
  getAppBySlug: App
  getAppNetworkSettings: Scalars['String']
  getAppSpaceSettings: Scalars['String']
  /** @deprecated This query will be replaced by apps */
  getApps: PaginatedApp
  /** @deprecated This query will be replaced by authMember */
  getAuthMember: Member
  /** @deprecated This query will be replaced by embed */
  getEmbed: Embed
  /** @deprecated This query will be replaced by feed */
  getFeed: PaginatedPost
  /** @deprecated This query will be replaced by collection */
  getGroup: Collection
  /** @deprecated This query will be replaced by collections */
  getGroups: Array<Collection>
  /** @deprecated This query will be replaced by media */
  getMedia: Media
  /** @deprecated This query will be replaced by member */
  getMember: Member
  /** @deprecated Use authMemberAppInstallations instead */
  getMemberAppInstallations: PaginatedAppInstallation
  /** @deprecated This query will be replaced by memberInvitation */
  getMemberInvitation: MemberInvitation
  /** @deprecated This query will be replaced by memberInvitationLink */
  getMemberInvitationLink: MemberInvitationLink
  /** @deprecated This query will be replaced by memberInvitations */
  getMemberInvitations: PaginatedMemberInvitation
  /** @deprecated This query will be replaced by memberNotificationSettings */
  getMemberNetworkNotificationSettings: Array<MemberNetworkNotificationSettings>
  /** @deprecated This query will be replaced by memberNotificationSettings */
  getMemberNotificationSettings: MemberNotificationSettings
  /** @deprecated This query will be replaced by memberPosts */
  getMemberPosts: PaginatedPost
  /** @deprecated This query will be replaced by memberNotificationSettings */
  getMemberSpaceNotificationSettings: Array<MemberSpaceNotificationSettings>
  /** @deprecated This query will be replaced by memberSpaces */
  getMemberSpaces: PaginatedSpaceMember
  /** @deprecated This query will be replaced by members */
  getMembers: PaginatedMember
  /** @deprecated This query will be replaced by moderationItem */
  getModerationById: ModerationItem
  /** @deprecated This query will be replaced by moderationItemReporters */
  getModerationReporters: PaginatedModerationItemReporter
  /** @deprecated This query will be replaced by moderationSettings */
  getModerationSetting: ModerationSettings
  /** @deprecated This query will be replaced by moderationItems */
  getModerations: PaginatedModeration
  /** @deprecated This query will be replaced by network */
  getNetwork: Network
  /** @deprecated Use networkAppInstallations instead */
  getNetworkAppInstallations: PaginatedAppInstallation
  /** @deprecated This query will be replaced by networkApps */
  getNetworkApps: Array<App>
  /** @deprecated This query will be replaced by networkPublicInfo */
  getNetworkPublicInfo: NetworkPublicInfo
  /** @deprecated This query will be replaced by networks */
  getNetworks: PaginatedNetwork
  /** @deprecated This query will be replaced by notifications */
  getNotifications: PaginatedNotification
  /** @deprecated This query will be replaced by notificationsCount */
  getNotificationsCount: NotificationsCount
  /** @deprecated This query will be replaced by post */
  getPost: Post
  /** @deprecated We no longer support app installation on space */
  getPostAppInstallations: PaginatedAppInstallation
  /** @deprecated This query will be replaced by postReactionParticipants */
  getPostReactionParticipants: PaginatedPostReactionParticipant
  /** @deprecated This query will be replaced by posts */
  getPosts: PaginatedPost
  /** @deprecated This query will be replaced by replies */
  getReplies: PaginatedPost
  /** @deprecated This query is replaced by analytics */
  getReport: Report
  /** @deprecated This query will be replaced by roles */
  getRoles: Array<Role>
  /** @deprecated This query will be replaced by scopes */
  getScopes: Scopes
  /** @deprecated This query will be replaced by space */
  getSpace: Space
  /** @deprecated We no longer support app installation on space */
  getSpaceAppInstallations: PaginatedAppInstallation
  /** @deprecated This query will be replaced by spaceMembers */
  getSpaceMembers: PaginatedSpaceMember
  /** @deprecated This query will be replaced by memberSpaceMembershipRequest */
  getSpaceMembershipRequestForMember: Array<SpaceJoinRequest>
  /** @deprecated This query will be replaced by spaceMembershipRequests */
  getSpaceMembershipRequests: Array<SpaceJoinRequest>
  /** @deprecated This query will be replaced by spacePinnedPosts */
  getSpacePinnedPosts: Array<Post>
  /** @deprecated This query is replaced by analytics */
  getSpaceReport: Report
  /** @deprecated This query will be replaced by spaceRoles */
  getSpaceRoles: Array<SpaceRole>
  /** @deprecated This query will be replaced by ssoMemberships */
  getSsoMemberships: Array<SsoMembership>
  /** @deprecated This query will be replaced by supportNetworkTokens */
  getSupportNetworkTokens: SupportLimitedAuthToken
  /** @deprecated This query will be replaced by tokens */
  getTokens: AuthToken
  /** @deprecated Use the global gateway instead */
  globalApp: App
  /** @deprecated Use the global gateway instead */
  globalAppCollaborators: Array<AppCollaborator>
  /** @deprecated Use the global gateway instead */
  globalAppPublications: Array<AppPublication>
  /** @deprecated Use the global gateway instead */
  globalAppSettings: AppSetting
  /** @deprecated Use the global gateway instead */
  globalApps: PaginatedApp
  /** @deprecated Use the global gateway instead */
  globalEmbed: Embed
  /** @deprecated Use the global gateway instead */
  globalEventTypes: Array<EventType>
  /** @deprecated Use the global gateway instead */
  globalMedia: Media
  /** @deprecated Use the global gateway instead */
  globalNetworks: PaginatedNetwork
  /** @deprecated Use the global gateway instead */
  globalToken: GlobalToken
  homepage?: Maybe<Page>
  /** @deprecated This query will be replaced by impersonateLoginToNetwork mutation */
  impersonateLoginToNetwork: AuthInfoWithOtp
  invitationLinkValidity: MemberInvitationLink
  /** @deprecated Use new billing APIs */
  invoices: Array<Invoice>
  /** @deprecated This query is replaced by analytics */
  leaderboard: Array<Member>
  /** @deprecated This query is replaced by analytics */
  leaderboardWithScores: Array<LeaderboardItem>
  limitedToken: AppToken
  /** @deprecated This query will be replaced by loginNetwork mutation */
  loginNetwork: AuthToken
  /** @deprecated This query will be replaced by loginNetworkWithPassword mutation */
  loginNetworkWithPassword: AuthToken
  /** @deprecated This query will be replaced by supportSsoUrl */
  loginSupportWithSso: SupportSsoUrl
  loginSupportWithSsoCode: SupportAuthToken
  /** @deprecated This query will be replaced by ssoUrl */
  loginWithSso: SsoUrl
  /** @deprecated This query will be replaced by loginWithSsoCode mutation */
  loginWithSsoCode: AuthToken
  massActionRequest: MassActionRequest
  massActionRequestInProgress: MassActionRequest
  media: Media
  member: Member
  memberInvitation: MemberInvitation
  memberInvitationLink: MemberInvitationLink
  memberInvitationValidity: MemberInvitation
  memberInvitations: PaginatedMemberInvitation
  memberNotificationSettings: MemberNotificationSettings
  memberPostNotificationSettings: MemberPostNotificationSettings
  memberPosts: PaginatedPost
  /** @deprecated This query is no longer valid. */
  memberScore: Report
  memberSpaceMembershipRequest: Array<SpaceJoinRequest>
  memberSpaces: PaginatedSpaceMember
  members: PaginatedMember
  membersByIds: Array<Member>
  migrationSampleFile: Scalars['String']
  moderationItem: ModerationItem
  moderationItemReporters: PaginatedModerationItemReporter
  moderationItems: PaginatedModeration
  moderationSettings: ModerationSettings
  network: Network
  networkAppInstallations: PaginatedAppInstallation
  networkApps: Array<App>
  networkPublicInfo: NetworkPublicInfo
  networks: PaginatedNetwork
  networksMembers: PaginatedPluralMember
  newDomainStatus: DomainTransferStatus
  notifications: PaginatedNotification
  notificationsCount: NotificationsCount
  oAuthCode: OAuthCode
  oAuthTokens: OAuthTokens
  otp: Scalars['String']
  page: Page
  pageCustomResponses: PaginatedPageCustomResponse
  passwordComplexity: PasswordComplexity
  permission: Permission
  permissions: Array<Permission>
  post: Post
  postModerationItems: PaginatedModeration
  postReactionParticipants: PaginatedPostReactionParticipant
  postType: PostType
  postTypes: PaginatedPostType
  posts: PaginatedPost
  postsByIds: Array<Post>
  /** Create or get a private message space inside your community which will be visible to recipient only after first message. */
  privateMessage: Space
  /** @deprecated Use new billing APIs */
  products: Array<Product>
  recommendResources: Array<SmartSearchResource>
  redirect: Redirect
  replies: PaginatedPost
  /** @deprecated This query is replaced by analytics */
  report: Report
  roles: Array<Role>
  scopes: Scopes
  search: SearchResult
  searchMembersForSpaceInvitation: Array<MemberForSpaceInvitation>
  smartSearch: SmartSearchResult
  space: Space
  spaceDefaultNotificationSettings: Array<SpaceDefaultNotificationSettings>
  spaceJoinRequests: PaginatedSpaceJoinRequest
  spaceMember: SpaceMember
  spaceMembers: PaginatedSpaceMember
  spaceMembershipRequests: Array<SpaceJoinRequest>
  spacePinnedPosts: Array<Post>
  spacePostType: SpacePostType
  spacePostTypes: PaginatedSpacePostType
  spaceRoles: Array<SpaceRole>
  spaces: PaginatedSpace
  spacesByIds: Array<Space>
  spacesBySlugs: Array<Space>
  ssoMemberships: Array<SsoMembership>
  ssoUrl: SsoUrl
  ssos: Array<Sso>
  /** @deprecated Use new billing APIs */
  subscription?: Maybe<BillingSubscription>
  subscriptionInformation: SubscriptionInformation
  supportNetworkTokens: SupportLimitedAuthToken
  supportSsoUrl: SupportSsoUrl
  systemSpaces: Array<Space>
  tagPosts: PaginatedPost
  tags: PaginatedTag
  template: Template
  templateRequest: TemplateRequest
  templates: PaginatedTemplate
  tokens: AuthToken
  translateMarkup: Array<Scalars['String']>
  usernameAvailability: UsernameAvailability
  /** @deprecated Use new billing APIs */
  vatTypes: Array<VatTypeInfo>
}

export type QueryAccessGroupArgs = {
  id: Scalars['ID']
}

export type QueryActivityLogsArgs = {
  query: Scalars['String']
}

export type QueryAnalyticsArgs = {
  queries: Array<Scalars['String']>
}

export type QueryAppArgs = {
  clientId?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['ID']>
  redirectUri?: InputMaybe<Scalars['String']>
  slug?: InputMaybe<Scalars['String']>
}

export type QueryAppsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  standing?: InputMaybe<StoreItemStanding>
  status?: InputMaybe<StoreItemStatus>
}

export type QueryAuthMemberAppInstallationArgs = {
  appId: Scalars['String']
}

export type QueryAuthMemberAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryAvailableDynamicBlocksArgs = {
  context?: InputMaybe<PermissionContext>
  size?: InputMaybe<DynamicBlockSize>
}

export type QueryBasketsArgs = {
  input: BasketsInput
}

export type QueryCheckDomainAvailabilityArgs = {
  input: DomainAvailabilityInput
}

export type QueryCheckEmailAvailabilityArgs = {
  email: Scalars['String']
}

export type QueryCheckInvitationLinkValidityArgs = {
  invitationLinkId: Scalars['String']
}

export type QueryCheckMemberInvitationValidityArgs = {
  token: Scalars['String']
}

export type QueryCheckNewDomainStatusArgs = {
  domain: Scalars['String']
}

export type QueryCheckPasswordComplexityArgs = {
  password: Scalars['String']
}

export type QueryCheckUsernameAvailabilityArgs = {
  username: Scalars['String']
}

export type QueryCollectionArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryCollectionsArgs = {
  orderBy?: InputMaybe<CollectionListOrderByEnum>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryDomainAvailabilityArgs = {
  input: DomainAvailabilityInput
}

export type QueryDynamicBlockArgs = {
  blockId: Scalars['ID']
}

export type QueryDynamicBlockByKeyArgs = {
  appId: Scalars['ID']
  key: Scalars['String']
}

export type QueryDynamicBlocksArgs = {
  after?: InputMaybe<Scalars['String']>
  appIds?: InputMaybe<Array<Scalars['ID']>>
  before?: InputMaybe<Scalars['String']>
  contexts?: InputMaybe<Array<PermissionContext>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryEmailAvailabilityArgs = {
  email: Scalars['String']
}

export type QueryEmailLogsArgs = {
  after?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  recipient?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  statuses?: InputMaybe<Array<EmailStatus>>
  types?: InputMaybe<Array<EmailType>>
}

export type QueryEmbedArgs = {
  input: EmbedInput
}

export type QueryExploreSpacesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  collectionId?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryExportMemberRequestArgs = {
  id: Scalars['ID']
}

export type QueryExportMemberRequestsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<ExportListOrderByEnum>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  statuses?: InputMaybe<Array<ExportStatus>>
}

export type QueryExtraPropertiesArgs = {
  entityId?: InputMaybe<Scalars['String']>
  entityType: ExtraPropertyEntityType
  keys?: InputMaybe<Array<Scalars['String']>>
}

export type QueryFeedArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filterBy?: InputMaybe<Array<PostListFilterByInput>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  onlyMemberSpaces?: InputMaybe<Scalars['Boolean']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  orderByString?: InputMaybe<Scalars['String']>
  postTypeIds?: InputMaybe<Array<Scalars['String']>>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetAppByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetAppBySlugArgs = {
  slug: Scalars['String']
}

export type QueryGetAppNetworkSettingsArgs = {
  appId: Scalars['ID']
}

export type QueryGetAppSpaceSettingsArgs = {
  appId: Scalars['ID']
  spaceId: Scalars['ID']
}

export type QueryGetAppsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<StoreItemStatus>
}

export type QueryGetEmbedArgs = {
  input: EmbedInput
}

export type QueryGetFeedArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filterBy?: InputMaybe<Array<PostListFilterByInput>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  onlyMemberSpaces?: InputMaybe<Scalars['Boolean']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  postTypeIds?: InputMaybe<Array<Scalars['String']>>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetGroupArgs = {
  groupId?: InputMaybe<Scalars['ID']>
}

export type QueryGetMediaArgs = {
  mediaId: Scalars['ID']
}

export type QueryGetMemberArgs = {
  memberId?: InputMaybe<Scalars['ID']>
  username?: InputMaybe<Scalars['String']>
}

export type QueryGetMemberAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryGetMemberInvitationArgs = {
  id: Scalars['ID']
}

export type QueryGetMemberInvitationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['String']>>
  status?: InputMaybe<MemberInvitationStatus>
}

export type QueryGetMemberNetworkNotificationSettingsArgs = {
  memberId?: InputMaybe<Scalars['ID']>
}

export type QueryGetMemberNotificationSettingsArgs = {
  memberId?: InputMaybe<Scalars['ID']>
}

export type QueryGetMemberPostsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  memberId: Scalars['ID']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetMemberSpaceNotificationSettingsArgs = {
  memberId?: InputMaybe<Scalars['ID']>
  spaceId: Scalars['ID']
}

export type QueryGetMemberSpacesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  groupId?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  memberId: Scalars['ID']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryGetMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['ID']>>
  status?: InputMaybe<Array<MemberStatusInput>>
}

export type QueryGetModerationByIdArgs = {
  moderationId: Scalars['ID']
}

export type QueryGetModerationReportersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  moderationId: Scalars['String']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetModerationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  entityId?: InputMaybe<Scalars['String']>
  entityType?: InputMaybe<ModerationEntityType>
  flaggedBy?: InputMaybe<FlaggedType>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['String']>
  status?: InputMaybe<ModerationStatus>
}

export type QueryGetNetworkAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryGetNetworkAppsArgs = {
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryGetNetworksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
}

export type QueryGetPostArgs = {
  postId: Scalars['ID']
}

export type QueryGetPostAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  postId: Scalars['ID']
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryGetPostReactionParticipantsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  postId: Scalars['ID']
  reaction: Scalars['ID']
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetPostsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  excludePins?: InputMaybe<Scalars['Boolean']>
  filterBy?: InputMaybe<Array<PostListFilterByInput>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  postTypeIds?: InputMaybe<Array<Scalars['String']>>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryGetRepliesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  excludePins?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  postId: Scalars['ID']
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetReportArgs = {
  input: ReportInput
}

export type QueryGetScopesArgs = {
  contexts?: InputMaybe<Array<PermissionsContextInput>>
}

export type QueryGetSpaceArgs = {
  spaceId?: InputMaybe<Scalars['ID']>
  spaceSlug?: InputMaybe<Scalars['ID']>
}

export type QueryGetSpaceAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId: Scalars['ID']
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryGetSpaceMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['ID']>>
  spaceId: Scalars['ID']
}

export type QueryGetSpaceMembershipRequestForMemberArgs = {
  status?: InputMaybe<SpaceJoinRequestStatus>
}

export type QueryGetSpaceMembershipRequestsArgs = {
  spaceId: Scalars['ID']
  status?: InputMaybe<SpaceJoinRequestStatus>
}

export type QueryGetSpacePinnedPostsArgs = {
  spaceId: Scalars['ID']
}

export type QueryGetSpaceReportArgs = {
  input: ReportInput
  spaceId: Scalars['String']
}

export type QueryGetSpaceRolesArgs = {
  spaceId?: InputMaybe<Scalars['ID']>
}

export type QueryGetSsoMembershipsArgs = {
  memberId: Scalars['String']
}

export type QueryGetSupportNetworkTokensArgs = {
  input: CreateLimitedSupportTokenInput
}

export type QueryGetTokensArgs = {
  networkDomain?: InputMaybe<Scalars['String']>
  networkId?: InputMaybe<Scalars['ID']>
  otp?: InputMaybe<Scalars['String']>
  refreshToken?: InputMaybe<Scalars['String']>
}

export type QueryGlobalAppArgs = {
  id?: InputMaybe<Scalars['ID']>
  slug?: InputMaybe<Scalars['String']>
}

export type QueryGlobalAppCollaboratorsArgs = {
  appId: Scalars['String']
}

export type QueryGlobalAppPublicationsArgs = {
  appId: Scalars['ID']
}

export type QueryGlobalAppSettingsArgs = {
  context: PermissionContext
  entityId?: InputMaybe<Scalars['ID']>
  networkId: Scalars['ID']
}

export type QueryGlobalAppsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  standing?: InputMaybe<StoreItemStanding>
  status?: InputMaybe<StoreItemStatus>
}

export type QueryGlobalEmbedArgs = {
  input: EmbedInput
}

export type QueryGlobalMediaArgs = {
  id: Scalars['ID']
}

export type QueryGlobalNetworksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleType?: InputMaybe<RoleType>
}

export type QueryGlobalTokenArgs = {
  input: GlobalTokenInput
}

export type QueryHomepageArgs = {
  type?: InputMaybe<HomeSpaceType>
}

export type QueryImpersonateLoginToNetworkArgs = {
  input: ImpersonateLoginToNetworkInput
}

export type QueryInvitationLinkValidityArgs = {
  id: Scalars['String']
}

export type QueryLeaderboardArgs = {
  input: ReportInput
}

export type QueryLeaderboardWithScoresArgs = {
  includeAuthMember: Scalars['Boolean']
  input: ReportInput
}

export type QueryLimitedTokenArgs = {
  context?: InputMaybe<PermissionContext>
  entityId?: InputMaybe<Scalars['String']>
  impersonateMemberId?: InputMaybe<Scalars['String']>
  networkId: Scalars['String']
}

export type QueryLoginNetworkArgs = {
  input: LoginNetworkWithPasswordInput
}

export type QueryLoginNetworkWithPasswordArgs = {
  input: LoginNetworkWithPasswordInput
}

export type QueryLoginSupportWithSsoArgs = {
  input?: InputMaybe<SupportSsoUrlInput>
}

export type QueryLoginSupportWithSsoCodeArgs = {
  input: LoginSupportWithSsoCodeInput
}

export type QueryLoginWithSsoArgs = {
  input: SsoUrlInput
}

export type QueryLoginWithSsoCodeArgs = {
  input: LoginWithSsoCodeInput
}

export type QueryMassActionRequestArgs = {
  id: Scalars['String']
}

export type QueryMediaArgs = {
  id: Scalars['ID']
}

export type QueryMemberArgs = {
  externalId?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['ID']>
  username?: InputMaybe<Scalars['String']>
}

export type QueryMemberInvitationArgs = {
  id: Scalars['ID']
}

export type QueryMemberInvitationValidityArgs = {
  token: Scalars['String']
}

export type QueryMemberInvitationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filterBy?: InputMaybe<Array<MemberInvitationFilterByInput>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['String']>>
  status?: InputMaybe<MemberInvitationStatus>
}

export type QueryMemberNotificationSettingsArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryMemberPostNotificationSettingsArgs = {
  memberId?: InputMaybe<Scalars['ID']>
  postId: Scalars['ID']
}

export type QueryMemberPostsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  hasParent?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
  memberId: Scalars['ID']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryMemberScoreArgs = {
  input: ReportInput
  spaceId?: InputMaybe<Scalars['String']>
}

export type QueryMemberSpaceMembershipRequestArgs = {
  status?: InputMaybe<SpaceJoinRequestStatus>
}

export type QueryMemberSpacesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  collectionId?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  memberId: Scalars['ID']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filterBy?: InputMaybe<Array<MemberListFilterByInput>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Scalars['String']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['ID']>>
  status?: InputMaybe<Array<MemberStatusInput>>
}

export type QueryMembersByIdsArgs = {
  ids: Array<Scalars['String']>
}

export type QueryMigrationSampleFileArgs = {
  type?: InputMaybe<PermissionContext>
}

export type QueryModerationItemArgs = {
  id: Scalars['ID']
}

export type QueryModerationItemReportersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  moderationId: Scalars['String']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryModerationItemsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  entityId?: InputMaybe<Scalars['String']>
  entityType?: InputMaybe<ModerationEntityType>
  flaggedBy?: InputMaybe<FlaggedType>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reportCategories?: InputMaybe<Array<ReportCategory>>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['String']>
  status?: InputMaybe<ModerationStatus>
}

export type QueryNetworkAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryNetworkAppsArgs = {
  status?: InputMaybe<AppInstallationStatus>
}

export type QueryNetworksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryNetworksMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleType?: InputMaybe<RoleType>
  status?: InputMaybe<Array<MemberStatus>>
}

export type QueryNewDomainStatusArgs = {
  domain: Scalars['String']
}

export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
}

export type QueryOAuthCodeArgs = {
  input: OAuthCodeInput
}

export type QueryOAuthTokensArgs = {
  input: OAuthTokenInput
}

export type QueryPageArgs = {
  path: Scalars['String']
}

export type QueryPageCustomResponsesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  creatorType?: InputMaybe<CreatorType>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryPasswordComplexityArgs = {
  password: Scalars['String']
}

export type QueryPermissionArgs = {
  id: Scalars['ID']
}

export type QueryPostArgs = {
  id: Scalars['ID']
}

export type QueryPostModerationItemsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  entityId?: InputMaybe<Scalars['String']>
  flaggedBy?: InputMaybe<FlaggedType>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reportCategories?: InputMaybe<Array<ReportCategory>>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['String']>
  status?: InputMaybe<ModerationStatus>
}

export type QueryPostReactionParticipantsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  postId: Scalars['ID']
  reaction: Scalars['ID']
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryPostTypeArgs = {
  id: Scalars['ID']
}

export type QueryPostTypesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  context?: InputMaybe<PostTypeContext>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryPostsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  excludePins?: InputMaybe<Scalars['Boolean']>
  filterBy?: InputMaybe<Array<PostListFilterByInput>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  orderByString?: InputMaybe<Scalars['String']>
  postTypeIds?: InputMaybe<Array<Scalars['String']>>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryPostsByIdsArgs = {
  ids: Array<Scalars['ID']>
  statuses?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryPrivateMessageArgs = {
  input: PrivateMessageInput
}

export type QueryRecommendResourcesArgs = {
  input: RecommendResourcesInput
}

export type QueryRedirectArgs = {
  url: Scalars['String']
}

export type QueryRepliesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  excludePins?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<PostListOrderByEnum>
  postId: Scalars['ID']
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryReportArgs = {
  input: ReportInput
  spaceId?: InputMaybe<Scalars['String']>
}

export type QueryRolesArgs = {
  orderBy?: InputMaybe<RoleListOrderByEnum>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryScopesArgs = {
  contexts?: InputMaybe<Array<PermissionsContextInput>>
}

export type QuerySearchArgs = {
  input: SearchInput
}

export type QuerySearchMembersForSpaceInvitationArgs = {
  input: SearchMembersForSpaceInvitationInput
}

export type QuerySmartSearchArgs = {
  input: SmartSearchInput
}

export type QuerySpaceArgs = {
  id?: InputMaybe<Scalars['ID']>
  path?: InputMaybe<Scalars['String']>
  slug?: InputMaybe<Scalars['ID']>
}

export type QuerySpaceDefaultNotificationSettingsArgs = {
  spaceId: Scalars['ID']
}

export type QuerySpaceJoinRequestsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  memberId?: InputMaybe<Scalars['ID']>
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['ID']>
  status?: InputMaybe<SpaceJoinRequestStatus>
}

export type QuerySpaceMemberArgs = {
  memberId: Scalars['ID']
  spaceId: Scalars['ID']
}

export type QuerySpaceMembersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<SpaceMemberListOrderByEnum>
  reverse?: InputMaybe<Scalars['Boolean']>
  roleIds?: InputMaybe<Array<Scalars['ID']>>
  spaceId: Scalars['ID']
}

export type QuerySpaceMembershipRequestsArgs = {
  spaceId: Scalars['ID']
  status?: InputMaybe<SpaceJoinRequestStatus>
}

export type QuerySpacePinnedPostsArgs = {
  spaceId: Scalars['ID']
}

export type QuerySpacePostTypeArgs = {
  postTypeId: Scalars['ID']
  spaceId: Scalars['ID']
}

export type QuerySpacePostTypesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  context?: InputMaybe<PostTypeContext>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId: Scalars['ID']
}

export type QuerySpaceRolesArgs = {
  orderBy?: InputMaybe<SpaceRoleListOrderByEnum>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['ID']>
}

export type QuerySpacesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  collectionId?: InputMaybe<Scalars['String']>
  exploreOnly?: InputMaybe<Scalars['Boolean']>
  filterBy?: InputMaybe<Array<EntityListFilterByInput>>
  limit: Scalars['Int']
  memberId?: InputMaybe<Scalars['ID']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<SpaceListOrderByEnum>
  orderByString?: InputMaybe<Scalars['String']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  type?: InputMaybe<Array<SpaceType>>
}

export type QuerySpacesByIdsArgs = {
  ids: Array<Scalars['ID']>
}

export type QuerySpacesBySlugsArgs = {
  slugs: Array<Scalars['String']>
}

export type QuerySsoMembershipsArgs = {
  memberId: Scalars['String']
}

export type QuerySsoUrlArgs = {
  input: SsoUrlInput
}

export type QuerySsosArgs = {
  status?: InputMaybe<SsoStatus>
}

export type QuerySubscriptionArgs = {
  input: SubscriptionInput
}

export type QuerySupportNetworkTokensArgs = {
  networkId: Scalars['String']
}

export type QuerySupportSsoUrlArgs = {
  input?: InputMaybe<SupportSsoUrlInput>
}

export type QueryTagPostsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['ID']>
  tagId?: InputMaybe<Scalars['ID']>
  tagSlug?: InputMaybe<Scalars['String']>
}

export type QueryTagsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  ids?: InputMaybe<Array<Scalars['ID']>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<TagsOrderByEnum>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  spaceId?: InputMaybe<Scalars['ID']>
}

export type QueryTemplateArgs = {
  id: Scalars['String']
}

export type QueryTemplateRequestArgs = {
  id: Scalars['String']
}

export type QueryTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  categories?: InputMaybe<Array<Scalars['String']>>
  entityTypes?: InputMaybe<Array<TemplateEntityType>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<StoreItemStatus>
}

export type QueryTokensArgs = {
  networkDomain?: InputMaybe<Scalars['String']>
  networkId?: InputMaybe<Scalars['ID']>
  otp?: InputMaybe<Scalars['String']>
  refreshToken?: InputMaybe<Scalars['String']>
  ssoToken?: InputMaybe<Scalars['String']>
}

export type QueryTranslateMarkupArgs = {
  format?: InputMaybe<TranslationMarkupFormat>
  input?: InputMaybe<Array<TranslationMarkupInput>>
  markups?: InputMaybe<Array<Scalars['String']>>
}

export type QueryUsernameAvailabilityArgs = {
  username: Scalars['String']
}

export type ReOrderSchemaFieldInput = {
  index: Scalars['Int']
  key: Scalars['String']
}

export enum ReactionType {
  EMOJI_BASE = 'EMOJI_BASE',
  LIKE_BASE = 'LIKE_BASE',
  VOTE_BASE = 'VOTE_BASE',
}

export type RecommendResourcesInput = {
  limit?: InputMaybe<Scalars['Float']>
  negativeEntityIds?: InputMaybe<Array<Scalars['String']>>
  positiveEntityIds: Array<Scalars['String']>
  source: SmartSearchSource
}

export type Redirect = {
  resolvedUrl: Scalars['String']
  url: Scalars['String']
}

export enum RelationTypeOptions {
  Media = 'Media',
  Member = 'Member',
  Post = 'Post',
  Space = 'Space',
  Tag = 'Tag',
}

export type Report = {
  data?: Maybe<Array<ReportData>>
  description?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['DateTime']>
  previousValue?: Maybe<Scalars['String']>
  slug: Scalars['String']
  startDate?: Maybe<Scalars['DateTime']>
  title: Scalars['String']
  tooltip?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['String']>
}

export enum ReportCategory {
  HARASSMENT = 'HARASSMENT',
  MISINFORMATION = 'MISINFORMATION',
  NUDITY = 'NUDITY',
  SPAM = 'SPAM',
  SUICIDE = 'SUICIDE',
  TERRORISM = 'TERRORISM',
  VIOLENCE = 'VIOLENCE',
}

export type ReportData = {
  description?: Maybe<Scalars['String']>
  key: Scalars['String']
  previousValue?: Maybe<ReportDataValue>
  type: ReportDataType
  value: ReportDataValue
}

export enum ReportDataType {
  chartData = 'chartData',
  entityReport = 'entityReport',
  intValue = 'intValue',
  stringValue = 'stringValue',
}

export type ReportDataValue = ChartData | EntityReport | IntValue | StringValue

export type ReportEntities = {
  actor?: Maybe<Member>
  app?: Maybe<App>
  member?: Maybe<Member>
  network?: Maybe<Network>
  person?: Maybe<Member>
  post?: Maybe<Post>
  space?: Maybe<Space>
  tag?: Maybe<Tag>
}

export type ReportInput = {
  endDate?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  slug: ReportSlug
  sort?: InputMaybe<ColumnSortInput>
  startDate?: InputMaybe<Scalars['String']>
  timeFrame?: InputMaybe<ReportTimeFrame>
  timeZone: Scalars['String']
}

export type ReportPayload = {
  key: Scalars['String']
  value: Scalars['String']
}

export type ReportRecord = {
  entities: ReportEntities
  payload: Array<ReportPayload>
}

export enum ReportSlug {
  activeMembers = 'activeMembers',
  averageDailyActiveMembers = 'averageDailyActiveMembers',
  highlights = 'highlights',
  memberScore = 'memberScore',
  newMembersOverTime = 'newMembersOverTime',
  newPosts = 'newPosts',
  newReactions = 'newReactions',
  newReplies = 'newReplies',
  popularDaysOfWeek = 'popularDaysOfWeek',
  popularHoursOfDay = 'popularHoursOfDay',
  postsVSreplies = 'postsVSreplies',
  topMembers = 'topMembers',
  topPosts = 'topPosts',
  topSpaces = 'topSpaces',
  totalMembers = 'totalMembers',
  totalPosts = 'totalPosts',
  totalReactions = 'totalReactions',
  totalReplies = 'totalReplies',
  totalVisitors = 'totalVisitors',
  trendingTags = 'trendingTags',
}

export enum ReportTimeFrame {
  allTime = 'allTime',
  lastCalendarQuarter = 'lastCalendarQuarter',
  lastCalendarYear = 'lastCalendarYear',
  lastMonth = 'lastMonth',
  lastNinetyDays = 'lastNinetyDays',
  lastSevenDays = 'lastSevenDays',
  lastThirtyDays = 'lastThirtyDays',
  lastTwelveMonth = 'lastTwelveMonth',
  lastWeek = 'lastWeek',
  today = 'today',
  yesterday = 'yesterday',
}

export type ReportableEntity = Member | Post | Space | Tag

export enum ReportableEntityType {
  member = 'member',
  post = 'post',
  space = 'space',
}

export type RequestGlobalTokenInput = {
  captchaToken?: InputMaybe<Scalars['String']>
  email: Scalars['String']
}

export type ResetPasswordInput = {
  email: Scalars['String']
}

export enum RichTextTypeOptions {
  html = 'html',
  markup = 'markup',
}

export type Role = {
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  scopes: Array<Scalars['String']>
  type?: Maybe<RoleType>
  visible: Scalars['Boolean']
}

export enum RoleListOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT',
}

export enum RoleType {
  admin = 'admin',
  guest = 'guest',
  member = 'member',
  moderator = 'moderator',
}

export type Scopes = {
  contextAwareScopes: Array<ContextScopes>
  scopes: Array<Scalars['String']>
}

export type SearchEntity = {
  by?: Maybe<By>
  content?: Maybe<Scalars['String']>
  created?: Maybe<Scalars['DateTime']>
  entity?: Maybe<SearchObjectEntity>
  entityId?: Maybe<Scalars['String']>
  entityType: SearchEntityType
  id: Scalars['ID']
  in?: Maybe<In>
  media?: Maybe<Media>
  subtitle?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
  title: Scalars['String']
  url?: Maybe<Scalars['String']>
}

export type SearchEntityGroup = {
  entityType: SearchEntityType
  hits: Array<SearchEntity>
}

export enum SearchEntityType {
  External = 'External',
  member = 'member',
  post = 'post',
  space = 'space',
}

export type SearchInput = {
  filters?: InputMaybe<Array<FiltersInput>>
  includeExternal?: InputMaybe<Scalars['Boolean']>
  query: Scalars['String']
}

export type SearchMembersForSpaceInvitationInput = {
  query: Scalars['String']
  spaceId: Scalars['ID']
}

export type SearchObjectEntity = Member | Post | Space

export type SearchResult = {
  hits: Array<SearchEntityGroup>
  totalCount: Scalars['Float']
}

export type Settings = {
  captcha?: Maybe<CaptchaSettings>
  contentTranslation?: Maybe<ContentTranslationSettings>
  emailEnabled: Scalars['Boolean']
  emailFrom?: Maybe<Scalars['String']>
  emailNotificationEnabled: Scalars['Boolean']
  fileSizeLimit: Scalars['Float']
  fileTypesLimit: Array<Scalars['String']>
  imageSizeLimit: Scalars['Float']
  imageTypesLimit: Array<Scalars['String']>
  memberPermissions?: Maybe<MembersPermissionSettings>
  /** @deprecated This field will be replaced by privateMessaging.membersCanTurnOffPrivateMessaging */
  membersCanTurnOffPrivateMessaging?: Maybe<Scalars['Boolean']>
  /** @deprecated This field will be replaced by privateMessaging.membersCanUsePrivateMessaging */
  membersCanUsePrivateMessaging?: Maybe<Scalars['Boolean']>
  privateMessaging?: Maybe<PrivateMessagingSettings>
  /** @deprecated This field will be replaced by privateMessaging.privateMessagingEnabled */
  privateMessagingEnabled?: Maybe<Scalars['Boolean']>
}

export enum ShortContentFormat {
  Html = 'Html',
  Text = 'Text',
}

export type Shortcut = {
  app?: Maybe<App>
  appId: Scalars['ID']
  description?: Maybe<Scalars['String']>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  key: Scalars['String']
  name: Scalars['String']
}

export type SignedUrl = {
  fields: Scalars['String']
  mediaDownloadUrl: Scalars['String']
  mediaId: Scalars['ID']
  mediaUrl: Scalars['String']
  signedUrl: Scalars['String']
  urls?: Maybe<MediaUrls>
}

export type Slate = {
  blocks: Array<Block>
  id?: Maybe<Scalars['String']>
  restrictions?: Maybe<SlateRestrictions>
  rootBlock: Scalars['String']
}

export type SlateInput = {
  blocks: Array<BlockInput>
  rootBlock: Scalars['String']
}

export type SlateRestrictions = {
  lockedChildrenBlocks?: Maybe<Array<Scalars['String']>>
  nonEditableBlocks?: Maybe<Array<Scalars['String']>>
  nonRemovableBlocks?: Maybe<Array<Scalars['String']>>
}

export type SlateUpdatesInput = {
  addedBlocks?: InputMaybe<Array<BlockInput>>
  removedBlocks?: InputMaybe<Array<Scalars['String']>>
  rootBlock?: InputMaybe<Scalars['String']>
  updatedBlocks?: InputMaybe<Array<UpdateBlockInput>>
}

export type SmartSearchInput = {
  level?: InputMaybe<AssistantLevel>
  query: Scalars['String']
}

export type SmartSearchResource = {
  additional: SmartSearchResourceAdditional
  entity?: Maybe<SearchObjectEntity>
  info: SmartSearchResourceInfo
  source: SmartSearchSource
  type: Scalars['String']
  uuid: Scalars['String']
}

export type SmartSearchResourceAdditional = {
  score: Scalars['Float']
}

export type SmartSearchResourceInfo = {
  description?: Maybe<Scalars['String']>
  icon?: Maybe<Media>
  id: Scalars['String']
  spaceId?: Maybe<Scalars['String']>
  title: Scalars['String']
  url: Scalars['String']
}

export type SmartSearchResult = {
  answer?: Maybe<Scalars['String']>
  resources: Array<SmartSearchResource>
}

export enum SmartSearchSource {
  POST = 'POST',
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type Space = {
  address: SpaceAddress
  authMemberProps?: Maybe<SpaceAuthMemberProps>
  banner?: Maybe<Media>
  bannerId?: Maybe<Scalars['ID']>
  collection?: Maybe<Collection>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<Member>
  createdById: Scalars['ID']
  customOrderingIndexInGroup: Scalars['Float']
  customSeoDetail?: Maybe<CustomSeoDetail>
  description?: Maybe<Scalars['String']>
  externalId?: Maybe<Scalars['ID']>
  groupId?: Maybe<Scalars['ID']>
  hidden?: Maybe<Scalars['Boolean']>
  highlightedTagIds: Array<Scalars['ID']>
  highlightedTags?: Maybe<Array<Tag>>
  id: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  /** @deprecated We no longer support app installation on space */
  installedApps?: Maybe<PaginatedAppInstallation>
  inviteOnly?: Maybe<Scalars['Boolean']>
  isHomepage?: Maybe<Scalars['Boolean']>
  isNewUserHomepage?: Maybe<Scalars['Boolean']>
  isReturningUserHomepage?: Maybe<Scalars['Boolean']>
  key: Scalars['String']
  layout: Scalars['String']
  members?: Maybe<PaginatedSpaceMember>
  membersCount: Scalars['Int']
  name: Scalars['String']
  network?: Maybe<Network>
  networkId: Scalars['ID']
  nonAdminsCanInvite?: Maybe<Scalars['Boolean']>
  pinnedPosts?: Maybe<Array<Post>>
  posts?: Maybe<PaginatedPost>
  postsCount?: Maybe<Scalars['Int']>
  private?: Maybe<Scalars['Boolean']>
  relativeUrl?: Maybe<Scalars['String']>
  roles?: Maybe<Array<SpaceRole>>
  seoDetail?: Maybe<SpaceSeoDetail>
  shortcuts?: Maybe<Array<Shortcut>>
  slate?: Maybe<Slate>
  slug: Scalars['String']
  /** @deprecated Space tag filters is a retired concept and is no longer used. */
  tagFilter?: Maybe<TagFilter>
  /** @deprecated This field is deprecated. Use `tags` query instead. */
  tags?: Maybe<PaginatedTag>
  type: SpaceType
  updatedAt: Scalars['DateTime']
  url?: Maybe<Scalars['String']>
  whoCanPost?: Maybe<Array<Scalars['ID']>>
  whoCanReact?: Maybe<Array<Scalars['ID']>>
  whoCanReply?: Maybe<Array<Scalars['ID']>>
}

export type SpaceInstalledAppsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<AppInstallationStatus>
}

export type SpaceMembersArgs = {
  limit: Scalars['Int']
}

export type SpacePostsArgs = {
  excludePins?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
}

export type SpaceTagsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<TagListOrderByEnum>
  query?: InputMaybe<Scalars['String']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type SpaceAddress = {
  editable: Scalars['Boolean']
  exact: Scalars['Boolean']
  path: Scalars['String']
}

export type SpaceAddressInput = {
  editable?: InputMaybe<Scalars['Boolean']>
  exact: Scalars['Boolean']
  path: Scalars['String']
}

export type SpaceAuthMemberProps = {
  availablePostTypes?: Maybe<Array<PostType>>
  context: PermissionContext
  lastReadAt?: Maybe<Scalars['DateTime']>
  membershipStatus?: Maybe<SpaceMembershipStatus>
  permissions?: Maybe<Array<ActionPermissions>>
  scopes?: Maybe<Array<Scalars['String']>>
  spaceMember?: Maybe<SpaceMember>
  unreadPostsCount?: Maybe<Scalars['Int']>
}

export type SpaceDefaultNotificationSettings = {
  channel: NotificationChannel
  enabled?: Maybe<Scalars['Boolean']>
  isDefault: Scalars['Boolean']
  preference?: Maybe<SpaceNotificationPreference>
  sameAsDefault: Scalars['Boolean']
}

export type SpaceEdge = {
  cursor: Scalars['String']
  node: Space
}

export type SpaceJoinRequest = {
  id: Scalars['ID']
  member?: Maybe<Member>
  spaceId: Scalars['ID']
  status: SpaceJoinRequestStatus
}

export type SpaceJoinRequestEdge = {
  cursor: Scalars['String']
  node: SpaceJoinRequest
}

export enum SpaceJoinRequestStatus {
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
}

export enum SpaceListOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  CUSTOM_ORDERING_INDEX = 'CUSTOM_ORDERING_INDEX',
  UPDATED_AT = 'UPDATED_AT',
}

export type SpaceMember = {
  member?: Maybe<Member>
  role?: Maybe<SpaceRole>
  space?: Maybe<Space>
}

export enum SpaceMemberAffiliation {
  Joined = 'Joined',
  NotJoined = 'NotJoined',
  RequestedToJoin = 'RequestedToJoin',
  UnableToJoin = 'UnableToJoin',
}

export type SpaceMemberEdge = {
  cursor: Scalars['String']
  node: SpaceMember
}

export enum SpaceMemberListOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT',
}

export enum SpaceMembershipStatus {
  Archived = 'Archived',
  Closed = 'Closed',
  joined = 'joined',
  notJoined = 'notJoined',
  requested = 'requested',
}

export enum SpaceNotificationPreference {
  ALL = 'ALL',
  NEW_POST = 'NEW_POST',
  NONE = 'NONE',
}

export type SpacePostType = {
  postType?: Maybe<PostType>
  postTypeId: Scalars['ID']
  space?: Maybe<Space>
  spaceId: Scalars['ID']
  whoCanPost?: Maybe<Array<Scalars['ID']>>
  whoCanReact?: Maybe<Array<Scalars['ID']>>
  whoCanReply?: Maybe<Array<Scalars['ID']>>
}

export type SpacePostTypeEdge = {
  cursor: Scalars['String']
  node: SpacePostType
}

export type SpaceRole = {
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  network?: Maybe<Network>
  scopes: Array<Scalars['String']>
  type?: Maybe<SpaceRoleType>
}

export enum SpaceRoleListOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT',
}

export enum SpaceRoleType {
  admin = 'admin',
  member = 'member',
}

export type SpaceSeoDetail = {
  description?: Maybe<Scalars['String']>
  image?: Maybe<Media>
  title: Scalars['String']
}

export type SpaceSeoDetailInput = {
  description?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  title: Scalars['String']
}

export enum SpaceType {
  Broadcast = 'Broadcast',
  Entity = 'Entity',
  Group = 'Group',
  Page = 'Page',
  PrivateMessage = 'PrivateMessage',
}

export type Sso = {
  allowSignUp?: Maybe<Scalars['Boolean']>
  authorizationUrl?: Maybe<Scalars['String']>
  buttonText?: Maybe<Scalars['String']>
  clientId?: Maybe<Scalars['String']>
  clientSecret?: Maybe<Scalars['String']>
  defaultRelayState?: Maybe<Scalars['String']>
  idpUrl?: Maybe<Scalars['String']>
  logoutUrl?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  provider?: Maybe<SsoProvider>
  scopes?: Maybe<Array<Scalars['String']>>
  settingsUrl?: Maybe<Scalars['String']>
  signUpUrl?: Maybe<Scalars['String']>
  status: SsoStatus
  tokenUrl?: Maybe<Scalars['String']>
  type: SsoType
  userProfileUrl?: Maybe<Scalars['String']>
}

export type SsoMembership = {
  id: Scalars['String']
  memberId: Scalars['String']
  ssoType: SsoType
}

export enum SsoProvider {
  auth0 = 'auth0',
  custom = 'custom',
  memberful = 'memberful',
  okta = 'okta',
  outseta = 'outseta',
  wordpress = 'wordpress',
}

export enum SsoStatus {
  disable = 'disable',
  enable = 'enable',
}

export enum SsoType {
  Apple = 'Apple',
  Discord = 'Discord',
  Saml = 'Saml',
  Slack = 'Slack',
  facebook = 'facebook',
  google = 'google',
  jwt = 'jwt',
  linkedin = 'linkedin',
  oauth2 = 'oauth2',
}

export type SsoUrl = {
  url: Scalars['String']
}

export type SsoUrlInput = {
  callbackUrl?: InputMaybe<Scalars['String']>
  invitationLinkId?: InputMaybe<Scalars['String']>
  invitationToken?: InputMaybe<Scalars['String']>
  redirectUri?: InputMaybe<Scalars['String']>
  type: SsoType
}

export enum StaffReason {
  NetworkStaffRole = 'NetworkStaffRole',
  SamlSso = 'SamlSso',
  SpaceStaffRole = 'SpaceStaffRole',
}

export type StatusReason = {
  changedAt: Scalars['DateTime']
  changedBy: NetworkStatusChangedBy
  changedById?: Maybe<Scalars['String']>
  reason?: Maybe<NetworkStatusReason>
}

export enum StoreItemStanding {
  OFFICIAL = 'OFFICIAL',
  REGULAR = 'REGULAR',
  VERIFIED = 'VERIFIED',
}

export enum StoreItemStatus {
  DELETED = 'DELETED',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export type StringValue = {
  string: Scalars['String']
}

export type Subscription = {
  network: Network
  post: Post
  smartSearch: SmartSearchResult
  space: Space
}

export type SubscriptionSmartSearchArgs = {
  input: SmartSearchInput
}

export type SubscriptionCheckoutSession = {
  url: Scalars['String']
}

export type SubscriptionInformation = {
  addons?: Maybe<Array<AddonInformation>>
  currentProduct?: Maybe<BillingProduct>
  isManual: Scalars['Boolean']
  planId?: Maybe<Scalars['String']>
  planName?: Maybe<Scalars['String']>
  planPriceId?: Maybe<Scalars['String']>
  planPriceInterval?: Maybe<BillingPriceInterval>
}

export enum SubscriptionStatus {
  active = 'active',
  canceled = 'canceled',
  failed = 'failed',
  incomplete = 'incomplete',
  incomplete_expired = 'incomplete_expired',
  past_due = 'past_due',
  trialing = 'trialing',
  unpaid = 'unpaid',
}

export type SupportAuthToken = {
  accessToken: Scalars['String']
  refreshToken: Scalars['String']
}

export type SupportLimitedAuthToken = {
  accessToken: Scalars['String']
  member: Member
}

export type SupportSsoUrl = {
  url: Scalars['String']
}

export type SupportSsoUrlInput = {
  callbackUrl?: InputMaybe<Scalars['String']>
}

export type Tag = {
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  slug: Scalars['String']
  /** @deprecated Tags belong to network. This field is no longer used. */
  spaceId?: Maybe<Scalars['String']>
  title: Scalars['String']
}

export type TagEdge = {
  cursor: Scalars['String']
  node: Tag
}

export type TagFilter = {
  filterType: TagFilterType
  filters: Array<Scalars['String']>
}

export enum TagFilterType {
  BLACKLIST = 'BLACKLIST',
  WHITELIST = 'WHITELIST',
}

export enum TagListOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
  UPDATED_AT = 'UPDATED_AT',
}

export enum TagsOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
  UPDATED_AT = 'UPDATED_AT',
}

export type Template = {
  about?: Maybe<Scalars['String']>
  appIds: Array<Scalars['String']>
  apps?: Maybe<Array<App>>
  authorName?: Maybe<Scalars['String']>
  authorUrl?: Maybe<Scalars['String']>
  banner?: Maybe<Media>
  bannerId?: Maybe<Scalars['ID']>
  categories: Array<Scalars['String']>
  comingSoon: Scalars['Boolean']
  contentTypes?: Maybe<Array<ContentTypeTemplate>>
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<Member>
  createdById?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  embedIds: Array<Scalars['ID']>
  embeds?: Maybe<Array<Embed>>
  entity?: Maybe<TemplateEntity>
  entityId?: Maybe<Scalars['String']>
  entityProperties: Scalars['String']
  entityType: TemplateEntityType
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  hubContent?: Maybe<HubContent>
  hubContentId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  imageIds: Array<Scalars['ID']>
  images?: Maybe<Array<Media>>
  installed?: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  network?: Maybe<Network>
  networkId: Scalars['ID']
  previewHtml?: Maybe<Scalars['String']>
  privacyPolicyUrl?: Maybe<Scalars['String']>
  requiredPlan?: Maybe<PlanName>
  requiredTemplateIds: Array<Scalars['String']>
  /** @deprecated Use contentTypes instead */
  requiredTemplates?: Maybe<Array<Template>>
  slate?: Maybe<Slate>
  slug: Scalars['String']
  standing: StoreItemStanding
  status: StoreItemStatus
  syncedAt?: Maybe<Scalars['DateTime']>
  termsOfServiceUrl?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  updatedBy?: Maybe<Member>
  updatedById?: Maybe<Scalars['ID']>
}

export type TemplateCreatedEntity = Space

export type TemplateEdge = {
  cursor: Scalars['String']
  node: Template
}

export type TemplateEntity =
  | Network
  | Post
  | PostType
  | Space
  | SpacePostType
  | Tag

export enum TemplateEntityType {
  Network = 'Network',
  Post = 'Post',
  PostType = 'PostType',
  Space = 'Space',
  SpacePostType = 'SpacePostType',
  Tag = 'Tag',
}

export type TemplateFieldMapping = {
  from: Scalars['String']
  to: Scalars['String']
}

export type TemplateFieldMappingInput = {
  from: Scalars['String']
  to: Scalars['String']
}

export type TemplateRequest = {
  createdAt: Scalars['DateTime']
  createdById: Scalars['String']
  createdEntity?: Maybe<TemplateCreatedEntity>
  createdEntityAt?: Maybe<Scalars['DateTime']>
  createdEntityId?: Maybe<Scalars['String']>
  createdEntityType: TemplateEntityType
  id: Scalars['String']
  networkId?: Maybe<Scalars['String']>
  processedPercentage: Scalars['Float']
  status: TemplateRequestStatus
  templateId: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export enum TemplateRequestStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Succeeded = 'Succeeded',
}

export type TemplatesMapping = {
  fields?: Maybe<Array<TemplateFieldMapping>>
  from?: Maybe<Scalars['String']>
  to?: Maybe<Scalars['String']>
}

export type TemplatesMappingInput = {
  fields?: InputMaybe<Array<TemplateFieldMappingInput>>
  from: Scalars['String']
  to: Scalars['String']
}

export type TestAppWebhookInput = {
  webhookUrl: Scalars['String']
}

export enum TextTypeOptions {
  fullText = 'fullText',
  shortText = 'shortText',
}

export type Theme = {
  name: Scalars['String']
  status: ThemeStatus
  tokens: ThemeTokens
}

export type ThemeColor = {
  key: Scalars['String']
  weights: Array<ThemeToken>
}

export type ThemeColorToken = {
  key: Scalars['String']
  value: Scalars['String']
}

export type ThemeColorTokens = {
  dark?: Maybe<Array<ThemeColorToken>>
  light?: Maybe<Array<ThemeColorToken>>
}

export type ThemeColors = {
  dark?: Maybe<Array<ThemeColor>>
  light?: Maybe<Array<ThemeColor>>
}

export enum ThemeStatus {
  draft = 'draft',
  published = 'published',
}

export type ThemeToken = {
  key: Scalars['String']
  value: Scalars['String']
}

export type ThemeTokens = {
  breakpoints?: Maybe<Array<ThemeToken>>
  colors?: Maybe<Array<ThemeToken>>
  fontSizes?: Maybe<Array<ThemeToken>>
  fontWeights?: Maybe<Array<ThemeToken>>
  opacity?: Maybe<Array<ThemeToken>>
  shadows?: Maybe<Array<ThemeToken>>
  sizes?: Maybe<Array<ThemeToken>>
  textStyles?: Maybe<Array<ThemeToken>>
  zIndices?: Maybe<Array<ThemeToken>>
}

export type Themes = {
  active: Theme
  drafts?: Maybe<Array<Theme>>
  published: Array<Theme>
}

export type Toast = {
  description?: Maybe<Scalars['String']>
  duration?: Maybe<Scalars['Float']>
  status?: Maybe<ToastStatus>
  title?: Maybe<Scalars['String']>
}

export enum ToastStatus {
  Error = 'Error',
  Info = 'Info',
  Neutral = 'Neutral',
  Success = 'Success',
  Warning = 'Warning',
}

export type TopNavigation = {
  alignment: TopNavigationAlignment
  enabled: Scalars['Boolean']
  items: Array<NavigationItem>
}

export enum TopNavigationAlignment {
  CENTER = 'CENTER',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export enum TranslationMarkupFormat {
  HTML = 'HTML',
  TEXT = 'TEXT',
}

export type TranslationMarkupInput = {
  format: TranslationMarkupFormat
  markup: Scalars['String']
}

export enum UnauthorizedReason {
  ACCESS = 'ACCESS',
  PLAN = 'PLAN',
}

export enum UnsubscribeTokenContext {
  ALL = 'ALL',
  MEMBER = 'MEMBER',
  MENTIONS = 'MENTIONS',
  POST = 'POST',
  REACTIONS = 'REACTIONS',
  SPACE = 'SPACE',
}

export type UnsubscribeWithTokenInput = {
  context: UnsubscribeTokenContext
  entityId?: InputMaybe<Scalars['String']>
  token: Scalars['String']
}

export type UpdateAccessGroupInput = {
  description?: InputMaybe<Scalars['String']>
  entityId?: InputMaybe<Scalars['ID']>
  entityType?: InputMaybe<AccessGroupEntityType>
  info?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}

export type UpdateAppCustomCodes = {
  body?: InputMaybe<Scalars['String']>
  head?: InputMaybe<Scalars['String']>
}

export type UpdateAppInput = {
  about?: InputMaybe<Scalars['String']>
  authorName?: InputMaybe<Scalars['String']>
  authorUrl?: InputMaybe<Scalars['String']>
  bannerId?: InputMaybe<Scalars['String']>
  comingSoon?: InputMaybe<Scalars['Boolean']>
  customCodes?: InputMaybe<UpdateAppCustomCodes>
  description?: InputMaybe<Scalars['String']>
  docsUrl?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  privacyPolicyUrl?: InputMaybe<Scalars['String']>
  requiredPermissions?: InputMaybe<Array<PrimaryScopes>>
  requiredPlan?: InputMaybe<PlanName>
  slug?: InputMaybe<Scalars['String']>
  termsOfServiceUrl?: InputMaybe<Scalars['String']>
  webhookSubscriptions?: InputMaybe<Array<Scalars['String']>>
  webhookUrl?: InputMaybe<Scalars['String']>
}

export type UpdateAppInstallationInput = {
  permissions?: InputMaybe<Array<PrimaryScopes>>
  templatesMappings?: InputMaybe<AppInstallationTemplatesMappingsInput>
}

export type UpdateBadgeInput = {
  active: Scalars['Boolean']
  backgroundColor?: InputMaybe<Scalars['String']>
  daysUntilExpired?: InputMaybe<Scalars['Float']>
  imageId?: InputMaybe<Scalars['ID']>
  longDescription?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  settings?: InputMaybe<Array<BadgeSettingsInput>>
  shortDescription: Scalars['String']
  text?: InputMaybe<Scalars['String']>
  textColor?: InputMaybe<Scalars['String']>
}

export type UpdateBlockInput = {
  children?: InputMaybe<Scalars['String']>
  extraProps?: InputMaybe<Scalars['String']>
  id: Scalars['String']
  output?: InputMaybe<Scalars['String']>
  props?: InputMaybe<Scalars['String']>
}

export type UpdateCollectionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>
  description?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['DateTime']>
}

export type UpdateCustomFieldSchemaInput = {
  default?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  externalKeys?: InputMaybe<Array<Scalars['String']>>
  items?: InputMaybe<BaseCustomFieldSchemaInput>
  key: Scalars['String']
  name?: InputMaybe<Scalars['String']>
  properties?: InputMaybe<Array<BaseCustomFieldSchemaInput>>
  readPrivacy?: InputMaybe<CustomFieldPrivacyInput>
  required?: InputMaybe<Scalars['Boolean']>
  settings?: InputMaybe<Array<CustomFieldSettingsInput>>
  validators?: InputMaybe<Array<CustomFieldValidatorInput>>
  writePrivacy?: InputMaybe<CustomFieldPrivacyInput>
}

export type UpdateCustomSsoInput = {
  allowSignUp?: InputMaybe<Scalars['Boolean']>
  authorizationUrl?: InputMaybe<Scalars['String']>
  buttonText?: InputMaybe<Scalars['String']>
  clientId?: InputMaybe<Scalars['String']>
  clientSecret?: InputMaybe<Scalars['String']>
  idpUrl?: InputMaybe<Scalars['String']>
  logoutUrl?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  provider?: InputMaybe<SsoProvider>
  scopes?: InputMaybe<Array<Scalars['String']>>
  settingsUrl?: InputMaybe<Scalars['String']>
  status?: InputMaybe<SsoStatus>
  tokenUrl?: InputMaybe<Scalars['String']>
  type: CustomSsoType
  userProfileUrl?: InputMaybe<Scalars['String']>
}

export type UpdateFileInput = {
  name?: InputMaybe<Scalars['String']>
}

export type UpdateFooter = {
  urls: Array<UpdateFooterUrl>
}

export type UpdateFooterUrl = {
  title: Scalars['String']
  url: Scalars['String']
}

export type UpdateHighlightedTags = {
  highlightedTags: Array<CreateHighlightedTag>
}

export type UpdateImageInput = {
  cropHeight?: InputMaybe<Scalars['Int']>
  cropWidth?: InputMaybe<Scalars['Int']>
  cropX?: InputMaybe<Scalars['Int']>
  cropY?: InputMaybe<Scalars['Int']>
  cropZoom?: InputMaybe<Scalars['Float']>
  name?: InputMaybe<Scalars['String']>
}

export type UpdateJwtSsoInput = {
  authorizationUrl?: InputMaybe<Scalars['String']>
  buttonText?: InputMaybe<Scalars['String']>
  logoutUrl?: InputMaybe<Scalars['String']>
  settingsUrl?: InputMaybe<Scalars['String']>
  signUpUrl?: InputMaybe<Scalars['String']>
  status: SsoStatus
}

export type UpdateMediaNetworkSettingsInput = {
  fileSizeLimit?: InputMaybe<Scalars['Float']>
  fileTypesLimit?: InputMaybe<Array<Scalars['String']>>
  imageSizeLimit?: InputMaybe<Scalars['Float']>
  imageTypesLimit?: InputMaybe<Array<Scalars['String']>>
}

export type UpdateMemberAttributesInput = {
  locale?: InputMaybe<Scalars['String']>
}

export type UpdateMemberInput = {
  attributes?: InputMaybe<UpdateMemberAttributesInput>
  bannerId?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  currentPassword?: InputMaybe<Scalars['String']>
  displayName?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  externalId?: InputMaybe<Scalars['String']>
  fields?: InputMaybe<Array<CustomFieldInput>>
  flagged?: InputMaybe<Scalars['Boolean']>
  locale?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  newPassword?: InputMaybe<Scalars['String']>
  profilePictureId?: InputMaybe<Scalars['String']>
  roleId?: InputMaybe<Scalars['ID']>
  settings?: InputMaybe<MemberSettingsInput>
  tagline?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['DateTime']>
  username?: InputMaybe<Scalars['String']>
}

export type UpdateMemberInvitationInput = {
  roleId: Scalars['ID']
}

export type UpdateMemberNetworkNotificationSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>
  memberId?: InputMaybe<Scalars['ID']>
  mention?: InputMaybe<Scalars['Boolean']>
  message?: InputMaybe<Scalars['Boolean']>
  /** Required if channel is DESKTOP */
  options?: InputMaybe<UpdateMemberNetworkNotificationSettingsOptionsInput>
  reaction?: InputMaybe<Scalars['Boolean']>
  sameAsDefault?: InputMaybe<Scalars['Boolean']>
}

export type UpdateMemberNetworkNotificationSettingsOptionsInput = {
  /** Required if channel is DESKTOP */
  fcmDeviceToken?: InputMaybe<Scalars['String']>
}

export type UpdateMemberPostNotificationSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>
  memberId?: InputMaybe<Scalars['ID']>
}

export type UpdateMemberPrivateMessagingSettingsInput = {
  privateMessagingEnabled?: InputMaybe<Scalars['Boolean']>
}

export type UpdateMemberSpaceNotificationSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>
  memberId?: InputMaybe<Scalars['ID']>
  preference?: InputMaybe<SpaceNotificationPreference>
  sameAsDefault?: InputMaybe<Scalars['Boolean']>
}

export type UpdateModerationItemInput = {
  changeStatusReason?: InputMaybe<Scalars['String']>
  sendNotification?: InputMaybe<Scalars['Boolean']>
  status: ModerationStatus
}

export type UpdateModerationSettingsInput = {
  akismet?: InputMaybe<Scalars['Boolean']>
  blackListPostTypeIds?: InputMaybe<Array<Scalars['String']>>
  blackListSpaceIds?: InputMaybe<Array<Scalars['String']>>
  customBlacklist?: InputMaybe<Array<Scalars['String']>>
  enableBlacklisting?: InputMaybe<Scalars['Boolean']>
  member?: InputMaybe<ModerationMemberSettingsInput>
  oopSpam?: InputMaybe<Scalars['Boolean']>
  preventPublish?: InputMaybe<Scalars['Boolean']>
  useDefaultBlacklisting?: InputMaybe<Scalars['Boolean']>
}

export type UpdateNavigationItem = {
  link?: InputMaybe<Scalars['String']>
  openInNewWindow?: InputMaybe<Scalars['Boolean']>
  text: Scalars['String']
  type: NavigationItemType
}

export type UpdateNetworkInput = {
  aliases?: InputMaybe<Array<Scalars['String']>>
  billingEmail?: InputMaybe<Scalars['String']>
  brandColor?: InputMaybe<Scalars['String']>
  companyName?: InputMaybe<Scalars['String']>
  customSeoDetail?: InputMaybe<CustomSeoDetailInput>
  defaultSpaceIds?: InputMaybe<Array<Scalars['ID']>>
  description?: InputMaybe<Scalars['String']>
  domain?: InputMaybe<Scalars['String']>
  entrancePage?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['String']>
  footer?: InputMaybe<UpdateFooter>
  hideDefaultAuthenticationForm?: InputMaybe<Scalars['Boolean']>
  imageIds?: InputMaybe<NetworkImagesInput>
  incidentEmails?: InputMaybe<Array<Scalars['String']>>
  industry?: InputMaybe<NetworkIndustryType>
  landingPages?: InputMaybe<UpdateNetworkSettingsInput>
  locale?: InputMaybe<Scalars['String']>
  logoId?: InputMaybe<Scalars['String']>
  membership?: InputMaybe<NetworkMembership>
  name?: InputMaybe<Scalars['String']>
  navigationSlates?: InputMaybe<NavigationSlateUpdatesInput>
  newDomain?: InputMaybe<Scalars['String']>
  passwordComplexity?: InputMaybe<NetworkPasswordComplexity>
  primaryMembers?: InputMaybe<NetworkPrimaryMembersType>
  privacyPolicyUrl?: InputMaybe<Scalars['String']>
  referrer?: InputMaybe<Scalars['String']>
  releaseChannel?: InputMaybe<NetworkReleaseChannelType>
  settings?: InputMaybe<NetworkSettingsInput>
  termsOfServiceUrl?: InputMaybe<Scalars['String']>
  themes?: InputMaybe<UpdateThemes>
  timeframe?: InputMaybe<NetworkTimeframeType>
  topNavigation?: InputMaybe<UpdateTopNavigation>
  tribeBranding?: InputMaybe<Scalars['Boolean']>
  utmCampaign?: InputMaybe<Scalars['String']>
  utmContent?: InputMaybe<Scalars['String']>
  utmMedium?: InputMaybe<Scalars['String']>
  utmSource?: InputMaybe<Scalars['String']>
  utmTerm?: InputMaybe<Scalars['String']>
  visibility?: InputMaybe<NetworkVisibility>
  whoCanInviteIds?: InputMaybe<Array<Scalars['String']>>
}

export type UpdateNetworkSettingsInput = {
  landingPageForGuest?: InputMaybe<NetworkLandingPage>
  landingPageForMember?: InputMaybe<NetworkLandingPage>
  landingPageForNewMember?: InputMaybe<NetworkLandingPage>
}

export type UpdateNetworkStatusInput = {
  status: NetworkStatus
  statusLocked?: InputMaybe<Scalars['Boolean']>
}

export type UpdateNewDomainInput = {
  domain: Scalars['String']
}

export type UpdateNotificationNetworkSettingsInput = {
  emailEnabled?: InputMaybe<Scalars['Boolean']>
  emailFrom?: InputMaybe<Scalars['String']>
  emailNotificationEnabled?: InputMaybe<Scalars['Boolean']>
}

export type UpdatePasswordWithTokenInput = {
  newPassword: Scalars['String']
  token: Scalars['String']
}

export type UpdatePermissionInput = {
  description?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  scopes?: InputMaybe<Array<Scalars['String']>>
}

export type UpdatePostInput = {
  attachmentIds?: InputMaybe<Array<Scalars['String']>>
  createdAt?: InputMaybe<Scalars['DateTime']>
  /** The custom seo detail of this post */
  customSeoDetail?: InputMaybe<CustomSeoDetailInput>
  /** Whether the post is locked */
  locked?: InputMaybe<Scalars['Boolean']>
  mappingFields?: InputMaybe<Array<PostMappingFieldInput>>
  ownerId?: InputMaybe<Scalars['ID']>
  publish?: Scalars['Boolean']
  publishedAt?: InputMaybe<Scalars['DateTime']>
  seoDetail?: InputMaybe<UpdatePostSeoDetailInput>
  /** The slug of the post creating the human readable part of its URL */
  slug?: InputMaybe<Scalars['String']>
  tagNames?: InputMaybe<Array<Scalars['String']>>
  updatedAt?: InputMaybe<Scalars['DateTime']>
}

export type UpdatePostSeoDetailInput = {
  description?: InputMaybe<Scalars['String']>
  image?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type UpdatePostTypeInput = {
  allowedReactions?: InputMaybe<Array<Scalars['String']>>
  customReactions?: InputMaybe<Array<CustomReactionInput>>
  description?: InputMaybe<Scalars['String']>
  excludedNativeShortcuts?: InputMaybe<Array<Scalars['String']>>
  forbiddenReactions?: InputMaybe<Array<Scalars['String']>>
  iconId?: InputMaybe<Scalars['ID']>
  languageTemplate?: InputMaybe<Scalars['String']>
  layout?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  nativeFieldsTemplates?: InputMaybe<NativeFieldsTemplatesInput>
  pluralName?: InputMaybe<Scalars['String']>
  postFields?: InputMaybe<CustomFieldsSchemaInput>
  primaryReactionType?: InputMaybe<ReactionType>
  recommendationsSettings?: InputMaybe<PostTypeRecommendationSettingsInput>
  selfRepliable?: InputMaybe<Scalars['Boolean']>
  shortContentTemplate?: InputMaybe<Scalars['String']>
  singleChoiceReactions?: InputMaybe<Array<Scalars['String']>>
  slate?: InputMaybe<SlateUpdatesInput>
  titleTemplate?: InputMaybe<Scalars['String']>
  validReplyTypesIds?: InputMaybe<Array<Scalars['String']>>
}

export type UpdatePrivateMessagingSettingsInput = {
  membersCanTurnOffPrivateMessaging?: InputMaybe<Scalars['Boolean']>
  membersCanUsePrivateMessaging?: InputMaybe<Scalars['Boolean']>
  privateMessagingEnabled?: InputMaybe<Scalars['Boolean']>
}

export type UpdateSpaceDefaultNotificationSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>
  preference?: InputMaybe<SpaceNotificationPreference>
  sameAsDefault?: InputMaybe<Scalars['Boolean']>
}

export type UpdateSpaceInput = {
  address?: InputMaybe<SpaceAddressInput>
  bannerId?: InputMaybe<Scalars['String']>
  collectionId?: InputMaybe<Scalars['ID']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  customSeoDetail?: InputMaybe<CustomSeoDetailInput>
  description?: InputMaybe<Scalars['String']>
  hidden?: InputMaybe<Scalars['Boolean']>
  imageId?: InputMaybe<Scalars['String']>
  inviteOnly?: InputMaybe<Scalars['Boolean']>
  layout?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  nonAdminsCanInvite?: InputMaybe<Scalars['Boolean']>
  private?: InputMaybe<Scalars['Boolean']>
  seoDetail?: InputMaybe<UpdateSpaceSeoDetailInput>
  slate?: InputMaybe<SlateUpdatesInput>
  slug?: InputMaybe<Scalars['String']>
  type?: InputMaybe<SpaceType>
  updatedAt?: InputMaybe<Scalars['DateTime']>
  whoCanPost?: InputMaybe<Array<Scalars['ID']>>
  whoCanReact?: InputMaybe<Array<Scalars['ID']>>
  whoCanReply?: InputMaybe<Array<Scalars['ID']>>
  withRoles?: InputMaybe<Scalars['Boolean']>
}

export type UpdateSpaceMemberRoleInput = {
  roleId: Scalars['String']
}

export type UpdateSpacePostTypeInput = {
  postTypeId: Scalars['ID']
  whoCanPost?: InputMaybe<Array<Scalars['ID']>>
  whoCanReact?: InputMaybe<Array<Scalars['ID']>>
  whoCanReply?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateSpaceSeoDetailInput = {
  description?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type UpdateTagInput = {
  description?: InputMaybe<Scalars['String']>
  slug?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type UpdateTemplateInput = {
  about?: InputMaybe<Scalars['String']>
  appIds?: InputMaybe<Array<Scalars['String']>>
  authorName?: InputMaybe<Scalars['String']>
  authorUrl?: InputMaybe<Scalars['String']>
  bannerId?: InputMaybe<Scalars['String']>
  categories?: InputMaybe<Array<Scalars['String']>>
  comingSoon?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  entityProperties?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['String']>
  hubContentId?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  previewHtml?: InputMaybe<Scalars['String']>
  privacyPolicyUrl?: InputMaybe<Scalars['String']>
  requiredPlan?: InputMaybe<PlanName>
  slate?: InputMaybe<SlateUpdatesInput>
  slug?: InputMaybe<Scalars['String']>
  termsOfServiceUrl?: InputMaybe<Scalars['String']>
}

export type UpdateTheme = {
  name: Scalars['String']
  status: ThemeStatus
  tokens: UpdateThemeTokens
}

export type UpdateThemeColor = {
  key: Scalars['String']
  weights: Array<UpdateThemeToken>
}

export type UpdateThemeColorToken = {
  key: Scalars['String']
  value: Scalars['String']
}

export type UpdateThemeColorTokens = {
  dark?: InputMaybe<Array<UpdateThemeColorToken>>
  light?: InputMaybe<Array<UpdateThemeColorToken>>
}

export type UpdateThemeColors = {
  dark?: InputMaybe<Array<UpdateThemeColor>>
  light?: InputMaybe<Array<UpdateThemeColor>>
}

export type UpdateThemeToken = {
  key: Scalars['String']
  value: Scalars['String']
}

export type UpdateThemeTokens = {
  breakpoints?: InputMaybe<Array<UpdateThemeToken>>
  colors?: InputMaybe<Array<UpdateThemeToken>>
  fontSizes?: InputMaybe<Array<UpdateThemeToken>>
  fontWeights?: InputMaybe<Array<UpdateThemeToken>>
  opacity?: InputMaybe<Array<UpdateThemeToken>>
  shadows?: InputMaybe<Array<UpdateThemeToken>>
  sizes?: InputMaybe<Array<UpdateThemeToken>>
  textStyles?: InputMaybe<Array<UpdateThemeToken>>
  zIndices?: InputMaybe<Array<UpdateThemeToken>>
}

export type UpdateThemes = {
  active: UpdateTheme
  drafts: Array<UpdateTheme>
  published: Array<UpdateTheme>
}

export type UpdateTopNavigation = {
  alignment: TopNavigationAlignment
  enabled: Scalars['Boolean']
  items: Array<UpdateNavigationItem>
}

export type UploadedMigrations = {
  migrationId: Scalars['String']
  results: Array<MigrationFileResult>
}

export type UpsertExtraPropertyInput = {
  entityId?: InputMaybe<Scalars['String']>
  entityType: ExtraPropertyEntityType
  key: Scalars['String']
  value: Scalars['String']
}

export type UpsertPageCustomResponse = {
  body?: InputMaybe<Scalars['String']>
  headers?: InputMaybe<Array<PageCustomResponseHeaderInput>>
  httpCode: Scalars['Int']
}

export type UpsertTheme = {
  active?: InputMaybe<Scalars['Boolean']>
  colorTokens?: InputMaybe<UpdateThemeColorTokens>
  colors?: InputMaybe<UpdateThemeColors>
  id: Scalars['String']
  name?: InputMaybe<Scalars['String']>
  typography?: InputMaybe<Array<UpdateThemeToken>>
}

export type UsernameAvailability = {
  available: Scalars['Boolean']
}

export type ValuePermissions = {
  isAuthorized: IsAuthorized
  value: Scalars['String']
}

export type Vat = {
  text: Scalars['String']
  vatId: Scalars['String']
  vatType: VatType
}

export type VatInput = {
  vatId: Scalars['String']
  vatType: VatType
}

export enum VatType {
  ae_trn = 'ae_trn',
  au_abn = 'au_abn',
  au_arn = 'au_arn',
  br_cnpj = 'br_cnpj',
  br_cpf = 'br_cpf',
  ca_bn = 'ca_bn',
  ca_gst_hst = 'ca_gst_hst',
  ca_pst_bc = 'ca_pst_bc',
  ca_pst_mb = 'ca_pst_mb',
  ca_pst_sk = 'ca_pst_sk',
  ca_qst = 'ca_qst',
  ch_vat = 'ch_vat',
  cl_tin = 'cl_tin',
  es_cif = 'es_cif',
  eu_vat = 'eu_vat',
  gb_vat = 'gb_vat',
  hk_br = 'hk_br',
  id_npwp = 'id_npwp',
  il_vat = 'il_vat',
  in_gst = 'in_gst',
  jp_cn = 'jp_cn',
  jp_rn = 'jp_rn',
  kr_brn = 'kr_brn',
  li_uid = 'li_uid',
  mx_rfc = 'mx_rfc',
  my_frp = 'my_frp',
  my_itn = 'my_itn',
  my_sst = 'my_sst',
  no_vat = 'no_vat',
  nz_gst = 'nz_gst',
  ru_inn = 'ru_inn',
  ru_kpp = 'ru_kpp',
  sa_vat = 'sa_vat',
  sg_gst = 'sg_gst',
  sg_uen = 'sg_uen',
  th_vat = 'th_vat',
  tw_vat = 'tw_vat',
  us_ein = 'us_ein',
  za_vat = 'za_vat',
}

export type VatTypeInfo = {
  key: VatType
  placeholder: Scalars['String']
  text: Scalars['String']
  value: VatType
}

export type VerifyMemberInput = {
  memberId: Scalars['String']
  verificationCode?: InputMaybe<Scalars['String']>
}

export type SubscriptionInput = {
  id: Scalars['String']
}

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    By: ['Member'],
    In: ['Space'],
    Media: ['Emoji', 'File', 'Glyph', 'Image'],
    ModerationItemEntity: ['Member', 'Post'],
    PageEntity: ['Collection', 'Member', 'Post'],
    PostLastActivityEntity: ['Post', 'PostReactionParticipant'],
    ReportDataValue: ['ChartData', 'EntityReport', 'IntValue', 'StringValue'],
    ReportableEntity: ['Member', 'Post', 'Space', 'Tag'],
    SearchObjectEntity: ['Member', 'Post', 'Space'],
    TemplateCreatedEntity: ['Space'],
    TemplateEntity: [
      'Network',
      'Post',
      'PostType',
      'Space',
      'SpacePostType',
      'Tag',
    ],
  },
}
export default result
